<div class="row ss-top-menu">
  <div class="col-sm-12">
    <span class="ss-link " style="vertical-align: text-bottom;" (click)="backToDashboard()">Dashboard</span>
    <span> <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link " style="vertical-align: text-bottom;" (click)="backClicked();">Wip</span>
    <span> <i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link " style="vertical-align: text-bottom;" (click)="backClicked();">Lead</span>
    <span> <i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link capitalize " style="vertical-align: text-bottom;" (click)="backClicked();"
      *ngIf="lead_details">{{lead_details.name}} - {{lead_details.project_details.name}}</span>
    <span><i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link " (click)="backClicked();" style="vertical-align: text-bottom;">BOQs</span>
    <span> <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: text-bottom;">Create</span>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="mb-3 mt-3 col-6 text-left" *ngIf="quotationDetails" style="display: inline-block;">Total Amount - &#8377;
  {{getBoqTotalAmt()}}</div>
<button class="rk-interalBtnColor pull-right mb-3 mt-3 addCursor" data-toggle="modal" data-target="#addsectionmodal"
  *ngIf="(selectedSections && selectedSections.length<=5 && boq_type == 'non_service') || (selectedSections && selectedSections.length <=2 && boq_type == 'service')">Add Section</button>
<button class="rk-interalBtnColor pull-right mb-3 mt-3 addCursor mx-2" data-toggle="modal"
  data-target="#deletesectionmodal" *ngIf="selectedSections && selectedSections.length>0">Delete Section</button>

<div id="navcontainer" style="width:100%">
  <ul class="nav nav-tabs tabs-chng" id="myTab" role="tablist" *ngIf="selectedSections">
    <li class="nav-item nav-items" *ngFor="let sec of selectedSections">
      <a class="nav-link addCursor text-center mr-3" [ngClass]="{'active': selectedsectionName == sec}"
        (click)="changeSectionTab(sec)">{{sec | replaceChar | uppercase}}</a>
    </li>
  </ul>
</div>

<div class="container-fluid container-set mb-3"
  [ngClass]="(selectedSections && selectedSections.length>0)?'d-block':'d-none'">
  <div class="row rowContainer" style="padding: 16px" id="globalVarRowForMK">
    <!-- {{globalVarArr | json}}<br/>  <span>hello - {{boqConfigMKVal}}</span> -->
    <div class="col-md-12 borderbottom pt-3 pb-3 addCursor" id="selectedGlobalVarLink" data-toggle="modal"
      data-target="#selectedGlobalVarModalMK" style="color: #8c031f;" *ngIf="globalVarArr && boqConfigMKVal!=undefined"
      (click)="getBoqConfig('kitchen')">Selected Global Variable</div>

    <!-- <div class="col-md-12 borderbottom pt-3 pb-3"  *ngIf="globalVarArr && boqConfigMKVal!=undefined && quotationDetails && quotationDetails.countertop_cost!=0 && quotationDetails.countertop_cost!=null">
                    <span class="addCursor" style="color: #8c031f;">Countertop -</span> <span class="capitalize" style="font-size: 14px;">{{quotationDetails.countertop_details.countertop | replaceChar}} - &#8377; {{quotationDetails.countertop_details.price}}</span>
                    <span class="addCursor ml-4" style="color: #8c031f;" *ngIf="quotationDetails.countertop_details.countertop_width">Countertop Length -</span> <span style="font-size: 14px;" *ngIf="quotationDetails.countertop_details.countertop_width">{{quotationDetails.countertop_details.countertop_width}} mm</span>
                    <button style="padding: 2px 6px;" (click)="showCountertopLengthForm()" class="rk-interalBtnColor addCursor ml-3" id="countertopLenChangeBtn">Change Length</button>
                    <form class="d-none mt-4" id="countertopLengthForm">
                        <h6>Change Counter Top Length</h6>
                        <input type="number" name="countertoplength" [(ngModel)]="countertop_width_globalVar_MK" placeholder="Enter Length" class="form-control d-inline" style="width: 25%" min="0">
                        <button class="cartBtn" (click)="changeCountertopLenSubmit(countertop_width_globalVar_MK)" [disabled]="countertop_width_globalVar_MK==undefined || countertop_width_globalVar_MK==''">Change</button>
                        <button class="rk-btnCancel" (click)="hideCountertopLengthForm()">Cancel</button>
                    </form>
                </div> -->

    <div class="col-md-12 my-3 text-center" *ngIf="globalVarArr && boqConfigMKVal==undefined ">
      <button (click)="getGlobalPresets('kitchen',1)" data-target="#listPresetModal" data-toggle="modal"
        class="rk-interalBtnColor addCursor">Choose Global Preset</button>
      <span class="mr-3 ml-3">OR</span>
      <button class="rk-interalBtnColor addCursor" data-target="#setGlobalConfigModal" data-toggle="modal">Create Global
        Variables</button>
    </div>
    <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="globalVarArr && boqConfigMKVal!=undefined ">
      <div class="row">
        <div class="col-md-3"><span>Enter Space</span></div>
        <div class="col-md-6">
          <form [formGroup]="addSpaceMWForm">
            <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
              <option value="">Select</option>
              <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
            </select>
            <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'kitchen')">
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3"
      *ngIf="globalVarArr && boqConfigMKVal!=undefined && selectedSpacesArrMK && selectedSpacesArrMK.length>0">
      <div id="accordionMk">
        <div class="card mb-2" *ngFor="let selSpaceMk of selectedSpacesArrMK; let k1=index; ">
          <div class="card-header" id="spaceCardMk{{k1}}">
            <h5 class="mb-0">
              <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse"
                [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapsetwo">
                {{selSpaceMk}}
              </button>
              <ng-container *ngFor="let key2 of Object.keys(quotationDetails.space_amounts_kitchen); let n1 =index; ">
                <span *ngIf="key2==selSpaceMk" style="font-size: 14px;" class="pull-right">Total - &#8377;
                  {{quotationDetails.space_amounts_kitchen[key2]}}</span></ng-container>
            </h5>

            <div class="pull-right col-md-12 text-right">
              <a href = "#" [routerLink]="['/browse-preset']" routerLinkActive="active" target = "_blank">
                <button class="addCursor">Browse Preset</button>
              </a>
              <button (click)="openImportLayoutModal('kitchen',selSpaceMk)" class="addCursor">Import Layout</button>
              <ng-container *ngIf="(Object.keys(quotationDetails.modular_jobs_kitchen).length>0 && 
                                    Object.keys(quotationDetails.modular_jobs_kitchen).includes(selSpaceMk) && 
                                    quotationDetails.modular_jobs_kitchen[selSpaceMk].length>0) || (Object.keys(quotationDetails.appliance_jobs).length>0 && 
                                    Object.keys(quotationDetails.appliance_jobs).includes(selSpaceMk) && 
                                    quotationDetails.appliance_jobs[selSpaceMk].length>0) || Object.keys(quotationDetails.extra_jobs_kitchen).length>0 && 
                                    Object.keys(quotationDetails.extra_jobs_kitchen).includes(selSpaceMk) && 
                                    quotationDetails.extra_jobs_kitchen[selSpaceMk].length>0">
                <button data-target="#saveMkwLayoutModal" data-toggle="modal"
                  (click)="openMkwlayout(selSpaceMk,'kitchen')" class="addCursor">Save As Layout</button>
              </ng-container>
              <button [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapsetwo"
                (click)="displayAddModuleForm(k1,'kitchen')" class="addCursor">Add Module</button>
              <button [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapsetwo"
                (click)="displayAddApplianceForm(k1,'kitchen')" class="addCursor">Add Appliance</button>
              <button [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapsetwo"
                (click)="getKitchenExtras('kitchen');setSpaceForExtra(selSpaceMk,'kitchen')" class="addCursor"><span
                  data-toggle="modal" data-target="#addExtrasModal">Add Extra</span></button>

              <button (click)="spaceDelete(selSpaceMk,'kitchen')" class="addCursor">Delete Space</button>
            </div>
            <div class="pull-right col-md-12 text-right mt-2">
              <label class="text-left mr-2">Upload KDMax Excel</label>
              <input type="file" class="form-control" (change)="onChange($event)" name="attachment_file" ngModel
                #attachment_file="ngModel" style="display:inline-block;width: 30%;">
              <button (click)="uploadKdMaxExcel(selSpaceMk,'kitchen',k1)" [disabled]="basefile==undefined"
                class="cartBtn">Upload</button>
              <div class="col-md-12 d-none mt-2 text-left" id="kdmax_errorblock{{k1}}">
                <div class="alert alert-danger">
                  <a class="close rk-linknotification mr-3 mt-1" (click)="closeKdmax_errorblock(k1)">×</a>
                  <ng-container *ngFor=" let err of this.quotationDetails.errors">
                    <span><strong>Code - </strong> {{err.code}}</span><br>
                    <span><strong>Message - </strong> {{err.message}}</span><br>
                    <p style=" padding-top: 10px;border-bottom: 1px solid #f5c6cb;"></p>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div id="collapseSpaceCardMk{{k1}}" class="collapse" [attr.aria-labelledby]="'spaceCardMk'+k1"
            data-parent="#accordionMk">
            <div class="card-body">
              <div id="addModuleFormRowMk{{k1}}" class="d-none">
                <h5 class="">Add Module</h5>
                <form [formGroup]="addModuleFormMk">
                  <div class="row">
                    <div class="col-md-3">
                      <ng-select formControlName="kitchen_category" (change)="getModuletypeOfKitchenCat($event)">
                        <ng-option value="">Choose Kitchen Category</ng-option>
                        <ng-option *ngFor="let kc of kitchenCatArr" value="{{kc | json}}">{{kc.name}}</ng-option>
                      </ng-select>
                    </div>
                    <div class="col-md-3">
                      <ng-select formControlName="module_type" (change)="getModuleOfModuleType($event)">
                        <ng-option value="">Choose Type</ng-option>
                        <ng-option *ngFor="let mt of moduletypesArr" value="{{mt | json}}">{{mt.name}}</ng-option>
                      </ng-select>
                    </div>
                    <div class="col-md-3">
                      <a (click)="openModuleModal(modulesArr,'kitchen')" class="addCursor" style="color: blue;">Choose
                        Module</a>
                      <span class="ml-2 rk-form-fontsize">{{addModuleFormMk.controls['module_code'].value}}</span>
                    </div>
                    <div class="col-md-3">
                      <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity"
                        formControlName="qty" min="0">
                    </div>
                    <ng-container
                      *ngIf="customizable_dim_data_for_module_mk && customizable_dim_data_for_module_mk.dimensions=='WDH'">
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize"
                          placeholder="Enter Width in mm" formControlName="width" min="0" readonly>
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize"
                          placeholder="Enter Depth in mm" formControlName="depth" min="0" readonly>
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize"
                          placeholder="Enter Height in mm" formControlName="height" min="0" readonly>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="customizable_dim_data_for_module_mk && customizable_dim_data_for_module_mk.dimensions=='LBT'">
                      <div class="col-md-3 mt-2">
                        <ng-select formControlName="thickness">
                          <ng-option value="" disabled>Select Thickness</ng-option>
                          <ng-option *ngFor="let val of customizable_dim_data_for_module_mk.allowed_T" value="{{val}}">
                            {{val}}</ng-option>
                        </ng-select>
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize"
                          placeholder="Enter Length in mm" formControlName="length" min="0">
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize"
                          placeholder="Enter Breadth in mm" formControlName="breadth" min="0">
                      </div>
                    </ng-container>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-12 text-right">
                      <button [disabled]="!addModuleFormMk.valid"
                        (click)="addModule(addModuleFormMk.value,selSpaceMk,'kitchen',k1)"
                        class="rk-interalBtnColor addCursor"
                        [ngClass]="{'cursor-notallowed':!addModuleFormMk.valid}">ADD</button>
                    </div>
                  </div>
                </form>
              </div>
              <div id="addApplianceFormRowMk{{k1}}" class="d-none">
                <h5 class="">Add Appliance</h5>
                <form [formGroup]="addApplianceFormMk">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="text-danger">*</span>
                      <select class="form-control w-75 d-inline-block width-90" (change)="openKitchenApplianceModal()"
                        formControlName="module_type_id">
                        <option value="">Choose Appliance Type</option>
                        <option *ngFor="let kat of kitchenApplianceTypesArr" value="{{kat.id}}">{{kat.name}}</option>
                      </select>
                      <span class="text-danger ml-3"
                        *ngIf="errorAlertModuleTypeId && addApplianceFormMk.controls['module_type_id'].errors">Appliance
                        Type is required</span>
                    </div>
                    <div class="col-md-2">
                      <a class="addCursor p-2" href="#" data-toggle="modal" data-target="#addApplianceModal"
                        (click)="openKitchenApplianceModal()">Choose Appliance</a>
                    </div>
                    <div class="col-md-4" *ngIf="selected_kitchen_appliance">
                      <span class="text-danger">*</span>
                      <input type="number" name="" class="form-control rk-form-fontsize d-inline-block width-90"
                        placeholder="Enter Quantity" formControlName="qty" min="0">
                      <span class="text-danger ml-3"
                        *ngIf="errorAlertQty && addApplianceFormMk.controls['qty'].errors">Quantity is required</span>
                    </div>
                    <div class="col-md-2">
                      <button (click)="addAppliance(addApplianceFormMk.value,selSpaceMk,'kitchen',k1)"
                        class="rk-interalBtnColor addCursor">ADD</button>
                    </div>
                  </div>
                  <div class="m-2 ml-3 p-2 row bg-light" *ngIf="selected_kitchen_appliance">
                    <div class="col-md-4 ml-0 pl-0">
                      {{selected_kitchen_appliance.module_type}}
                    </div>
                    <div class="col-md-4">
                      {{selected_kitchen_appliance.code}}
                    </div>
                    <div class="col-md-4">
                      <img src="{{selected_kitchen_appliance.appliance_image}}"
                        class="my-1 aspect-ratio-appliance-img-add" height="60px" width="100px"
                        *ngIf="selected_kitchen_appliance.appliance_image"
                        onerror="this.src='./assets/img/no_image.svg'" />
                    </div>
                  </div>
                </form>
              </div><br>
              <div id="addExtraFormRowMk{{k1}}" class="d-none">
                <h5 class="">Add Extra</h5>
                <form [formGroup]="addExtraFormMk">
                  <div class="row">
                    <div class="col-md-3">
                      <select class="form-control" formControlName="id">
                        <option value="">Choose Extra</option>
                        <option *ngFor="let ext of kitchenExtras" value="{{ext.id}}">{{ext.name}}</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity"
                        formControlName="qty" min="0">
                    </div>
                    <div class="col-md-2">
                      <button [disabled]="!addExtraFormMk.valid" (click)="addExtra(addExtraFormMk.value,selSpaceMk,k1)"
                        class="rk-interalBtnColor">ADD</button>
                    </div>
                  </div>
                </form>
              </div><br>
              <p style="padding-bottom:0%" *ngIf="Object.keys(quotationDetails.modular_jobs_kitchen).length>0">Added
                Modules :</p>
              <ng-container *ngFor="let key of Object.keys(quotationDetails.modular_jobs_kitchen); let m1 =index; ">
                <div *ngIf="key==selSpaceMk" class="tableDiv mt-3">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th class="firstTh">#</th>
                        <th>Kitchen Category</th>
                        <th>Type</th>
                        <th>Module</th>
                        <th>Label</th>
                        <th class="text-center">Image</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Dimensions(mm)</th>
                        <!-- <th>Width</th> -->
                        <th></th>
                        <th>Delivery Timeline</th>
                        <!-- <th>Max Time taken for</th> -->
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let mod of quotationDetails.modular_jobs_kitchen[key]; let k=index; ">
                        <td>{{k+1}}</td>
                        <td>{{mod.kitchen_category_name}}</td>
                        <td>{{mod.module_type}}</td>
                        <td>{{mod.code}}</td>
                        <td style="text-align:center">
                          <ng-container *ngFor="let label of mod.labels.slice(0,3)"> {{label.label_name}}<br />
                          </ng-container><span data-toggle="modal" data-target="#labelList"
                            (click)="this.transferLabelList(key,mod.labels,k,mod.id,'ModularJob',false,0,'')"><i
                              data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                              style="font-size:1rem;color:#8c0420"></i></span>
                        </td>
                        <td>
                          <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;"
                            onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                            (click)="zoomImg($event.target)" class="addCursor">
                        </td>
                        <td class="text-center">
                          <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                          <input type="number" name=""
                            class="form-control d-none moduleLineItemInput{{k}} rk-form-fontsize"
                            [(ngModel)]="editModuleLineQty">
                        </td>
                        <td>{{mod.amount}}</td>
                        <td class="minWidthForTd">
                          <span class="moduleLineItemSpan{{k}}">
                            {{mod.dimensions}}
                          </span>
                          <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">
                            <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                              <span class="input-group-addon rk-form-fontsize">Width</span>
                              <input type="number" name="" class="form-control rk-form-fontsize"
                                [(ngModel)]="editModuleLineWidth" readonly>
                            </div>
                            <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                              <span class="input-group-addon rk-form-fontsize">Depth</span>
                              <input type="number" name="" class="form-control rk-form-fontsize"
                                [(ngModel)]="editModuleLineDepth" readonly>
                            </div>
                            <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                              <span class="input-group-addon rk-form-fontsize">Height</span>
                              <input type="number" name="" class="form-control rk-form-fontsize"
                                [(ngModel)]="editModuleLineHeight" readonly>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">
                            <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                              <span class="input-group-addon rk-form-fontsize">Length</span>
                              <input type="number" name="" class="form-control  rk-form-fontsize"
                                [(ngModel)]="editModuleLineLength">
                            </div>
                            <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                              <span class="input-group-addon rk-form-fontsize">Breadth</span>
                              <input type="number" name="" class="form-control  rk-form-fontsize"
                                [(ngModel)]="editModuleLineBreadth">
                            </div>
                            <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                              <ng-select [(ngModel)]="editModuleLineThickness" class="rk-form-fontsize"
                                style="width: 100%">
                                <ng-option value="" disabled>Select Thickness</ng-option>
                                <ng-option *ngFor="let val of mod.customizable_dimensions.allowed_T" [value]="val">
                                  {{val}}</ng-option>
                              </ng-select>

                            </div>
                          </ng-container>
                        </td>
                        <td>
                          <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfModule(mod.id)"
                            data-toggle="modal" data-target="#customizationModalMk">
                        </td>
                        <td>
                          <ng-container *ngIf="mod.timeline['lead_time']">
                            {{mod.timeline["lead_time"]}}&nbsp;days
                          </ng-container>
                        </td>
                        <!-- <td>{{mod.timeline["type"]}}</td> -->
                        <td>
                          <button
                            class="d-none moduleLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1"
                            (click)="updateQuantity(k,mod,'kitchen')">Update</button>
                          <button class="d-none moduleLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                            (click)="cancelModuleLineItem(k,mod)">Cancel</button>
                          <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}"
                            data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                            aria-expanded="false"></i>
                          <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                            <a class="dropdown-item addCursor" (click)="editmoduleLineItem(k,mod)">Edit</a>
                            <a class="dropdown-item addCursor"
                              (click)="moduleDelete(mod.id,mod.space,mod.category)">Delete</a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
              <p style="padding-bottom:0" *ngIf="Object.keys(quotationDetails.appliance_jobs).length>0">Added Appliances
                :</p>
              <ng-container *ngFor="let key6 of Object.keys(quotationDetails.appliance_jobs); let m6 =index; ">
                <div *ngIf="key6==selSpaceMk" class="tableDiv mt-3">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th class="firstTh">#</th>
                        <th>Appliance Type</th>
                        <th>Appliance</th>
                        <th>Make</th>
                        <th>Label</th>
                        <th>Vendor Sku</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Image</th>
                        <th></th>
                        <th>Delivery Timeline</th>
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let appjob of quotationDetails.appliance_jobs[key6]; let k=index; ">
                        <td>{{k+1}}</td>
                        <td>{{appjob.subcategory}}</td>
                        <td>{{appjob.name}}</td>
                        <td>{{appjob.make}}</td>
                        <td style="text-align:center">
                          <ng-container *ngFor="let label of appjob.labels.slice(0,3)"> {{label.label_name}}<br />
                          </ng-container><span data-toggle="modal" data-target="#labelList"
                            (click)="this.transferLabelList(key6,appjob.labels,k,appjob.id,'ApplianceJob',false,0,'')"><i
                              data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                              style="font-size:1rem;color:#8c0420"></i></span>
                        </td>
                        <td>{{appjob.vendor_sku}}</td>
                        <td>
                          <span class="applianceLineItemSpan{{k}}">{{appjob.quantity}}</span>
                          <input type="number" name="" class="form-control d-none applianceLineItemInput{{k}}"
                            [(ngModel)]="editApplianceLineQty">
                        </td>
                        <td>{{appjob.amount}}</td>
                        <td>
                          <img src="{{appjob.image_url}}" *ngIf="appjob.image_url"
                            class="aspect-ratio-appliance-img-row addCursor"
                            onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                            (click)="zoomImg($event.target)">
                        </td>
                        <td>
                          <ng-container *ngIf="appjob.lead_time">
                            {{appjob.lead_time}}&nbsp;days
                          </ng-container>
                        </td>
                        <td>
                          <button class="d-none applianceLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1"
                            (click)="updateAppliance(k,appjob,'kitchen')">Update</button>
                          <button class="d-none applianceLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                            (click)="cancelApplianceLineItem(k,appjob)">Cancel</button>
                          <i class="ion-android-more-vertical  ss-3-dot-drop applianceLineItemSpan{{k}}"
                            data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                            aria-expanded="false"></i>
                          <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                            <a class="dropdown-item addCursor" (click)="editApplianceLineItem(k,appjob)">Edit</a>
                            <a class="dropdown-item addCursor"
                              (click)="applianceDelete(appjob.id,appjob.space)">Delete</a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
              <p style="padding-bottom:0 !important" *ngIf="Object.keys(quotationDetails.extra_jobs_kitchen).length>0">
                Added Extras :</p>
              <ng-container *ngFor="let key7 of Object.keys(quotationDetails.extra_jobs_kitchen); let m7 =index; ">
                <div *ngIf="key7==selSpaceMk" class="tableDiv mt-3">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th class="firstTh">#</th>
                        <th> Name</th>
                        <th>Vendor Sku</th>
                        <th>Make</th>
                        <th style="text-align:center">Label</th>
                        <th>Specification</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Image</th>
                        <th class="lastTh"></th>

                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let extrajob of quotationDetails.extra_jobs_kitchen[key7]; let k=index; ">
                        <tr>
                          <ng-container *ngIf="!extrajob.included_addons">
                            <td>{{k+1}}</td>
                            <td>{{extrajob.name}}</td>
                            <td>{{extrajob.vendor_sku}}</td>
                            <td>{{extrajob.make}}</td>
                            <td style="text-align:center">
                              <ng-container *ngFor="let label of extrajob.labels.slice(0,3)"> {{label.label_name}}<br />
                              </ng-container><span data-toggle="modal" data-target="#labelList"
                                (click)="this.transferLabelList(key7,extrajob.labels,k,extrajob.id,'ExtraJob',false,0,'')"><i
                                  data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                  style="font-size:1rem;color:#8c0420"></i></span>
                            </td>
                            <td>{{extrajob.specifications}}</td>
                            <td>
                              <span class="extraLineItemSpan{{k}}">{{extrajob.quantity}}</span>
                              <input type="number" name="" class="form-control d-none extraLineItemInput{{k}}"
                                [(ngModel)]="editExtraLineQty">
                            </td>
                            <td>{{extrajob.amount}}</td>
                            <td>
                              <img src="{{extrajob.image_url}}" *ngIf="extrajob.image_url" style="width: 100px;"
                                onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                                (click)="zoomImg($event.target)" class="addCursor">
                            </td>
                            <td>
                              <button class="d-none extraLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1"
                                (click)="updateExtra(k,extrajob,'kitchen',false)">Update</button>
                              <button class="d-none extraLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelExtraLineItem(k,extrajob)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop extraLineItemSpan{{k}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor" (click)="editExtraLineItem(k,extrajob)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="extraDelete(extrajob.id,extrajob.space)">Delete</a>
                              </div>
                            </td>

                          </ng-container>
                          <ng-container *ngIf="extrajob.included_addons">
                            <td>{{k+1}}</td>
                            <td data-toggle="collapse" [attr.data-target]="'.addons-'+k" style="cursor:pointer"><span
                                style="color:#8c0420" data-toggle="tooltip" data-placement="bottom"
                                title="Combination Extra : Please click here to view included extras">{{extrajob.name}}</span>
                            </td>
                            <td></td>
                            <td></td>
                            <td style="text-align:center">
                              <ng-container *ngFor="let label of extrajob.labels.slice(0,3)"> {{label.label_name}}<br />
                              </ng-container><span data-toggle="modal" data-target="#labelList"
                                (click)="this.transferLabelList(key7,extrajob.labels,k,extrajob.id,'ExtraJob',false,0,'')"><i
                                  data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                  style="font-size:1rem;color:#8c0420"></i></span>
                            </td>
                            <td></td>
                            <td>
                              <span class="extraLineItemSpan{{k}}">{{extrajob.quantity}}</span>
                              <input type="number" name="" class="form-control d-none extraLineItemInput{{k}}"
                                [(ngModel)]="editExtraLineQty">
                            </td>
                            <td>{{extrajob.amount}}</td>
                            <td>
                              <img src="{{extrajob.included_addons[0].addon_image}}"
                                *ngIf="extrajob.included_addons.length>0 && extrajob.included_addons[0].addon_image"
                                style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';"
                                alt="Missing Image" (click)="zoomImg($event.target)" class="addCursor">
                            </td>
                            <td>
                              <button class="d-none extraLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1"
                                (click)="updateExtra(k,extrajob,'kitchen',true)">Update</button>
                              <button class="d-none extraLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelExtraLineItem(k,extrajob)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop extraLineItemSpan{{k}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor" (click)="editExtraLineItem(k,extrajob)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="extraDelete(extrajob.id,extrajob.space)">Delete</a>
                              </div>
                            </td>

                          </ng-container>
                        </tr>
                        <ng-container *ngIf="extrajob.included_addons">
                          <tr class="collapse addons-{{k}}"
                            *ngFor="let addon of extrajob.included_addons;let k_addon=index;">
                            <td>{{k_addon+1}}</td>
                            <td>{{addon.name}}</td>
                            <td>{{addon.vendor_sku}}</td>
                            <td>{{addon.make}}</td>
                            <td></td>
                            <td>{{addon.specifications}}</td>
                            <td>
                              <span class="extraLineItemSpan{{k}}">{{addon.quantity}}</span>
                            </td>
                            <td>{{addon.mrp}}</td>
                            <td>
                              <img src="{{addon.addon_image}}" *ngIf="addon.addon_image" style="width: 100px;"
                                onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                                (click)="zoomImg($event.target)" class="addCursor">
                            </td>
                            <td></td>
                          </tr>
                        </ng-container>

                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right"
      *ngIf="globalVarArr && quotationDetails && (boqConfigMWVal!=undefined && selectedSpacesArr && selectedSpacesArr.length>0  && quotationDetails && Object.keys(quotationDetails.modular_jobs_wardrobe).length>0) || (boqConfigMKVal!=undefined && selectedSpacesArrMK && selectedSpacesArrMK.length>0 && (Object.keys(quotationDetails.modular_jobs_kitchen).length>0) || (quotationDetails && Object.keys(quotationDetails.appliance_jobs) && Object.keys(quotationDetails.appliance_jobs).length>0) || (quotationDetails && Object.keys(quotationDetails.extra_jobs_kitchen) && Object.keys(quotationDetails.extra_jobs_kitchen).length>0))">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>


  <!--Wardrobe Container-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForMW">
    <!-- {{globalVarArr | json}}  {{boqConfigMWVal}} -->
    <div class="col-md-12 borderbottom pt-3 pb-3 addCursor" id="selectedGlobalVarLink" data-toggle="modal"
      data-target="#selectedGlobalVarModal" style="color: #8c031f;" *ngIf="globalVarArr && boqConfigMWVal!=undefined"
      (click)="getBoqConfig('wardrobe')">Selected Global Variable</div>
    <div class="col-md-12 my-3 text-center" *ngIf="globalVarArr && boqConfigMWVal==undefined ">
      <button (click)="getGlobalPresets('wardrobe',1)" data-target="#listPresetModal" data-toggle="modal"
        class="rk-interalBtnColor addCursor">Choose Global Preset</button>
      <span class="mr-3 ml-3">OR</span>
      <button class="rk-interalBtnColor addCursor" data-target="#setGlobalConfigModal" data-toggle="modal">Create Global
        Variables</button>
    </div>
    <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="globalVarArr && boqConfigMWVal!=undefined ">
      <div class="row">
        <div class="col-md-3"><span>Enter Space</span></div>
        <div class="col-md-6">
          <form [formGroup]="addSpaceMWForm">
            <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
              <option value="">Select</option>
              <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
            </select>
            <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'wardrobe')">
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3"
      *ngIf="globalVarArr && boqConfigMWVal!=undefined && selectedSpacesArr && selectedSpacesArr.length>0">
      <div id="accordion">
        <div class="card mb-2" *ngFor="let selSpace of selectedSpacesArr; let k=index; ">
          <div class="card-header" id="spaceCard{{k}}">
            <h5 class="mb-0">
              <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse"
                [attr.data-target]=" '#collapseSpaceCard'+k" aria-expanded="true" aria-controls="collapseOne">
                {{selSpace}}
              </button>
              <ng-container *ngFor="let key1 of Object.keys(quotationDetails.space_amounts_wardrobe); let n =index; ">
                <span *ngIf="key1==selSpace" style="font-size: 14px;" class="pull-right">Total - &#8377;
                  {{quotationDetails.space_amounts_wardrobe[key1]}}</span></ng-container>
            </h5>

            <div class=" col-md-12 text-right">
              <a href = "#" [routerLink]="['/browse-preset']" routerLinkActive="active" target = "_blank">
                <button class="addCursor">Browse Preset</button>
              </a>
              <button (click)="openImportLayoutModal('wardrobe',selSpace)" class="addCursor">Import Layout</button>
              <ng-container *ngIf="Object.keys(quotationDetails.modular_jobs_wardrobe).length>0 && 
                                    Object.keys(quotationDetails.modular_jobs_wardrobe).includes(selSpace) && 
                                    quotationDetails.modular_jobs_wardrobe[selSpace].length>0">
                <button data-target="#saveMkwLayoutModal" data-toggle="modal"
                  (click)="openMkwlayout(selSpace,'wardrobe')" class="addCursor">Save As Layout</button>
              </ng-container>
              <button [attr.data-target]=" '#collapseSpaceCard'+k" aria-expanded="true" aria-controls="collapseOne"
                (click)="displayAddModuleForm(k,'wardrobe')" class="addCursor">Add Module</button>
              <button (click)="spaceDelete(selSpace,'wardrobe')" class="addCursor">Delete Space</button>
              <!-- Changes here -->
              <button [attr.data-target]=" '#collapseSpaceCard'+k" aria-expanded="true" aria-controls="collapsetwo"
                (click)="getKitchenExtras('wardrobe');setSpaceForExtra(selSpace,'wardrobe')" class="addCursor"><span
                  data-toggle="modal" data-target="#addExtrasModal">Add Extra</span></button>
              <!-- Changes Completed -->
            </div>
            <div class=" col-md-12 text-right mt-2">
              <label class="text-left mr-2">Upload KDMax Excel</label>
              <input type="file" class="form-control" (change)="onChange($event)" name="attachment_file" ngModel
                #attachment_file="ngModel" style="display:inline-block;width: 30%;">
              <button (click)="uploadKdMaxExcel(selSpace,'wardrobe',k)" [disabled]="basefile==undefined"
                class="cartBtn">Upload</button>
              <div class="col-md-12 d-none mt-2 text-left" id="kdmax_errorblock{{k}}">
                <div class="alert alert-danger">
                  <a class="close rk-linknotification mr-3 mt-1" (click)="closeKdmax_errorblock(k)">×</a>
                  <ng-container *ngFor=" let err of this.quotationDetails.errors">
                    <span><strong>Code - </strong> {{err.code}}</span><br>
                    <span><strong>Message - </strong> {{err.message}}</span><br>
                    <p style=" padding-top: 10px;border-bottom: 1px solid #f5c6cb;"></p>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div id="collapseSpaceCard{{k}}" class="collapse" [attr.aria-labelledby]="'spaceCard'+k"
            data-parent="#accordion">
            <div class="card-body">
              <div id="addModuleFormRow{{k}}" class="d-none">
                <h5 class="">Add Module</h5>
                <form [formGroup]="addModuleForm">
                  <div class="row">
                    <div class="col-md-3">
                      <ng-select formControlName="module_type" (change)="getModuleOfModuleType($event)">
                        <ng-option value="">Choose Type</ng-option>
                        <ng-option *ngFor="let mt of moduletypesArr" value="{{mt | json}}">{{mt.name}}</ng-option>
                      </ng-select>
                    </div>
                    <div class="col-md-3">
                      <a (click)="openModuleModal(modulesArr,'wardrobe')" class="addCursor" style="color: blue;">Choose
                        Module</a>
                      <span class="ml-2 rk-form-fontsize">{{addModuleForm.controls['module_code'].value}}</span>
                    </div>
                    <div class="col-md-3">
                      <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity"
                        formControlName="qty" min="0">
                    </div>
                    <ng-container
                      *ngIf="customizable_dim_data_for_module_mw && customizable_dim_data_for_module_mw.dimensions=='WDH'">
                      <div class="col-md-3">
                        <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Width"
                          formControlName="width" min="0" readonly>
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Depth"
                          formControlName="depth" min="0" readonly>
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Height"
                          formControlName="height" min="0" readonly>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="customizable_dim_data_for_module_mw && customizable_dim_data_for_module_mw.dimensions=='LBT'">
                      <div class="col-md-3">
                        <ng-select formControlName="thickness">
                          <ng-option value="" disabled>Select Thickness</ng-option>
                          <ng-option *ngFor="let val of customizable_dim_data_for_module_mw.allowed_T" value="{{val}}">
                            {{val}}</ng-option>
                        </ng-select>
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Length"
                          formControlName="length" min="0">
                      </div>
                      <div class="col-md-3 mt-2">
                        <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Breadth"
                          formControlName="breadth" min="0">
                      </div>
                    </ng-container>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-12 text-right">
                      <button [disabled]="!addModuleForm.valid"
                        (click)="addModule(addModuleForm.value,selSpace,'wardrobe',k)"
                        class="rk-interalBtnColor addCursor"
                        [ngClass]="{'cursor-notallowed':!addModuleForm.valid}">ADD</button>
                    </div>
                  </div>
                </form>
              </div>
              <ng-container *ngFor="let key of Object.keys(quotationDetails.modular_jobs_wardrobe); let m =index; ">
                <div *ngIf="key==selSpace" class="tableDiv mt-3">
                  <button class="rk-interalBtnColor pull-right"
                    (click)="setCombineModuleData(quotationDetails.modular_jobs_wardrobe[key])"
                    *ngIf="quotationDetails.modular_jobs_wardrobe[key].length>=2" data-toggle="modal"
                    data-target="#combinedmodulesModal">Combine Module</button>
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th class="firstTh">#</th>
                        <th>Type</th>
                        <th>Module</th>
                        <th>Quantity</th>
                        <th>Label</th>
                        <th>Price</th>
                        <th>Dimensions(mm)</th>
                        <th>Image</th>
                        <th></th>
                        <th>Delivery Timeline</th>
                        <!-- <th>Max Time taken for</th>   -->
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let mod of quotationDetails.modular_jobs_wardrobe[key]; let k=index; ">
                        <tr *ngIf="!mod.combined">
                          <td>{{k+1}}</td>
                          <td>{{mod.module_type}}</td>
                          <td>{{mod.code}}</td>
                          <td>
                            <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                            <input type="number" name="" class="form-control d-none moduleLineItemInput{{k}}"
                              [(ngModel)]="editModuleLineQty">
                          </td>
                          <td style="text-align:center">
                            <ng-container *ngFor="let label of mod.labels.slice(0,3)"> {{label.label_name}}<br />
                            </ng-container><span data-toggle="modal" data-target="#labelList"
                              (click)="this.transferLabelList(key,mod.labels,k,mod.id,'ModularJob',false,0,'')"><i
                                data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                style="font-size:1rem;color:#8c0420"></i></span>
                          </td>
                          <td>{{mod.amount}}</td>
                          <td class="minWidthForTd">
                            <span class="moduleLineItemSpan{{k}}">
                              {{mod.dimensions}}
                              <!-- <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">{{mod.length}} X {{mod.breadth}} X {{mod.thickness}} LBT</ng-container>
                                                                    <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">{{mod.width}} X {{mod.depth}} X {{mod.height}} WDH</ng-container> -->
                            </span>
                            <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">
                              <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                <span class="input-group-addon rk-form-fontsize">Width</span>
                                <input type="number" name="" class="form-control rk-form-fontsize"
                                  [(ngModel)]="editModuleLineWidth" readonly>
                              </div>
                              <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                <span class="input-group-addon rk-form-fontsize">Depth</span>
                                <input type="number" name="" class="form-control rk-form-fontsize"
                                  [(ngModel)]="editModuleLineDepth" readonly>
                              </div>
                              <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                                <span class="input-group-addon rk-form-fontsize">Height</span>
                                <input type="number" name="" class="form-control rk-form-fontsize"
                                  [(ngModel)]="editModuleLineHeight" readonly>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">
                              <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                                <span class="input-group-addon rk-form-fontsize">Length</span>
                                <input type="number" name="" class="form-control  rk-form-fontsize"
                                  [(ngModel)]="editModuleLineLength">
                              </div>
                              <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                <span class="input-group-addon rk-form-fontsize">Breadth</span>
                                <input type="number" name="" class="form-control  rk-form-fontsize"
                                  [(ngModel)]="editModuleLineBreadth">
                              </div>
                              <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                <ng-select [(ngModel)]="editModuleLineThickness" class="rk-form-fontsize"
                                  style="width: 100%">
                                  <ng-option value="" disabled>Select Thickness</ng-option>
                                  <ng-option *ngFor="let val of mod.customizable_dimensions.allowed_T" [value]="val">
                                    {{val}}</ng-option>
                                </ng-select>

                              </div>
                            </ng-container>
                          </td>
                          <td>
                            <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;"
                              onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                              (click)="zoomImg($event.target)" class="addCursor">
                          </td>
                          <td>
                            <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfModule(mod.id)"
                              data-toggle="modal" data-target="#customizationModal">
                          </td>
                          <td>
                            <ng-container *ngIf="mod.timeline['lead_time']">
                              {{mod.timeline["lead_time"]}}&nbsp;days
                            </ng-container>

                          </td>
                          <!-- <td>{{mod.timeline["type"]}}</td> -->
                          <td>
                            <button
                              class="d-none moduleLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1"
                              (click)="updateQuantity(k,mod,'wardrobe')">Update</button>
                            <button class="d-none moduleLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                              (click)="cancelModuleLineItem(k,mod)">Cancel</button>
                            <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}"
                              data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                              aria-expanded="false"></i>
                            <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                              <a class="dropdown-item addCursor" (click)="editmoduleLineItem(k,mod)">Edit</a>
                              <a class="dropdown-item addCursor"
                                (click)="moduleDelete(mod.id,mod.space,mod.category)">Delete</a>
                            </div>
                          </td>
                        </tr>
                        <tr id="package{{k}}" class="accordion-toggle addCursor" data-toggle="collapse"
                          data-parent="#OrderPackages" [attr.data-target]="'.packageDetails'+k" *ngIf="mod.combined"
                          (click)="showAccordion(k)" style="font-weight: normal;">
                          <td>{{k+1}}</td>
                          <td>Combined</td>
                          <td>{{mod.name}}</td>
                          <td style="text-align:center">
                            <ng-container *ngFor="let label of mod.labels.slice(0,3)"> {{label.label_name}}<br />
                            </ng-container><span data-toggle="modal" data-target="#labelList"
                              (click)="this.transferLabelList(key,mod.labels,k,mod.id,'ModularJob',false,0,'')"><i
                                data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                style="font-size:1rem;color:#8c0420"></i></span>
                          </td>
                          <td>{{mod.quantity}}</td>
                          <td>{{mod.amount}}</td>
                          <td></td>
                          <td>
                            <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;"
                              onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                              (click)="zoomImg($event.target)" class="addCursor">
                          </td>
                          <td></td>
                          <td>
                            <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}"
                              data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                              aria-expanded="false"></i>
                            <i class="fa fa-angle-up pull-right"></i>
                            <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                              <a class="dropdown-item addCursor"
                                (click)="show_EditCombModModal(k,mod); setCombineModuleData(quotationDetails.modular_jobs_wardrobe[key])"
                                data-toggle="modal" data-target="#editCombineModuleModal">Edit</a>
                              <a class="dropdown-item addCursor"
                                (click)="moduleDelete(mod.id,mod.space,mod.category,true)">Remove Combination</a>
                            </div>
                          </td>
                        </tr>
                        <tr class="d-none combmoduleAccordionRow{{k}}" id="combmoduleAccordionRow{{k}}"
                          *ngIf="mod.combined">
                          <td colspan="12" class="hiddenRow">
                            <div class="accordion-body collapse packageDetails{{k}}" id="accordion_{{k}}">
                              <table class="table">
                                <tr *ngFor="let cmod of mod.included_modules; let m=index; ">
                                  <td>{{m+1}}</td>
                                  <td>{{cmod.module_type}}</td>
                                  <td>{{cmod.code}}</td>
                                  <td style="text-align:center">
                                    <ng-container *ngFor="let label of cmod.labels.slice(0,3)">
                                      {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                      data-target="#labelList"
                                      (click)="this.transferLabelList(key,cmod.labels,k,cmod.id,'ModularJob',true,m,'')"><i
                                        data-toggle="tooltip" title="Click to view complete list."
                                        class="fa fa-binoculars" style="font-size:1rem;color:#8c0420"></i></span>
                                  </td>
                                  <td>
                                    <span class="moduleLineItemSpan{{k}}{{m}}">{{cmod.quantity}}</span>
                                    <input type="number" name=""
                                      class="form-control d-none moduleLineItemInput{{k}}{{m}} rk-form-fontsize"
                                      [(ngModel)]="editModuleLineQty">
                                  </td>
                                  <td class="text-center">{{cmod.amount}}</td>
                                  <td class="minWidthForTd">
                                    <span class="moduleLineItemSpan{{k}}{{m}}">
                                      <!-- <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='LBT'">{{cmod.length}} X {{cmod.breadth}} X {{cmod.thickness}} (LBT)</ng-container>
                                                                                    <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='WDH'">{{cmod.width}} X {{cmod.depth}} X {{cmod.height}} (WDH)</ng-container> -->
                                      {{cmod.dimensions}}
                                    </span>
                                    <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='WDH'">
                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Width</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize"
                                          [(ngModel)]="editModuleLineWidth" readonly>
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Depth</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize"
                                          [(ngModel)]="editModuleLineDepth" readonly>
                                      </div>
                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}{{m}}">
                                        <span class="input-group-addon rk-form-fontsize">Height</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize"
                                          [(ngModel)]="editModuleLineHeight" readonly>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='LBT'">
                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}{{m}}">
                                        <span class="input-group-addon rk-form-fontsize">Length</span>
                                        <input type="number" name="" class="form-control  rk-form-fontsize"
                                          [(ngModel)]="editModuleLineLength">
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Breadth</span>
                                        <input type="number" name="" class="form-control  rk-form-fontsize"
                                          [(ngModel)]="editModuleLineBreadth">
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                        <ng-select [(ngModel)]="editModuleLineThickness" class="rk-form-fontsize"
                                          style="width: 100%">
                                          <ng-option value="" disabled>Select Thickness</ng-option>
                                          <ng-option *ngFor="let val of cmod.customizable_dimensions.allowed_T"
                                            [value]="val">{{val}}</ng-option>
                                        </ng-select>
                                      </div>
                                    </ng-container>
                                  </td>
                                  <td>
                                    <img src="{{cmod.module_image_url}}" *ngIf="cmod.module_image_url"
                                      style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';"
                                      alt="Missing Image" (click)="zoomImg($event.target)" class="addCursor">
                                  </td>
                                  <td>
                                    <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfModule(cmod.id)"
                                      data-toggle="modal" data-target="#customizationModal">
                                  </td>
                                  <td>
                                    <ng-container *ngIf="mod.timeline['lead_time']">
                                      {{cmod.timeline["lead_time"]}}&nbsp;days
                                    </ng-container>
                                  </td>
                                  <!-- <td>{{cmod.timeline["type"]}}</td> -->
                                  <td>
                                    <button
                                      class="d-none moduleLineItemInput{{k}}{{m}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1"
                                      (click)="updateQuantity(k,cmod,'wardrobe')">Update</button>
                                    <button
                                      class="d-none moduleLineItemInput{{k}}{{m}} rk-btnCancel addCursor mx-2 mt-1"
                                      (click)="cancelCombineModuleLineItem(k,mod,m)">Cancel</button>
                                    <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}{{m}}"
                                      data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                      aria-expanded="false"></i>
                                    <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                      <a class="dropdown-item addCursor"
                                        (click)="editCombinemoduleLineItem(k,cmod,m)">Edit</a>
                                      <a class="dropdown-item addCursor"
                                        (click)="moduleDelete(cmod.id,cmod.space,cmod.category)">Delete</a>
                                    </div>
                                  </td>
                                </tr>

                              </table>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-container>
              <p style="padding-bottom:0 !important" *ngIf="Object.keys(quotationDetails.extra_jobs_wardrobe).length>0">
                Added Extras :</p>
              <ng-container *ngFor="let key7 of Object.keys(quotationDetails.extra_jobs_wardrobe); let m7 =index; ">
                <div *ngIf="key7==selSpace" class="tableDiv mt-3">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th class="firstTh">#</th>
                        <th> Name</th>
                        <th>Vendor Sku</th>
                        <th>Make</th>
                        <th style="text-align:center">Label</th>
                        <th>Specification</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Image</th>
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let extrajob of quotationDetails.extra_jobs_wardrobe[key7]; let k=index; ">
                        <tr>
                          <ng-container *ngIf="!extrajob.included_addons">
                            <td>{{k+1}}</td>
                            <td>{{extrajob.name}}</td>
                            <td>{{extrajob.vendor_sku}}</td>
                            <td>{{extrajob.make}}</td>
                            <td style="text-align:center">
                              <ng-container *ngFor="let label of extrajob.labels.slice(0,3)"> {{label.label_name}}<br />
                              </ng-container><span data-toggle="modal" data-target="#labelList"
                                (click)="this.transferLabelList(key7,extrajob.labels,k,extrajob.id,'ExtraJob',false,0,'')"><i
                                  data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                  style="font-size:1rem;color:#8c0420"></i></span>
                            </td>
                            <td>{{extrajob.specifications}}</td>
                            <td>
                              <span class="extraLineItemSpan{{k}}">{{extrajob.quantity}}</span>
                              <input type="number" name="" class="form-control d-none extraLineItemInput{{k}}"
                                [(ngModel)]="editExtraLineQty">
                            </td>
                            <td>{{extrajob.amount}}</td>
                            <td>
                              <img src="{{extrajob.image_url}}" *ngIf="extrajob.image_url" style="width: 100px;"
                                onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                                (click)="zoomImg($event.target)" class="addCursor">
                            </td>
                            <td>
                              <button class="d-none extraLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1"
                                (click)="updateExtra(k,extrajob,'kitchen',false)">Update</button>
                              <button class="d-none extraLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelExtraLineItem(k,extrajob)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop extraLineItemSpan{{k}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor" (click)="editExtraLineItem(k,extrajob)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="extraDelete(extrajob.id,extrajob.space)">Delete</a>
                              </div>
                            </td>

                          </ng-container>
                          <ng-container *ngIf="extrajob.included_addons">
                            <td>{{k+1}}</td>
                            <td data-toggle="collapse" [attr.data-target]="'.addons-'+k" style="cursor:pointer"><span
                                style="color:#8c0420" data-toggle="tooltip" data-placement="bottom"
                                title="Combination Extra : Please click here to view included extras">{{extrajob.name}}</span>
                            </td>
                            <td></td>
                            <td></td>
                            <td style="text-align:center">
                              <ng-container *ngFor="let label of extrajob.labels.slice(0,3)"> {{label.label_name}}<br />
                              </ng-container><span data-toggle="modal" data-target="#labelList"
                                (click)="this.transferLabelList(key7,extrajob.labels,k,extrajob.id,'ExtraJob',false,0,'')"><i
                                  data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                  style="font-size:1rem;color:#8c0420"></i></span>
                            </td>
                            <td></td>
                            <td>
                              <span class="extraLineItemSpan{{k}}">{{extrajob.quantity}}</span>
                              <input type="number" name="" class="form-control d-none extraLineItemInput{{k}}"
                                [(ngModel)]="editExtraLineQty">
                            </td>
                            <td>{{extrajob.amount}}</td>
                            <td>
                              <img src="{{extrajob.included_addons[0].addon_image}}"
                                *ngIf="extrajob.included_addons.length>0 && extrajob.included_addons[0].addon_image"
                                style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';"
                                alt="Missing Image" (click)="zoomImg($event.target)" class="addCursor">
                            </td>
                            <td>
                              <button class="d-none extraLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1"
                                (click)="updateExtra(k,extrajob,'kitchen',true)">Update</button>
                              <button class="d-none extraLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelExtraLineItem(k,extrajob)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop extraLineItemSpan{{k}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor" (click)="editExtraLineItem(k,extrajob)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="extraDelete(extrajob.id,extrajob.space)">Delete</a>
                              </div>
                            </td>
                          </ng-container>
                        </tr>
                        <ng-container *ngIf="extrajob.included_addons">
                          <tr class="collapse addons-{{k}}"
                            *ngFor="let addon of extrajob.included_addons;let k_addon=index;">
                            <td>{{k_addon+1}}</td>
                            <td>{{addon.name}}</td>
                            <td>{{addon.vendor_sku}}</td>
                            <td>{{addon.make}}</td>
                            <td></td>
                            <td>{{addon.specifications}}</td>
                            <td>
                              <span class="extraLineItemSpan{{k}}">{{addon.quantity}}</span>
                            </td>
                            <td>{{addon.mrp}}</td>
                            <td>
                              <img src="{{addon.addon_image}}" *ngIf="addon.addon_image" style="width: 100px;"
                                onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                                (click)="zoomImg($event.target)" class="addCursor">
                            </td>
                            <td></td>
                          </tr>
                        </ng-container>

                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right"
      *ngIf="globalVarArr  && quotationDetails && (boqConfigMWVal!=undefined && selectedSpacesArr && selectedSpacesArr.length>0 && quotationDetails && Object.keys(quotationDetails.modular_jobs_wardrobe).length>0) || (boqConfigMKVal!=undefined && selectedSpacesArrMK && selectedSpacesArrMK.length>0 && Object.keys(quotationDetails.modular_jobs_kitchen).length>0 || (quotationDetails && Object.keys(quotationDetails.appliance_jobs).length>0) || (quotationDetails && Object.keys(quotationDetails.extra_jobs_wardrobe).length>0))">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>

  <!--Loose Furniture Container-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForLF">
    <div class="col-md-12 borderbottom pt-3 pb-3">
      <div class="row">
        <div class="col-md-3"><span>Enter Space</span></div>
        <div class="col-md-6">
          <form [formGroup]="addSpaceMWForm">
            <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
              <option value="">Select</option>
              <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
            </select>
            <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'loose_furniture')">
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3" *ngIf="selectedSpacesArrLf && selectedSpacesArrLf.length>0">
      <div id="accordionLf">
        <div class="card mb-2" *ngFor="let selSpaceLf of selectedSpacesArrLf; let k2=index; ">
          <div class="card-header" id="spaceCardLf{{k2}}">
            <h5 class="mb-0">
              <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse"
                [attr.data-target]=" '#collapseSpaceCardLf'+k2" aria-expanded="true" aria-controls="collapseOne">
                {{selSpaceLf}}
              </button>
              <!-- <ng-container><span style="font-size: 14px;" class="pull-right">Total - &#8377; <span id="spacesLfTotal{{k2}}">{{getTotalOfLfSpaces(selSpaceLf,k2)}}</span></span></ng-container> -->
              <ng-container *ngFor="let key2 of Object.keys(quotationDetails.space_amounts_loose); let n =index; "><span
                  *ngIf="key2==selSpaceLf" style="font-size: 14px;" class="pull-right">Total - &#8377;
                  {{quotationDetails.space_amounts_loose[key2]}}</span></ng-container>
            </h5>

            <div class=" col-md-12 text-right">
              <button class="addCursor" (click)="openSmartBoqModal(selSpaceLf)">Generate Smart BOQ</button>
              <button [attr.data-target]=" '#collapseSpaceCardLf'+k2" aria-expanded="true"
                aria-controls="collapseOne"><span data-toggle="modal" data-target="#addProductModal"
                  (click)="openProductModal(selSpaceLf)" class="addCursor">Add Product</span></button>
              <button (click)="spaceDelete(selSpaceLf,'loose_furniture')" class="addCursor">Delete Space</button>
            </div>
          </div>

          <div id="collapseSpaceCardLf{{k2}}" class="collapse" [attr.aria-labelledby]="'spaceCardLf'+k2"
            data-parent="#accordionLf">
            <div class="card-body">
              <!--  <div class="col-md-12 mt-2 text-center"  *ngIf="boqProducts && boqProducts.length==0 ">
                                    No product has been added.
                                  </div> -->
              <div class="">
                <ng-container *ngFor="let keylf of Object.keys(quotationDetails.boqjobs); let m5 =index;">
                  <div *ngIf="keylf==selSpaceLf" class="tableDiv mt-3">
                    <table class="table" style="display:block;overflow:auto">
                      <thead class="thead-dark">
                        <tr>
                          <th class="firstTh">#</th>
                          <th>NAME</th>
                          <th>FINISH</th>
                          <th>Dimension(mm)</th>
                          <th>Label</th>
                          <th>Material</th>
                          <th>PRICE</th>
                          <th style="min-width: 110px;">QTY</th>
                          <th>TOTAL AMOUNT</th>
                          <th>Fabric</th>
                          <th>Image</th>
                          <th>Delivery Timeline</th>
                          <th class="lastTh"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let addedproduct of quotationDetails.boqjobs[keylf]; let k7=index; ">
                          <tr>
                            <td>{{k7+1}}</td>
                            <td>{{addedproduct.name}}</td>
                            <td>{{addedproduct.finish}}</td>
                            <td>{{addedproduct.dimensions}}</td>
                            <td style="text-align:center">
                              <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)">
                                {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                data-target="#labelList"
                                (click)="this.transferLabelList(keylf,addedproduct.labels,k7,addedproduct.id,'Boqjob',false,0,'')"><i
                                  data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                  style="font-size:1rem;color:#8c0420"></i></span>
                            </td>
                            <td>{{addedproduct.material}}<span *ngIf="addedproduct.material==null">NA</span></td>
                            <td>{{addedproduct.rate | number: '1.2-2'}}</td>
                            <td>
                              <span class="loosefurLineItemSpan{{k7}}">{{addedproduct.quantity}}</span>
                              <input type="number" name="" class="form-control d-none loosefurLineItemInput{{k7}}"
                                [(ngModel)]="editProductLineItemQty">
                            </td>
                            <td>{{addedproduct.amount | number: '1.2-2'}}</td>
                            <ng-container *ngIf="addedproduct.job_type !== 'curtain'">
                            <td>
                              <img class=" addCursor" src="{{addedproduct.product_variant.fabric_image}}" alt="No Image"
                                height="100px" width="100px"
                                *ngIf="addedproduct.product_variant && addedproduct.product_variant.fabric_image"
                                onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target)"
                                title="{{addedproduct.product_variant.name}}">
                              <br>
                              <input type="button"
                                class="d-none loosefurLineItemInput{{k7}} rk-interalBtnColor addCursor mt-1" name=""
                                (click)="fetchMasterOption(addedproduct.id)" value="Change Fabric">
                            </td>
                            </ng-container>
                            <ng-container *ngIf="addedproduct.job_type === 'curtain'">
                              <td></td>
                              </ng-container>
                            <ng-container *ngIf="addedproduct.job_type === 'loose'">
                            <td>
                              <img class="addCursor" src="{{addedproduct.image_urls[0]}}" alt="No Image" height="100px"
                                width="100px" *ngIf="addedproduct.image_urls[0]"
                                onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target)">
                            </td>
                            </ng-container>
                            <ng-container *ngIf="addedproduct.job_type === 'curtain'">
                              <td>
                              <img class="addCursor" src="{{baseUrl + '/' + addedproduct.image_urls[0]}}" alt="No Image" height="100px"
                                width="100px"
                                onerror="this.src='./assets/img/no_image.svg'">
                            </td>
                              </ng-container>
                            <td>
                              <ng-container *ngIf="addedproduct.lead_time">
                                {{addedproduct.lead_time}}&nbsp;days
                              </ng-container>
                            </td>
                            <td>
                              <button
                                class="d-none loosefurLineItemInput{{k7}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1"
                                (click)="updateProduct(k7,addedproduct)">Update</button>
                              <button class="d-none loosefurLineItemInput{{k7}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelProductLineItem(k7,addedproduct)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="editProductLineItem(k7,addedproduct)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="removeProductToBoqs(addedproduct.id,addedproduct.name,selSpaceLf)">Delete</a>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>

  <!--Custom Furniture Container-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForCF">
    <div class="col-md-12 borderbottom pt-3 pb-3">
      <div class="row">
        <div class="col-md-3"><span>Enter Space</span></div>
        <div class="col-md-6">
          <form [formGroup]="addSpaceMWForm">
            <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
              <option value="">Select</option>
              <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
            </select>
            <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'custom_furniture')">
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3" *ngIf="selectedSpacesArrCf && selectedSpacesArrCf.length>0">
      <div id="accordionCF">
        <div class="card mb-2" *ngFor="let selSpaceCF of selectedSpacesArrCf; let k5=index; ">
          <div class="card-header" id="spaceCardCF{{k5}}">
            <h5 class="mb-0">
              <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse"
                [attr.data-target]=" '#collapseSpaceCardCF'+k5" aria-expanded="true" aria-controls="collapseOne"
                (click)="passSpaceName(selSpaceCF)">
                {{selSpaceCF}}
              </button>
              <!-- <ng-container><span style="font-size: 14px;" class="pull-right">Total - &#8377; <span id="spacesLfTotal{{k2}}">{{getTotalOfLfSpaces(selSpaceLf,k2)}}</span></span></ng-container> -->
              <div *ngIf="quotationDetails">
                <ng-container *ngFor="let key2 of Object.keys(quotationDetails.space_amounts_shangpin); let n =index; ">
                  <div *ngIf="key2==selSpaceCF" style="font-size: 14px; margin-top: -29px;" class="pull-right">Total -
                    &#8377; {{quotationDetails.space_amounts_shangpin[selSpaceCF] | number: '.1-2' }}</div>
                </ng-container>
              </div>
            </h5>

            <div class="pull-right col-md-12 text-right">
              <a href = "#" [routerLink]="['/browse-preset']" routerLinkActive="active" target = "_blank">
                <button class="addCursor">Browse Preset</button>
              </a>
              <button (click)="getCFlayoutList(selSpaceCF)" class="addCursor">Import Layout</button>
              <ng-container *ngIf="quotationDetails">
                <ng-container
                  *ngIf="quotationDetails.shangpin_jobs_cabinet[selSpaceCF] || 
                                quotationDetails.shangpin_jobs_door[selSpaceCF] || quotationDetails.shangpin_jobs_accessory[selSpaceCF] || quotationDetails.shangpin_jobs_sliding_door[selSpaceCF] || quotationDetails.shangpin_jobs_wardrobe[selSpaceCF]">
                  <button data-target="#saveCfLayoutModal" data-toggle="modal" class="addCursor"
                    (click)="passSpaceName(selSpaceCF)">Save As Layout</button>
                </ng-container>
              </ng-container>
              <button (click)="spaceDelete(selSpaceCF,'custom_furniture')" class="addCursor">Delete Space</button>
            </div>

            <div class="pull-right col-md-12 text-right mt-2">
              <label class="text-left mr-2">Upload Excel</label>
              <input type="file" #myInput id="uploadInput{{k5}}" class="form-control"
                (change)="uploadCustomFurnitureExl($event,k5,selSpaceCF)" name="attachment_file" ngModel
                #attachment_file="ngModel" style="display:inline-block;width: 30%;" /><button data-toggle="modal"
                data-target="#selectExcelType" class="cartBtn">Upload</button>
              <div class="col-md-12 d-none mt-2 text-left" id="kdmax_errorblock{{k1}}">
                <div class="alert alert-danger" *ngIf="quotationDetails">
                  <a class="close rk-linknotification mr-3 mt-1" (click)="closeKdmax_errorblock(k1)">×</a>
                  <ng-container *ngFor=" let err of this.quotationDetails.errors">
                    <span><strong>Code - </strong> {{err.code}}</span><br>
                    <span><strong>Message - </strong> {{err.message}}</span><br>
                    <p style=" padding-top: 10px;border-bottom: 1px solid #f5c6cb;"></p>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div id="collapseSpaceCardCF{{k5}}" class="collapse" [attr.aria-labelledby]="'spaceCardCF'+k5"
            data-parent="#accordionCF">
            <div class="card-body" *ngIf="quotationDetails">
              <!--  <div class="col-md-12 mt-2 text-center"  *ngIf="boqProducts && boqProducts.length==0 ">
                                No product has been added.
                              </div> -->
              <div class="">
                <!--Cabinet List-->
                <div class="" *ngIf="quotationDetails.shangpin_jobs_cabinet[selSpaceCF]">
                  <p class="font-weight-bold">Cabinet List:</p>
                  <ng-container
                    *ngFor="let keyCF of Object.keys(quotationDetails.shangpin_jobs_cabinet); let m5 =index;">
                    <div *ngIf="keyCF==selSpaceCF" class="tableDiv mt-3">
                      <table class="table">
                        <thead class="thead-dark">
                          <tr>
                            <!-- <th class="firstTh">#</th>
                                            <th *ngIf="addedproduct.imported_file_type!='1QuoteForm'">ITEM</th>
                                            <th>MODEL NUMBER</th>
                                            <th *ngIf="addedproduct.imported_file_type!='1DetailedQuoteForm' && addedproduct.imported_file_type!='1DetailedQuoteForm-1' ">ACTUAL SIZE<br>(WxDxH)</th>
                                            <th>LABEL</th>
                                            <th *ngIf="addedproduct.imported_file_type!='1QuoteForm'">COLOR</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1QuoteForm'">IMAGE / MATERIAL</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1QuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1' " >ADDITIONAL DETAILS</th>
                                            <th>UNIT PRICE</th>
                                            <th>QUANTITY</th>
                                            <th>AMOUNT</th>
                                            <th class="lastTh"></th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="let addedproduct of quotationDetails.shangpin_jobs_cabinet[keyCF]; let k7=index; ">
                            <tr>
                              <td>{{k7+1}}</td>
                              <td *ngIf="addedproduct.imported_file_type!='1QuoteForm'"><span
                                  class="specification-sub">Item:</span> {{addedproduct.cabinet_item}}</td>
                              <td><span class="specification-sub">Model Number:</span><br />
                                {{addedproduct.cabinet_model_no}}</td>
                              <td
                                *ngIf="addedproduct.imported_file_type!='1DetailedQuoteForm' && addedproduct.imported_file_type!='1DetailedQuoteForm-1' && addedproduct.imported_file_type!='1QuoteForm' ">
                                <span class="specification-sub">Actual Size:</span>
                                {{addedproduct.cabinet_overall_size}}</td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><img class="zoom"
                                  [src]="addedproduct.image_url || '../../assets/404.jpg' " alt="Cabinet Image"></td>
                              <!-- <td><span class="specification-sub">Labels: </span><ng-container *ngFor="let label of addedproduct.labels.slice(0,3)"> {{label.label_name}}<br/></ng-container><span data-toggle="modal" data-target="#labelList" (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'cabinet')"><i data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars" style="font-size:1rem;color:#8c0420"></i></span></td> -->

                              <td *ngIf="addedproduct.imported_file_type!='1QuoteForm'"><span
                                  class="specification-sub">Color:</span> {{addedproduct.cabinet_color || '-'}}</td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><span
                                  class="specification-sub">Material:</span> <span
                                  class="specification-value">{{addedproduct.cabinet_material || '-'}}</span></td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><span
                                  class="specification-sub">Additional Details :</span> <br /> Actual Size:
                                {{addedproduct.cabinet_overall_size}} <br /> Specific Size:
                                {{addedproduct.cabinet_specific_size || '-'}} <br />
                                Door:{{addedproduct.cabinet_door || '-'}} <br />
                                Platform:{{addedproduct.cabinet_platform || '-'}} <br />
                                Handle:{{addedproduct.cabinet_handle || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}}</td>
                              <td
                                *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">
                                <span class="specification-sub">Additional Details:</span><br /> Actual
                                Size:{{addedproduct.cabinet_overall_size || '-'}} <br /> Specification:
                                {{addedproduct.cabinet_specific_size || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}}</td>
                              <td><span class="specification-sub">Labels: </span>
                                <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)">
                                  {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                  data-target="#labelList"
                                  (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'cabinet')"><i
                                    data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                    style="font-size:1rem;color:#8c0420"></i></span>
                              </td>
                              <td><span class="specification-sub">Unit Price:</span>&#x20b9;
                                {{addedproduct.cabinet_price_factored | number: '.1-2'}}</td>
                              <td><span class="specification-sub">Quantity:</span> {{addedproduct.cabinet_quantity}}
                              </td>
                              <td><span class="specification-sub">Amount:</span>&#x20b9;
                                {{addedproduct.cabinet_amount_factored | number: '.1-2'}}</td>
                              <td>
                                <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                  data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                  <a class="dropdown-item addCursor"
                                    (click)="removeCfProductToBoqs(addedproduct.id)">Delete</a>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </div>

                <!--Door List-->
                <div class="" *ngIf="quotationDetails.shangpin_jobs_door[selSpaceCF]">
                  <p class="font-weight-bold">Door List:</p>
                  <ng-container *ngFor="let keyCF of Object.keys(quotationDetails.shangpin_jobs_door); let m5 =index;">
                    <div *ngIf="keyCF==selSpaceCF" class="tableDiv mt-3">
                      <table class="table">
                        <thead class="thead-dark">
                          <tr>
                            <!-- <th class="firstTh">#</th>
                                            <th *ngIf="addedproduct.imported_file_type!='1QuoteForm'">STYLE CODE</th>
                                            <th>OVERALL SIZE<br>(WxDxH)</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1QuoteForm'">ACTUAL SIZE</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1QuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">ADDITIONAL DETAILS</th>
                                            <th>QUANTITY</th>
                                            <th>LABEL</th>
                                            <th>AMOUNT</th>
                                            <th class="lastTh"></th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="let addedproduct of quotationDetails.shangpin_jobs_door[keyCF]; let k7=index; ">
                            <tr>
                              <td>{{k7+1}}</td>
                              <td><span class="specification-sub">Style Code:</span> {{addedproduct.door_style_code}}
                              </td>
                              <td
                                *ngIf="addedproduct.imported_file_type!='1DetailedQuoteForm' && addedproduct.imported_file_type!='1DetailedQuoteForm-1' && addedproduct.imported_file_type!='1QuoteForm' ">
                                <span class="specification-sub">Overall Size:</span> {{addedproduct.door_overall_size}}
                              </td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><img class="zoom"
                                  [src]="addedproduct.image_url || '../../assets/404.jpg' " alt="Door Image"><br /></td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><span
                                  class="specification-sub">Additional Details:</span><br /> Size (WDH):
                                {{addedproduct.door_overall_size || '-'}} <br /> Material:
                                {{addedproduct.door_material || '-'}} <br /> Handle:
                                {{addedproduct.door_handle || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}}</td>
                              <td
                                *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">
                                <span class="specification-sub">Additional Details</span>Actual Size:
                                {{addedproduct.door_overall_size || '-'}} <br /> Specification:
                                {{addedproduct.door_specific_size || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}}</td>
                              <td><span class="specification-sub">Labels:</span>
                                <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)">
                                  {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                  data-target="#labelList"
                                  (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'door')"><i
                                    data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                    style="font-size:1rem;color:#8c0420"></i></span>
                              </td>
                              <td><span class="specification-sub">Unit Price:</span>&#x20b9;
                                {{addedproduct.door_price_factored | number: '.1-2'}}</td>
                              <td><span class="specification-sub">Quantity:</span> {{addedproduct.door_quantity}}</td>
                              <td><span class="specification-sub">Amount:</span>&#x20b9;
                                {{addedproduct.door_amount_factored  | number: '.1-2'}}</td>
                              <td>
                                <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                  data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                  <a class="dropdown-item addCursor"
                                    (click)="removeCfProductToBoqs(addedproduct.id)">Delete</a>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </div>

                <!--Accessory List-->
                <div class="" *ngIf="quotationDetails.shangpin_jobs_accessory[selSpaceCF]">
                  <p class="font-weight-bold">Accessory List:</p>
                  <ng-container
                    *ngFor="let keyCF of Object.keys(quotationDetails.shangpin_jobs_accessory); let m5 =index;">
                    <div *ngIf="keyCF==selSpaceCF" class="tableDiv mt-3">
                      <table class="table">
                        <thead class="thead-dark">
                          <tr>
                            <!-- <th class="firstTh">#</th>
                                            <th>ITEM</th>
                                            <th>MODEL NUMBER</th>
                                            <th>ACTUAL SIZE<br>(WxDxH)</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1QuoteForm'|| addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">ADDITIONAL DETAILS</th>
                                            <th>LABEL</th>
                                            <th>COLOR</th>
                                            <th>UNIT PRICE</th>
                                            <th>QUANTITY</th>
                                            <th>AMOUNT</th>
                                            <th class="lastTh"></th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="let addedproduct of quotationDetails.shangpin_jobs_accessory[keyCF]; let k7=index; ">
                            <tr>
                              <td>{{k7+1}}</td>
                              <td><span class="specification-sub">Item:</span> {{addedproduct.accessory_item || '-'}}
                              </td>
                              <td> <span class="specification-sub">Model Number:</span>
                                <div *ngIf="addedproduct.accessory_code && !addedproduct.accessory_model_no">
                                  {{addedproduct.accessory_code}}</div>

                                <div *ngIf="addedproduct.accessory_model_no">{{addedproduct.accessory_model_no}}</div>
                              </td>
                              <td
                                *ngIf="addedproduct.imported_file_type!='1DetailedQuoteForm' && addedproduct.imported_file_type!='1DetailedQuoteForm-1' && addedproduct.imported_file_type!='1QuoteForm' ">
                                <span class="specification-sub">Overall Size:</span><br />
                                {{addedproduct.accessory_overall_size}}</td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><img class="zoom"
                                  [src]="addedproduct.image_url || '../../assets/404.jpg' " alt="Door Image"></td>
                              <td *ngIf="addedproduct.imported_file_type=='1QuoteForm'"><span
                                  class="specification-sub">Additional Details:</span><br /> Material:
                                {{addedproduct.accessory_material || '-'}} <br /> Handle:
                                {{addedproduct.accessory_handle || '-'}} <br /> Name Code:
                                {{addedproduct.accessory_name_code || '-'}} <br /> Size (WDH):
                                {{addedproduct.accessory_overall_size || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}}</td>
                              <td
                                *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">
                                <span class="specification-sub">Additional Details:</span><br /> Actual Size:
                                {{addedproduct.accessory_overall_size || '-'}} <br /> Specification:
                                {{addedproduct.accessory_specific_size || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}} </td>
                              <!-- <td><span class="specification-sub">Labels:</span> <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)"> {{label.label_name}}<br/></ng-container><span data-toggle="modal" data-target="#labelList" (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'accessory')"><i data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars" style="font-size:1rem;color:#8c0420"></i></span></td> -->
                              <td *ngIf="addedproduct.imported_file_type!='1QuoteForm'"><span
                                  class="specification-sub">Color:</span> {{addedproduct.accessory_color || '-'}}</td>
                              <td><span class="specification-sub">Labels:</span>
                                <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)">
                                  {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                  data-target="#labelList"
                                  (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'accessory')"><i
                                    data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                    style="font-size:1rem;color:#8c0420"></i></span>
                              </td>
                              <td><span class="specification-sub">Unit Price:</span>&#x20b9;
                                {{addedproduct.accessory_price_factored | number: '.1-2'}}</td>
                              <td><span class="specification-sub">Quantity:</span> {{addedproduct.accessory_quantity}}
                              </td>
                              <td><span class="specification-sub">Amount:</span>&#x20b9;
                                {{addedproduct.accessory_amount_factored | number: '.1-2'}}</td>
                              <td>
                                <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                  data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                  <a class="dropdown-item addCursor"
                                    (click)="removeCfProductToBoqs(addedproduct.id)">Delete</a>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </div>

                <!--Sliding Door-->
                <div class="" *ngIf="quotationDetails.shangpin_jobs_sliding_door[selSpaceCF]">
                  <p class="font-weight-bold">Sliding Door:</p>
                  <ng-container
                    *ngFor="let keyCF of Object.keys(quotationDetails.shangpin_jobs_sliding_door); let m5 =index;">
                    <div *ngIf="keyCF==selSpaceCF" class="tableDiv mt-3 mb-2">
                      <table class="table">
                        <thead class="thead-dark">
                          <tr>
                            <!-- <th class="firstTh">#</th>
                                            <th>ITEM</th>
                                            <th>MODEL NUMBER</th>
                                            <th>ACTUAL SIZE<br>(WxDxH)</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">ADDITIONAL DETAILS</th>
                                            <th>LABEL</th>
                                            <th>COLOR</th>
                                            <th>UNIT PRICE</th>
                                            <th>QUANTITY</th>
                                            <th>AMOUNT</th>
                                            <th class="lastTh"></th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="let addedproduct of quotationDetails.shangpin_jobs_sliding_door[keyCF]; let k7=index; ">
                            <tr>
                              <td>{{k7+1}}</td>
                              <td><span class="specification-sub">Item:</span> {{addedproduct.door_item || '-'}}</td>
                              <td><span class="specification-sub">Model Number:</span> {{addedproduct.door_model_no}}
                              </td>
                              <!-- <td><span class="specification-sub">Actual Size:</span><br/> {{addedproduct.door_overall_size}}</td> -->
                              <td
                                *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">
                                <span class="specification-sub">Additional Details:</span> <br />Actual Size:
                                {{addedproduct.door_overall_size || '-'}} <br /> Specification:
                                {{addedproduct.door_specific_size || '-'}}<br />Core
                                Material:{{addedproduct.core_material || '-'}} </td>
                              <!-- <td><span class="specification-sub">Labels:</span> <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)"> {{label.label_name}}<br/></ng-container><span data-toggle="modal" data-target="#labelList" (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'slidingDoor')"><i data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars" style="font-size:1rem;color:#8c0420"></i></span></td> -->
                              <td><span class="specification-sub">Color:</span> {{addedproduct.door_color || '-'}}</td>
                              <td><span class="specification-sub">Labels:</span>
                                <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)">
                                  {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                  data-target="#labelList"
                                  (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'slidingDoor')"><i
                                    data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                    style="font-size:1rem;color:#8c0420"></i></span>
                              </td>
                              <td><span class="specification-sub">Unit Price:</span>&#x20b9;
                                {{addedproduct.door_price_factored | number: '.1-2'}}</td>
                              <td><span class="specification-sub">Quantity:</span> {{addedproduct.door_quantity}}</td>
                              <td><span class="specification-sub">Amount:</span>&#x20b9;
                                {{addedproduct.door_amount_factored | number: '.1-2'}}</td>
                              <td>
                                <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                  data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                  <a class="dropdown-item addCursor"
                                    (click)="removeCfProductToBoqs(addedproduct.id)">Delete</a>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </div>

                <!--Wardrobe List-->
                <div class="" *ngIf="quotationDetails.shangpin_jobs_wardrobe[selSpaceCF]">
                  <p class="font-weight-bold">Wardrobe List:</p>
                  <ng-container
                    *ngFor="let keyCF of Object.keys(quotationDetails.shangpin_jobs_wardrobe); let m5 =index;">
                    <div *ngIf="keyCF==selSpaceCF" class="tableDiv mt-3 mb-2">
                      <table class="table">
                        <thead class="thead-dark">
                          <tr>
                            <!-- <th class="firstTh">#</th>
                                            <th>ITEM</th>
                                            <th>MODEL NUMBER</th>
                                            <th>ACTUAL SIZE<br>(WxDxH)</th>
                                            <th *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">ADDITIONAL DETAILS</th>
                                            <th>LABEL</th>
                                            <th>COLOR</th>
                                            <th>UNIT PRICE</th>
                                            <th>QUANTITY</th>
                                            <th>AMOUNT</th>
                                            <th class="lastTh"></th> -->
                          </tr>
                        </thead>
                        <ng-container
                          *ngFor="let addedproduct of quotationDetails.shangpin_jobs_wardrobe[keyCF]; let k7=index; ">
                          <tr>
                            <td>{{k7+1}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td
                              *ngIf="addedproduct.imported_file_type=='1DetailedQuoteForm' || addedproduct.imported_file_type=='1DetailedQuoteForm-1'">
                              <span class="specification-sub">Additional Details:</span> <br />Actual Size:
                              {{addedproduct.wardrobe_actual_size || '-'}} <br /> Specification:
                              {{addedproduct.wardrobe_specific_size || '-'}}<br />Core
                              Material:{{addedproduct.core_material || '-'}}</td>
                            <!-- <td><span class="specification-sub">Labels:</span> <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)"> {{label.label_name}}<br/></ng-container><span data-toggle="modal" data-target="#labelList" (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'wardrobe')"><i data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars" style="font-size:1rem;color:#8c0420"></i></span></td> -->
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><span class="specification-sub">Labels:</span>
                              <ng-container *ngFor="let label of addedproduct.labels.slice(0,3)">
                                {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                data-target="#labelList"
                                (click)="this.transferLabelList(keyCF,addedproduct.labels,k7,addedproduct.id,'ShangpinJob',false,0,'wardrobe')"><i
                                  data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                                  style="font-size:1rem;color:#8c0420"></i></span>
                            </td>
                            <td><span class="specification-sub">Amount:</span>&#x20b9;
                              {{addedproduct.wardrobe_amount_factored | number: '.1-2'}}</td>
                            <td>
                              <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="removeCfProductToBoqs(addedproduct.id)">Delete</a>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </table>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!--Excel Type selection Modal-->
          <div class="modal fade" id="selectExcelType" tabindex="-1" role="dialog"
            aria-labelledby="selectExcelTypeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Select The Type Of File Uploaded </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form [formGroup]="deleteSectionToBoqForm">
                    <div class="sectionDiv">
                      <div style="padding-left:1rem;padding-bottom:1rem" class="row"><label><input type="radio"
                            name="file_type" value="1DoorQuoteForm" class="sectionType-class"> <span
                            class="activeselectColor sectionType-class ml-3">1DoorQuoteForm.xlsx</span></label></div>
                      <div style="padding-left:1rem;padding-bottom:1rem" class="row"><label><input type="radio"
                            name="file_type" value="1WardrobeSetQuoteForm" class="sectionType-class"> <span
                            class="activeselectColor sectionType-class ml-3">1WardrobeSetQuoteForm.xlsx</span></label>
                      </div>
                      <div style="padding-left:1rem;padding-bottom:1rem" class="row"><label><input type="radio"
                            name="file_type" value="1DetailedQuoteForm" class="sectionType-class"><span
                            class="activeselectColor sectionType-class ml-3"> 1DetailedQuoteForm.xlsx</span></label>
                      </div>
                      <div style="padding-left:1rem;padding-bottom:1rem" class="row"><label><input type="radio"
                            name="file_type" value="1QuoteForm" class="sectionType-class"><span
                            class="activeselectColor sectionType-class ml-3">1QuoteForm.xlsx</span></label></div>
                      <div style="padding-left:1rem" class="row"><label><input type="radio" name="file_type"
                            value="1DetailedQuoteForm-1" class="sectionType-class"><span
                            class="activeselectColor sectionType-class ml-3">1DetailedQuoteForm-1.xlsx</span></label>
                      </div>
                      <!-- <ng-container ><input type="checkbox" name="sections" value="custom_furniture" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3">  Custom Furniture</span></ng-container> -->
                    </div>
                    <button class="rk-interalBtnColor addCursor pull-right" (click)="uploadCfExcel(selSpaceCF,k5)"
                      [disabled]="basefile==undefined">Upload</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>

  <!-- Services container -->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForSERV">
    <div class="col-md-12 borderbottom pt-3 pb-3">
      <div class="row">
        <div class="col-md-3"><span>Enter Space</span></div>
        <div class="col-md-6">
          <form [formGroup]="addSpaceMWForm">
            <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
              <option value="">Select</option>
              <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
            </select>
            <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'services')">
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-12 pt-3 pb-3" *ngIf="selectedSpacesArrSERV && selectedSpacesArrSERV.length>0">
      <div id="accordionLf">
        <div class="card mb-2" *ngFor="let selSpaceSERV of selectedSpacesArrSERV; let k3=index; ">
          <div class="card-header" id="spaceCardSERV{{k3}}">
            <h5 class="mb-0">
              <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse"
                [attr.data-target]=" '#collapseSpaceCardSERV'+k3" aria-expanded="true" aria-controls="collapseOne">
                {{selSpaceSERV}}
              </button>
              <ng-container *ngFor="let key1 of Object.keys(quotationDetails.space_amounts_services); let n =index; ">
                <span *ngIf="key1==selSpaceSERV" style="font-size: 14px;" class="pull-right">Total - &#8377;
                  {{quotationDetails.space_amounts_services[key1]}}</span></ng-container>
            </h5>

            <div class=" col-md-12 text-right">
              <button data-toggle="modal" data-target="#servicesPackages" (click)="selectedServiceSpace(selSpaceSERV)"
                class="cursor-pointer">Services Package</button>
              <button [attr.data-target]=" '#collapseSpaceCardSERV'+k3" aria-expanded="true" aria-controls="collapseOne"
                (click)="getServiceCategories(k3)" class="cursor-pointer"><span>Add Service</span></button>
              <button (click)="spaceDelete(selSpaceSERV,'services')" class="cursor-pointer">Delete Space</button>
            </div>
          </div>

          <div id="collapseSpaceCardSERV{{k3}}" class="collapse" [attr.aria-labelledby]="'spaceCardSERV'+k3"
            data-parent="#accordionSERV">
            <div class="card-body">

              <div id="addServiceFormRowSERV{{k3}}" class="d-none">
                <h5 class="">Add Service</h5>
                <form [formGroup]="addServiceFormSERV">
                  <br>
                  <div class="row">
                    <div class="col-md-4">
                      <ng-select (change)="getServiceSubCategory($event)" formControlName="category">
                        <ng-option value="">Choose Service Category</ng-option>
                        <ng-option *ngFor="let sc of service_category" value="{{sc.id}}">{{sc.name}}</ng-option>
                      </ng-select>
                    </div>

                    <div class="col-md-4">
                      <ng-select (change)="getServiceActivity($event)" formControlName="sub_category">
                        <ng-option value="">Choose Service SubCategory</ng-option>
                        <ng-option *ngFor="let ssc of service_subcategory" value="{{ssc.id}}">{{ssc.name}}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-md-5">
                      <ng-select formControlName="activity" (change)="chooseActivity($event)">
                        <ng-option value="">Choose Service Activity</ng-option>
                        <ng-option *ngFor="let sa of service_activity" value="{{sa.id}}">{{sa.name}}</ng-option>
                      </ng-select>
                    </div>

                    <div class="col-md-3">
                      <div class="d-inline-block col-md-9 p-0">
                        <input type="text" name="" class="form-control" formControlName="quantity"
                          placeholder="Quantity">
                      </div>
                      <a data-trigger="hover" title="Unit of measurement" class="pop p-0 d-inline-block align-middle"
                        (mouseenter)="openpopup($event)" [attr.data-content]="service_activity_unit">
                        <div class="p-0 text-left">
                          <span class="addCursor" *ngIf="service_activity_unit">{{service_activity_unit}}</span>
                        </div>
                      </a>
                      <br>
                    </div>

                    <div class="col-md-3 p-0">
                      <a data-trigger="hover" title="Base Rate" class="pop p-0 base_amt d-inline-block col-md-6"
                        (mouseenter)="openpopup($event)">
                        <div class="p-0 text-left">
                          <input type="text" name="" class="form-control" formControlName="base_rate"
                            placeholder="Base Rate">
                        </div>
                      </a>
                      <a data-trigger="hover" title="Description"
                        class="pop base_amt d-inline-block col-md-4 align-middle"
                        [attr.data-content]="addServiceFormSERV.controls['description'].value"
                        (mouseenter)="openpopup($event)">
                        <div class="p-0 text-left cursor-pointer"
                          style="display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">
                          <span>{{addServiceFormSERV.controls['description'].value}}</span>
                        </div>
                      </a>
                    </div>

                    <div class="col-md-1">
                      <button [disabled]="!addServiceFormSERV.valid"
                        (click)="addService(addServiceFormSERV.getRawValue(),selSpaceSERV,k3)"
                        class="rk-interalBtnColor cursor-pointer" id="addserviceBtn">ADD</button>
                    </div>
                  </div>
                </form>
                <br>
              </div>


              <!-- <div class="col-md-12 mt-2 text-center" *ngIf="boqServices_all && boqServices_all.length==0 ">
                No service has been added.
              </div> -->
              <!-- For Services Jobs -->
              <div class="" *ngIf="services_service_array && services_service_array[selSpaceSERV].length>0">
                <div class="tableDiv ">
                  <div class="">
                    <p>Service Jobs</p>
                    <table class="table ">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col" class="firstTh">#</th>
                          <th scope="col">ACTIVITY</th>
                          <th scope="col">BASE RATE</th>
                          <th scope="col">QTY</th>
                          <th scope="col">UNIT</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Delivery Timeline</th>
                          <th class="lastTh"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let addedservice of services_service_array[selSpaceSERV]; let i = index; "
                          [attr.data-index]="i">
                          <tr class="box-list" *ngIf="addedservice.space==selSpaceSERV &&  addedservice.quantity>0">
                            <td>{{ i +1 }}</td>
                            <td>{{addedservice.service_activity}}</td>

                            <td>
                              <span class="serviceLineItemSpan{{i}}">{{addedservice.base_rate}}</span>
                              <input type="number" name="" class="form-control d-none serviceLineItemInput{{i}}"
                                [(ngModel)]="editServciceLineBaseRate" min="0"
                                [disabled]="addedservice.disable_base_rate">
                              <!-- <span class="service-edit-mode-off service-edit-mode-off-{{i}}">{{addedservice.base_rate}}</span> -->
                              <!-- <span class="service-edit-mode-on service-edit-mode-on-{{i}}"><input type="number" name="" 
                                                                  [disabled]="addedservice.disable_base_rate" [attr.value] = 'addedservice.base_rate' class="form-control" (change) = "onBasePriceChange(i,$event)" ></span> -->
                            </td>

                            <td>
                              <span class="serviceLineItemSpan{{i}}">{{addedservice.quantity}}</span>
                              <input type="number" name="" class="form-control d-none serviceLineItemInput{{i}}"
                                [(ngModel)]="editServciceLineQty" min="0">
                              <!-- <span class="service-edit-mode-off service-edit-mode-off-{{i}}">{{addedservice.quantity}}</span>
                                                              <span class="service-edit-mode-on service-edit-mode-on-{{i}}">
                                                                 <input type="number" name="" [attr.value] = 'addedservice.quantity' class="form-control" (change) = "onQtyChange(i,$event)">
                                                              </span> -->
                            </td>

                            <td>
                              {{addedservice.unit}}
                            </td>
                            <td>
                              {{addedservice.amount}}
                            </td>
                            <td>
                              <ng-container *ngIf="addedservice.lead_time">
                                {{addedservice.lead_time}}&nbsp;days
                              </ng-container>
                            </td>
                            <td>
                              <button
                                class="d-none serviceLineItemInput{{i}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1"
                                (click)="updateService(addedservice.id)">Update</button>
                              <button class="d-none serviceLineItemInput{{i}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelEditService(i,addedservice)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop serviceLineItemSpan{{i}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor" (click)="editService(i,addedservice)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="servicejobDelete(addedservice.id)">Delete</a>
                              </div>
                              <!--  <img _ngcontent-c8="" src="./assets/img/dashboard/submit.png" (click)="updateService(i)" class="service-edit-mode-on service-edit-mode-on-{{i}} addCursor">
      
                                                              <i class="fa fa-pencil addCursor service-edit-mode-off service-edit-mode-off-{{i}}" id="edit_row{{i}}" (click)="editService(i)"></i>
                                                              <i class="fa fa-close addCursor service-edit-mode-on service-edit-mode-on-{{i}}" id="edit_row{{i}}" (click)="cancelEditService(i)"></i>
      
                                                              <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="servicejobDelete(addedservice.id)"></i> -->
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>

              <!-- For Services Packages -->
              <div *ngIf="services_service_array && services_package_array[selSpaceSERV].length>0">
                <div class="tableDiv ">
                  <div class="">
                    <p>Service Packages</p>
                    <table class="table ">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col" class="firstTh">#</th>
                          <th scope="col">NAME</th>
                          <th scope="col">RATE</th>
                          <th scope="col">QTY</th>
                          <th scope="col">UNIT</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Delivery Timeline</th>
                          <th class="lastTh"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let addedservice of services_package_array[selSpaceSERV]; let i = index; "
                          [attr.data-index]="i">
                          <tr class="box-list" *ngIf="addedservice.space==selSpaceSERV &&  addedservice.quantity>0">
                            <td>{{ i +1 }}</td>
                            <td>{{addedservice.name}}</td>

                            <td>
                              <span class="servicePackageItemsSpan{{i}}">{{addedservice.final_rate}}</span>
                              <input type="number" name="" class="form-control d-none servicePackagesItemInput{{i}}"
                                [(ngModel)]="editServcicePackagesBaseRate" min="0"
                                [disabled]="addedservice.disable_base_rate">
                              <!-- <span class="service-edit-mode-off service-edit-mode-off-{{i}}">{{addedservice.base_rate}}</span> -->
                              <!-- <span class="service-edit-mode-on service-edit-mode-on-{{i}}"><input type="number" name="" 
                                                                [disabled]="addedservice.disable_base_rate" [attr.value] = 'addedservice.base_rate' class="form-control" (change) = "onBasePriceChange(i,$event)" ></span> -->
                            </td>

                            <td>
                              <span class="servicePackagesItemSpan{{i}}">{{addedservice.quantity}}</span>
                              <input type="number" name="" class="form-control d-none servicePackageItemInput{{i}}"
                                [(ngModel)]="editServcicePackagesQty" min="0">
                              <!-- <span class="service-edit-mode-off service-edit-mode-off-{{i}}">{{addedservice.quantity}}</span>
                                                            <span class="service-edit-mode-on service-edit-mode-on-{{i}}">
                                                                <input type="number" name="" [attr.value] = 'addedservice.quantity' class="form-control" (change) = "onQtyChange(i,$event)">
                                                            </span> -->
                            </td>

                            <td>
                              {{addedservice.unit}}
                            </td>
                            <td>
                              {{addedservice.amount}}
                            </td>
                            <td>
                              <ng-container *ngIf="addedservice.lead_time">
                                {{addedservice.lead_time}}&nbsp;days
                              </ng-container>
                            </td>
                            <td>
                              <button
                                class="d-none servicePackageItemInput{{i}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1"
                                (click)="updateServicePackage(addedservice.id)">Update</button>
                              <button class="d-none servicePackageItemInput{{i}} rk-btnCancel addCursor mx-2 mt-1"
                                (click)="cancelEditService(i,addedservice)">Cancel</button>
                              <i class="ion-android-more-vertical  ss-3-dot-drop serviceLineItemSpan{{i}}"
                                data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                                aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="editServicePackages(i,addedservice)">Edit</a>
                                <a class="dropdown-item addCursor"
                                  (click)="servicePackageDelete(addedservice.id)">Delete</a>
                              </div>
                              <!--  <img _ngcontent-c8="" src="./assets/img/dashboard/submit.png" (click)="updateService(i)" class="service-edit-mode-on service-edit-mode-on-{{i}} addCursor">
    
                                                            <i class="fa fa-pencil addCursor service-edit-mode-off service-edit-mode-off-{{i}}" id="edit_row{{i}}" (click)="editService(i)"></i>
                                                            <i class="fa fa-close addCursor service-edit-mode-on service-edit-mode-on-{{i}}" id="edit_row{{i}}" (click)="cancelEditService(i)"></i>
    
                                                            <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="servicejobDelete(addedservice.id)"></i> -->
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right"
      *ngIf="(boqProducts && boqProducts.length>0) || boqServices_all && boqServices_all.length>0">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>

  <!--Custom Elements-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForCustomElem">
    <div class="col-md-12 borderbottom pt-3 pb-3">
      <div class="row">
        <div class="col-md-3"><span>Enter Space</span></div>
        <div class="col-md-6">
          <form [formGroup]="addSpaceMWForm">
            <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
              <option value="">Select</option>
              <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
            </select>
            <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'custom_elements')">
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3" *ngIf=" selectedSpacesArrCustomEle && selectedSpacesArrCustomEle.length>0">
      <div id="accordionCE">
        <div class="card mb-2" *ngFor="let selSpaceCE of selectedSpacesArrCustomEle; let k8=index; ">
          <div class="card-header" id="spaceCardCE{{k8}}">
            <h5 class="mb-0">
              <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse"
                [attr.data-target]=" '#collapseSpaceCardCE'+k8" aria-expanded="true" aria-controls="collapsetwo">
                {{selSpaceCE}}
              </button>
              <ng-container *ngFor="let key4 of Object.keys(quotationDetails.space_amounts_custom); let n1 =index; ">
                <span *ngIf="key4==selSpaceCE" style="font-size: 14px;" class="pull-right">Total - &#8377;
                  {{quotationDetails.space_amounts_custom[key4]}}</span></ng-container>
            </h5>

            <div class="pull-right col-md-12 text-right">
              <button [attr.data-target]=" '#collapseSpaceCardCE'+k8" aria-expanded="true" aria-controls="collapsetwo"
                (click)="displayAddCustomElemForm(k8,'custom_elements')">Add Custom Element</button>
              <button (click)="spaceDelete(selSpaceCE,'custom_elements')">Delete Space</button>
            </div>
          </div>

          <div id="collapseSpaceCardCE{{k8}}" class="collapse" [attr.aria-labelledby]="'spaceCardCE'+k8"
            data-parent="#accordionCE">
            <div class="card-body">
              <div id="addModuleFormRowCE{{k8}}" class="d-none">
                <h5 class="">Add Custom Elements</h5>
                <form [formGroup]="addCustomElemForm">
                  <div class="row">
                    <div class="col-md-3">
                      <select class="form-control capitalize" formControlName="id"
                        (change)="changeCustomElemImage($event.target.value)">
                        <option value="">Choose Custom Element</option>
                        <option *ngFor="let pce of pricedCustomElemArr" value="{{pce | json}}">{{pce.name}}</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <input type="number" name="" class="form-control" placeholder="Enter Quantity"
                        formControlName="qty" min="0">
                    </div>
                    <div class="col-md-3">
                      <img src="http://{{addCustomElemForm.controls['image'].value}}" height="100px" width="100px"
                        onerror="this.src='./assets/img/no_image.svg'" style="display: block;"
                        *ngIf="addCustomElemForm.controls['image'].value!=''" (click)="zoomImg($event.target)"
                        class="addCursor">
                    </div>
                    <div class="col-md-2">
                      <button [disabled]="!addCustomElemForm.valid"
                        (click)="addCustomElem(addCustomElemForm.value,selSpaceCE,'custom_elements',k8)"
                        class="rk-interalBtnColor">ADD</button>
                    </div>
                  </div>
                </form>
              </div>
              <ng-container *ngFor="let key of Object.keys(quotationDetails.custom_jobs); let m1 =index; ">
                <div *ngIf="key==selSpaceCE" class="tableDiv mt-3">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th class="firstTh">#</th>
                        <th>Name</th>
                        <th>Dimension</th>
                        <th>Core Material</th>
                        <th>Label</th>
                        <th>Shutter Finish</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Image</th>
                        <th>Delivery Timeline</th>
                        <th>Category Remark</th>
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let cj of quotationDetails.custom_jobs[key]; let k=index; ">
                        <td>{{k+1}}</td>
                        <td>{{cj.name}}</td>
                        <td>{{cj.dimension}}</td>
                        <td>{{cj.core_material}} </td>
                        <td style="text-align:center">
                          <ng-container *ngFor="let label of cj.labels.slice(0,3)"> {{label.label_name}}<br />
                          </ng-container><span data-toggle="modal" data-target="#labelList"
                            (click)="this.transferLabelList(key,cj.labels,k,cj.id,'CustomJob',false,0,'')"><i
                              data-toggle="tooltip" title="Click to view complete list." class="fa fa-binoculars"
                              style="font-size:1rem;color:#8c0420"></i></span>
                        </td>
                        <td>{{cj.shutter_finish}} </td>
                        <td>
                          <span class="customelemLineItemSpan{{k}}">{{cj.quantity}}</span>
                          <input type="number" name="" class="form-control d-none customelemLineItemInput{{k}}"
                            [(ngModel)]="editCustomElemLineQty">
                        </td>
                        <td>{{cj.amount}}</td>
                        <td>
                          <img src="{{cj.photo}}" height="100px" width="100px"
                            onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="cj.photo"
                            (click)="zoomImg($event.target)" class="addCursor">
                        </td>
                        <td>
                          <ng-container *ngIf="cj.timeline">
                            {{cj.timeline}}&nbsp;days
                          </ng-container>
                        </td>
                        <td style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 0;"
                          title="{{cj.category_remark}}"> {{cj.category_remark}}</td>
                        <td>
                          <button class="d-none customelemLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1"
                            (click)="updateCustomElem(k,cj,'custom_elements')">Update</button>
                          <button class="d-none customelemLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1"
                            (click)="cancelCustomElemLineItem(k,cj)">Cancel</button>
                          <i class="ion-android-more-vertical  ss-3-dot-drop customelemLineItemSpan{{k}}"
                            data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                            aria-expanded="false"></i>
                          <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                            <a class="dropdown-item addCursor" (click)="editcustomelementLineItem(k,cj)">Edit</a>
                            <a class="dropdown-item addCursor" (click)="customelementDelete(cj.id,cj.space)">Delete</a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right"
      *ngIf="globalVarArr  && quotationDetails && (boqConfigMWVal!=undefined && selectedSpacesArr && selectedSpacesArr.length>0 && quotationDetails && Object.keys(quotationDetails.modular_jobs_wardrobe).length>0) || (boqConfigMKVal!=undefined && selectedSpacesArrMK && selectedSpacesArrMK.length>0 && Object.keys(quotationDetails.modular_jobs_kitchen).length>0 || (quotationDetails && Object.keys(quotationDetails.appliance_jobs).length>0) || (quotationDetails && Object.keys(quotationDetails.extra_jobs_wardrobe).length>0)) || ( selectedSpacesArrCustomEle && selectedSpacesArrCustomEle.length>0 && Object.keys(quotationDetails.custom_jobs).length>0)">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>








  <!-- Other Tab Html -->
  <div class="row d-none rowContainer" style="padding: 16px" id="otherRow">
    <div class="col-md-12 borderbottom">
      <button class="addCursor mb-3 mt-3 mx-2 pull-right rk-interalBtnColor" data-toggle="modal"
        data-target="#promoCodeModal" data-backdrop="static" data-keyboard="false"
        *ngIf="promoCode_arry && promoCode_arry.length > 0">
        Add Promotion
      </button>
    </div>

    <div class="col-md-12 pt-3 pb-3" *ngIf="added_promocode_list && added_promocode_list.length > 0">
      <div class="row">
        <div class="col-md-12 text-center font-weight-bold  mb-3" style="font-size: 18px">
          Added Promotion
        </div>
      </div>
      <div class="row" *ngFor="let data of added_promocode_list ; let i = index; ">
        <div class="border col-md-10 mb-2 pb-2 pt-2" style="border-radius: 5px;">
          <div class="row justify-content-center">
            <div class="col-md-12 text-right">
              <i class="fa fa-close addCursor" style="font-size:24px" (click)="deletePromoCode(data.id)"></i>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <img class="img-fluid" src="{{data.promo_image}}" onerror="this.src='./assets/img/noimage.jpg'" />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-6">
                  <span class="font-weight-bold">Promo Code:</span>
                  <span class="">{{data.code}}</span>
                </div>
                <div class="col-md-6">
                  <span class="font-weight-bold">Promo Name:</span>
                  <span class="">{{data.name}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 d-flex">
                  <span class="font-weight-bold">Promo Description: </span>
                  <div class="pop" (mouseenter)="openpopup($event)" title={{data.description}}>
                    {{data.description | slice:0:30}}...
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  d-flex">
                  <span class="font-weight-bold">Promo Use Remarks: </span>
                  <div class="pop" (mouseenter)="openpopup($event)" title={{data.remarks}}>
                    {{data.remarks | slice:0:30}}...
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <span class="font-weight-bold">Promo Value: </span>
                  <span class="">{{data.promo_display_value}}</span>
                </div>
                <div class="col-md-6">
                  <span class="font-weight-bold">Promo Threshold:</span>
                  <span class="">{{data.threshold}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <span class="font-weight-bold">Promo Code Expiry Date:</span>
                  <span class="">{{data.expiry_date ? (data.expiry_date | date:'dd/MM/yyyy') : '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 pt-3 pb-3 text-center font-weight-bold"
      *ngIf="added_promocode_list && added_promocode_list.length == 0" style="font-size: 18px">
      No Promotion Added
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right" *ngIf="quotationDetails">
      <button class="mr-1 addCursor cartBtn" (click)="saveQuotation('draft')">SAVE AS DRAFT </button>
      <button class="addCursor cartBtn" (click)="saveQuotation('pending')">SAVE QUOTATION</button>
    </div>
  </div>
</div>


<!-- The Promo code Modal -->
<div class="modal" id="promoCodeModal">
  <div class="modal-dialog px-2" style="max-width: 60%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title text-center w-100">Add Promotion</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="getPromoCode(1, '');">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="col-md-12 borderbottom pt-3 pb-3 d-flex">
          <div class="ml-auto mr-3 ss-searchbox w-50">
            <i class="fa fa-search" style="font-size: 24px;color: beige;"></i>
            <input class="" id="serachPromo" type="text" placeholder="Search by Promo Code or by Name">
          </div>
          <button class="addCursor h-100 mr-auto mt-4 rk-interalBtnColor" (click)="searchPromo()">GO</button>
        </div>
        <div class="col-md-12 pt-3 pb-3" *ngIf="promoCode_arry && promoCode_arry.length>0">
          <div class="row justify-content-center"
            *ngFor="let data of promoCode_arry | paginate: {id:'promoCodePagination', itemsPerPage: promo_per_page, currentPage: promo_current_page, totalItems: promo_total_page  }">
            <div class="border col-md-10 mb-2 pb-2 pt-2" style="border-radius: 5px;">
              <div class="row">
                <div class="col-md-2">
                  <img class="img-fluid" src="{{data.promo_image}}" onerror="this.src='./assets/img/noimage.jpg'" />
                </div>
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-6">
                      <span class="font-weight-bold">Promo Code:</span>
                      <span class="">{{data.code}}</span>
                    </div>
                    <div class="col-md-6">
                      <span class="font-weight-bold">Promo Name:</span>
                      <span class="text-capitalize">{{data.name}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 d-flex">
                      <span class="font-weight-bold">Promo Description: </span>
                      <div class="pop" (mouseenter)="openpopup($event)" title={{data.description}}>
                        {{data.description | slice:0:30}}..
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 d-flex">
                      <span class="font-weight-bold">Promo Use Remarks: </span>
                      <div class="pop" (mouseenter)="openpopup($event)" title={{data.remarks}}>
                        {{data.remarks | slice:0:30}}...
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="font-weight-bold">Promo Value: create</span>
                      <span class="">{{data.promo_display_value}}</span>
                    </div>
                    <div class="col-md-6">
                      <span class="font-weight-bold">Promo Threshold:</span>
                      <span class="">{{data.threshold}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <span class="font-weight-bold"> Promo Code Expiry Date:</span>
                      <span class="">{{data.expiry_date ? (data.expiry_date | date:'dd/MM/yyyy') : '-' }}</span>
                    </div>
                  </div>
                 
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <button class="addCursor mb-3 mt-3 mx-2 rk-interalBtnColor" (click)="addPromoCode(data.id)">
                        Add Promotion
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center" *ngIf="promoCode_arry && promoCode_arry.length >0">
          <pagination-controls id="promoCodePagination" autoHide="true"
            (pageChange)="promo_current_page = getPromoCode($event,'')">
          </pagination-controls>
        </div>




        <div class="col-md-12 pt-3 pb-3 text-center" *ngIf="promoCode_arry && promoCode_arry.length == 0">
          No Promotion Found
        </div>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="addsectionmodal" tabindex="-1" role="dialog" aria-labelledby="addSectionModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Sections </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="addSectionToBoqForm">
          <div class="sectionDiv">
            <ng-container *ngIf="!selectedSections.includes('modular_wardrobe') && boq_type == 'non_service'"><input type="checkbox" name="sections"
                value="modular_wardrobe" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"> <span
                class="activeselectColor sectionType-class mr-3">Modular Wardrobe</span></ng-container>
            <ng-container *ngIf="!selectedSections.includes('modular_kitchen') && boq_type == 'non_service'"><input type="checkbox" name="sections"
                value="modular_kitchen" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"> <span
                class="activeselectColor sectionType-class mr-3">Modular Kitchen</span></ng-container>
            <ng-container *ngIf="!selectedSections.includes('loose_furniture') && boq_type == 'non_service'"><input type="checkbox" name="sections"
                value="loose_furniture" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span
                class="activeselectColor sectionType-class mr-3"> Loose Furniture</span></ng-container>
            <ng-container *ngIf="!selectedSections.includes('services') && boq_type == 'service'"><input type="checkbox" name="sections"
                value="services" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span
                class="activeselectColor sectionType-class mr-3"> Services</span></ng-container>
            <ng-container *ngIf="!selectedSections.includes('custom_elements')"><input type="checkbox" name="sections"
                value="custom_elements" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span
                class="activeselectColor sectionType-class mr-3"> Custom Elements</span></ng-container>
            <ng-container *ngIf="!selectedSections.includes('custom_furniture') && boq_type == 'non_service'"><input type="checkbox" name="sections"
                value="custom_furniture" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span
                class="activeselectColor sectionType-class mr-3"> Custom Furniture</span></ng-container>
          </div>
          <button class="rk-interalBtnColor addCursor pull-right"
            (click)="submitAddSectionForm(addSectionToBoqForm.value)"
            [disabled]="!addSectionToBoqForm.valid">Create</button>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deletesectionmodal" tabindex="-1" role="dialog" aria-labelledby="deleteSectionModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Delete Sections </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="deleteSectionToBoqForm">
          <div class="sectionDiv">
            <ng-container *ngIf="selectedSections.includes('modular_wardrobe')"><input type="checkbox" name="sections"
                value="modular_wardrobe" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class">
              <span class="activeselectColor sectionType-class mr-3">Modular Wardrobe</span></ng-container>
            <ng-container *ngIf="selectedSections.includes('modular_kitchen')"><input type="checkbox" name="sections"
                value="modular_kitchen" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class">
              <span class="activeselectColor sectionType-class mr-3">Modular Kitchen</span></ng-container>
            <ng-container *ngIf="selectedSections.includes('loose_furniture')"><input type="checkbox" name="sections"
                value="loose_furniture" (change)="onCheckChange2($event,'deletesection')"
                class="sectionType-class"><span class="activeselectColor sectionType-class mr-3"> Loose Furniture</span>
            </ng-container>
            <ng-container *ngIf="selectedSections.includes('services')"><input type="checkbox" name="sections"
                value="services" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class"><span
                class="activeselectColor sectionType-class mr-3"> Services</span></ng-container>
            <ng-container *ngIf="selectedSections.includes('custom_elements')"><input type="checkbox" name="sections"
                value="custom_elements" (change)="onCheckChange2($event,'deletesection')"
                class="sectionType-class"><span class="activeselectColor sectionType-class mr-3"> Custom Elements</span>
            </ng-container>
            <ng-container *ngIf="selectedSections.includes('custom_furniture')"><input type="checkbox" name="sections"
                value="custom_furniture" (change)="onCheckChange2($event,'deletesection')"
                class="sectionType-class"><span class="activeselectColor sectionType-class mr-3"> Custom
                Furniture</span></ng-container>
          </div>
          <button class="rk-interalBtnColor addCursor pull-right"
            (click)="submitdeleteSectionForm(deleteSectionToBoqForm.value)"
            [disabled]="!deleteSectionToBoqForm.valid">Delete</button>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="shadeCodeModal" tabindex="-1" role="dialog" aria-labelledby="shadeCodeModalLabel"
  aria-hidden="true" style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Select Shade Code</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeCodeModals()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mb-2" *ngIf="globalVarArr">
          <div class="col-4"><label>Enter custom shade code</label></div>
          <div class="col-8">
            <input type="text" class="form-control d-inline" placeholder="Enter custom shade code" style="width:54%"
              [(ngModel)]="customshadecode"><button class="rk-interalBtnColor ml-3 addCursor"
              (click)="addCustomShadeCode(globalVarArr.category)" [disabled]="customshadecode==undefined">Add</button>
          </div>
        </div>
        <div class="">
          <hr class="custom-hr hrTag">
        </div>
        <div class="row style-shade" *ngIf="globalVarArr">
          <i *ngIf="showLeft"
            style="margin:auto;font-size:2rem;display:inline-block;vertical-align:text-top;color:#8C031F"
            (click)="prevThree()" class="fas fa-chevron-left"></i>
          <div class="text-center style-highlight-shade"
            *ngFor=" let shadecode of globalVarArr.shutter_shade_code | slice:shadeStartingIndex:shadeEndingIndex">
            <div *ngIf="shadecode.arrivae_select"
              style="background-color: #8C031F;z-index:2;position:absolute;display: block; color: white;width: 10%;border-radius:13%;text-align:center">
              <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
            <img src="{{shadecode.shade_image}}" (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)"
              height="75px" style=" width:100%;height:50%;" *ngIf="shadecode.shade_image"
              onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
            <p (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)" style='font-weight:500'
              class="text-center mt-2 addCursor">{{shadecode.code}}</p>
            <p (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)" class="text-center mt-2 addCursor">
              <span style='color:lightgray ;font-weight:500'>Description:</span> <span
                style='font-weight:300'>{{shadecode.description || 'No Description'}}</span></p>
          </div>
          <i *ngIf="showRight"
            style="margin:auto;font-size:2rem;display:inline-block;vertical-align:text-top;color:#8C031F"
            (click)="nextThree()" class="fas fa-chevron-right"></i>
        </div>
        <div class="row" *ngIf="globalVarArr">
          <div class="col-sm-2 text-center" *ngFor=" let shadecode of globalVarArr.shutter_shade_code">
            <div *ngIf="shadecode.arrivae_select"
              style="background-color: #8C031F;z-index:2;position:relative;top:+0rem;display: block; color: white;width: 30%;border-radius:13%;text-align:center">
              <img style='width:14px;height:14px;position:absolute;left:0;background-color:#8C031F'
                src="/assets/img/Select_logo.png"></div>
            <img src="{{shadecode.shade_image}}" (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)"
              height="75px" style=" width: 100%;" *ngIf="shadecode.shade_image"
              onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
            <p (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)" class="text-center mt-2 addCursor">
              {{shadecode.code}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="edgebandingShadeModal" tabindex="-1" role="dialog"
  aria-labelledby="edgebandingShadeModalLabel" aria-hidden="true" style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Select Edge Banding Shade Code</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeCodeModals()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div> -->
      <!-- <div class="modal-body">
                        <div class="row mb-2" *ngIf="globalVarArr">
                            <div class="col-4"><label>Enter custom edge banding shade code</label></div>
                            <div class="col-8">
                                <input type="text" class="form-control d-inline" placeholder="Enter custom edge banding shade code" style="width:60%" [(ngModel)]="customedgebanshadecode"><button class="rk-interalBtnColor ml-3 addCursor" (click)="addCustomEdgeBanShadeCode(globalVarArr.category)" [disabled]="customedgebanshadecode==undefined">Add</button>
                            </div>
                        </div>
                        <div class="">
                            <hr class="custom-hr hrTag">
                        </div>
                        <div class="row" *ngIf="globalVarArr">
                            <div class="col-sm-2 text-center" *ngFor=" let edgebandingcode of globalVarArr.edge_banding_shade_code" [ngClass]= "{'highlighted-box': (edgebandingcode.code==edgebanding_shade_code_globalVar_MK && globalVarArr.category=='kitchen') || (edgebandingcode.code==edgebanding_shade_code_globalVar_MW && globalVarArr.category=='wardrobe')}">
                                <img src="{{edgebandingcode.shade_image}}" (click)="setImage(edgebandingcode.code,'edgebandingShadeCode',globalVarArr.category)" height="75px" style=" max-width: 100px;" *ngIf="edgebandingcode.shade_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                                <p (click)="setImage(edgebandingcode.code,'edgebandingShadeCode',globalVarArr.category)" class="text-center mt-2 addCursor">{{edgebandingcode.code}}</p>
                            </div>
                        </div>
                    </div> -->
    </div>
  </div>
</div>

<div class="modal fade" id="selectedGlobalVarModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Selected Global Variables</h5>
        <div *ngIf="showArrivaeValueToggle" class="editRowInput" style="display:flex;align-items:center">
          <span>Arrivae Select Only</span>
          <label class="switch">
            <input [(ngModel)]="arrivaeSelectValues" (change)="arrivaeSelectValuesOnly('wardrobe','',boqConfigMWVal)"
              type="checkbox">
            <span class="slider round"></span>
          </label>
        </div>
        <button type="button" (click)="arrivaeSelectValues=false" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <button _ngcontent-c6="" class="rk-interalBtnColor addCursor pull-right my-2 mr-2 editRowSpan"
              (click)="editGlobalVarRow('',boqConfigMWVal)"
              *ngIf="globalVarArr && boqConfigMWVal && boqConfigMWVal.category=='wardrobe' ">Update Global
              Variables</button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Type</th>
                <th></th>
              </tr>
            </thead>
            <!-- Modlar wardrobe-->
            <tbody *ngIf="globalVarArr && boqConfigMWVal && boqConfigMWVal.category=='wardrobe' ">
              <tr>
                <td>1</td>
                <td>Core Material</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMWVal.core_material.name}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Core Material" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="core_material_globalVar_MW"
                      (change)="listofCoreMaterial(core_material_globalVar_MW)">
                      <ng-option value="" selected>
                        Select Core Material
                      </ng-option>
                      <ng-container *ngFor="let coremat of globalVarArr.core_material">
                        <ng-option *ngIf="!coremat.arrivae_select" value="{{coremat.name}}">
                          {{coremat.name}}
                        </ng-option>

                        <ng-option *ngIf="coremat.arrivae_select" value="{{coremat.name}}">
                          {{coremat.name}} {{arrivae_select}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Shutter Material</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMWVal.shutter_material.name}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Shutter Material" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="shutter_material_globalVar_MW"
                      (change)="listofShutterFinishes(shutter_material_globalVar_MW)">
                      <ng-option value="" selected>
                        Select Shutter Material
                      </ng-option>
                      <ng-container *ngFor="let shuttermat of globalVarArr.shutter_materials">
                        <ng-option *ngIf="!shuttermat.arrivae_select" value="{{shuttermat.name}}">
                          {{shuttermat.name}}
                        </ng-option>

                        <ng-option *ngIf="shuttermat.arrivae_select" value="{{shuttermat.name}}">
                          {{shuttermat.name}} {{arrivae_select}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Shutter Finish</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMWVal.shutter_finish.name}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Shutter Finish" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="shutter_finish_globalVar_MW"
                      (change)="listofShutterFinishShades(shutter_finish_globalVar_MW)">
                      <ng-option value="" selected>
                        Select Shutter Finish
                      </ng-option>
                      <ng-container *ngFor="let shutter_fin of globalVarArr.shutter_finish">
                        <ng-option *ngIf="shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                          {{shutter_fin.name}} {{arrivae_select}}
                        </ng-option>

                        <ng-option *ngIf="!shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                          {{shutter_fin.name}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td> Shutter Shade Code</td>
                <td>
                  <span class="editRowSpan capitalize"
                    *ngIf="!boqConfigMWVal.custom_shutter_shade_code">{{boqConfigMWVal.shutter_shade_code.code}}</span>
                  <span class="editRowSpan capitalize"
                    *ngIf="boqConfigMWVal.custom_shutter_shade_code">{{boqConfigMWVal.shutter_shade_code}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Shutter Shade Code" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="shutter_shade_code_globalVar_MW"
                      (change)="setImageModal($event.target.value,'shadeCode',globalVarArr.category)">
                      <ng-option value="" selected>
                        Shutter Shade Code
                      </ng-option>
                      <ng-container *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code">
                        <ng-option *ngIf="!shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                          {{shuttershadecode.code}}
                        </ng-option>

                        <ng-option *ngIf="shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                          {{shuttershadecode.code}} {{arrivae_select}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                  <input type="text" name="" class="form-control d-none editRowInput my-1"
                    [(ngModel)]="shutter_custshade_code_globalVar_MW" placeholder="Enter custom shade code"
                    [disabled]="shutter_shade_code_globalVar_MW!='customshadecode'">
                  <img src="{{boqConfigMWVal.shutter_shade_code.shade_image}}" class="my-1 editRowSpan addCursor"
                    alt=" No Image" height="60px" width="100px"
                    *ngIf="!boqConfigMWVal.custom_shutter_shade_code && boqConfigMWVal.shutter_shade_code.shade_image"
                    onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModal')" />
                  <img src="{{shadeImgMW}}" class="my-1 d-none editRowInput addCursor" alt=" No Image" height="60px"
                    width="100px" *ngIf="shadeImgMW" onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModal')" />
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Shutter Handle Code</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMWVal.shutter_handle_code}}</span>
                  <a data-toggle="modal" data-target="#addhandleModal" class="addCursor d-none editRowInput"
                    style="color: blue;"
                    (click)="openHandleModal('wardrobe','shutter','',shutter_finish_globalVar_MW,false)">Choose Shutter
                    Handle code</a><br>
                  <img src="{{shutterhandleImg}}" class="my-1 d-none editRowInput addCursor" height="60px" width="100px"
                    *ngIf="shutterhandleImg" onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModal')" /> <span
                    class="ml-2 d-none editRowInput">{{shutter_handle_code_globalVar_MW}}</span>
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Drawer Handle Code</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMWVal.door_handle_code}}</span>
                  <a data-toggle="modal" data-target="#addhandleModal" class="addCursor d-none editRowInput"
                    style="color: blue;"
                    (click)="openHandleModal('wardrobe','drawer','',shutter_finish_globalVar_MW,false)">Choose Drawer
                    Handle code</a><br>
                  <img src="{{doorhandleImgMw}}" class="my-1 d-none editRowInput addCursor" height="60px" width="100px"
                    *ngIf="doorhandleImgMw" onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModal')" /> <span
                    class="ml-2 d-none editRowInput">{{door_handle_code_globalVar_MW}}</span>
                </td>
              </tr>
              <!-- <tr>
                               <td>7</td>
                               <td>Hardware Brand</td>
                               <td>
                                   <span *ngIf="boqConfigMWVal && boqConfigMWVal.brand" class="editRowSpan capitalize">{{boqConfigMWVal.brand.name}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="hardware_brand_globalVar_MW">
                                        <option value="">Select</option>
                                        <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                    </select>
                               </td>
                            </tr> -->
              <tr [ngClass]="{'d-none':(globalVarArr.modspace == true)}">
                <td>7</td>
                <td> Hinge Type</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMWVal.hinge_type}}</span>
                  <select class="form-control d-none editRowInput" [(ngModel)]="hinge_type_globalVar_MW">
                    <option value="">Select</option>
                    <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span
                        *ngIf="ht=='soft'"> - CLOSE</span></option>
                  </select>
                </td>
              </tr>
              <!-- <tr>
                               <td>9</td>
                               <td> Channel Type</td>
                               <td>
                                   <span class="editRowSpan capitalize">{{boqConfigMWVal.channel_type}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="channel_type_globalVar_MW">
                                        <option value="">Select</option>
                                        <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                    </select>
                               </td>
                            </tr> -->
              <!-- <tr>
                               <td>10</td>
                               <td> Edge Banding Shade</td>
                               <td>
                                   <span class="editRowSpan capitalize" *ngIf="!boqConfigMWVal.custom_edge_banding_shade_code">{{boqConfigMWVal.edge_banding_shade_code.code}}</span>
                                   <span class="editRowSpan capitalize" *ngIf="boqConfigMWVal.custom_edge_banding_shade_code">{{boqConfigMWVal.edge_banding_shade_code}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="edgebanding_shade_code_globalVar_MW" (change)="setImageModal($event.target.value,'edgebandingShadeCode',globalVarArr.category)">
                                        <option value="">Select</option>
                                        <option value="customedgebanshadecode">Custom edge banding shade code</option>
                                        <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}" [selected]="edgebanding_shade_code_globalVar_MW==ebsc.code">{{ebsc.code}}</option>
                                    </select>
                                    <input type="text" name="" class="form-control d-none editRowInput my-1" [(ngModel)]="edgebanding_custshade_code_globalVar_MW" placeholder="Enter custom edge banding shade code" [disabled]="edgebanding_shade_code_globalVar_MW!='customedgebanshadecode'">
                                    <img src="{{boqConfigMWVal.edge_banding_shade_code.shade_image}}" class="my-1 editRowSpan addCursor" alt=" No Image" height="60px" width="100px" *ngIf="!boqConfigMWVal.custom_edge_banding_shade_code && boqConfigMWVal.edge_banding_shade_code.shade_image" onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target,'#selectedGlobalVarModal')"/>
                                    <img src="{{edgebandingImgMW}}" class="my-1 d-none editRowInput addCursor" alt=" No Image" height="60px" width="100px" *ngIf="edgebandingImgMW" onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target,'#selectedGlobalVarModal')"/>
                               </td>
                            </tr> -->
            </tbody>
          </table>
          <div class="row editRowInput d-none"
            *ngIf="globalVarArr && boqConfigMWVal && boqConfigMWVal.category=='wardrobe' ">
            <div class="col-sm-12 text-right">
              <button class=" rk-btnCancel my-2"
                (click)="cancelEditGlobalVarRow('',boqConfigMWVal.category)">Cancel</button>
              <button class="pull-right rk-interalBtnColor mr-2 my-2"
                (click)="updateGlobalVar('',boqConfigMWVal.id,boqConfigMWVal.category)">Save</button>
              <button class="pull-right rk-interalBtnColor mr-2 my-2"
                (click)="updateAndApplyBoqGlobalConfig('',boqConfigMWVal.id,boqConfigMWVal.category)">Save and
                Apply</button>
              <button class="pull-right rk-interalBtnColor mr-2 my-2"
                (click)="openPresetModal(null,'wardrobe','update','#selectedGlobalVarModal')">Save As Preset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="selectedGlobalVarModalMK" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Selected Global Variables</h5>
        <div *ngIf="showArrivaeValueToggle" class="editRowInput" style="display:flex;align-items:center">
          <span>Arrivae Select Only</span>
          <label class="switch">
            <input [(ngModel)]="arrivaeSelectValues" (change)="arrivaeSelectValuesOnly('kitchen','',boqConfigMKVal)"
              type="checkbox">
            <span class="slider round"></span>
          </label>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="cancelEditGlobalVarRow('',boqConfigMKVal.category);arrivaeSelectValues=false">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <button _ngcontent-c6="" class="rk-interalBtnColor addCursor pull-right my-2 mr-2 editRowSpan"
              (click)="editGlobalVarRow('',boqConfigMKVal)"
              *ngIf="globalVarArr && boqConfigMKVal && boqConfigMKVal.category=='kitchen' ">Update Global
              Variables</button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Type</th>
                <th></th>
              </tr>
            </thead>

            <!--Modular kitchen-->
            <tbody *ngIf="globalVarArr && boqConfigMKVal && boqConfigMKVal.category=='kitchen' ">
              <tr>
                <td>1</td>
                <td>Type Of Kitchen</td>
                <td>
                  <span class="editRowSpan capitalize">
                    <ng-container *ngIf="boqConfigMKVal.civil_kitchen">Civil Kitchen</ng-container>
                    <ng-container *ngIf="!boqConfigMKVal.civil_kitchen">Modular Kitchen</ng-container>
                  </span>
                  <select class="form-control d-none editRowInput" [(ngModel)]="typeofkitchen_globalVar_MK">
                    <option value="">Select</option>
                    <option value="true">Civil Kitchen</option>
                    <option value="false">Modular Kitchen</option>
                  </select>
                </td>
              </tr>
              <tr
                [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                <td>2</td>
                <td>Depth(in mm)</td>
                <td>
                  <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                    {{ boqConfigMKVal.civil_kitchen_parameters.depth}}
                  </span>
                  <input type="number" name="" class="form-control d-none editRowInput"
                    [(ngModel)]="depthofcivilKit_globalVar_MK">
                </td>
              </tr>
              <tr
                [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                <td>3</td>
                <td>Drawer 1 Height in mm(D1)</td>
                <td>
                  <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                    {{ boqConfigMKVal.civil_kitchen_parameters.drawer_height_1}}
                  </span>
                  <input type="number" name="" class="form-control d-none editRowInput"
                    [(ngModel)]="drawerheight1ofcivilKit_globalVar_MK">
                </td>
              </tr>
              <tr
                [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                <td>4</td>
                <td>Drawer 2 Height in mm(D2)</td>
                <td>
                  <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                    {{ boqConfigMKVal.civil_kitchen_parameters.drawer_height_2}}
                  </span>
                  <input type="number" name="" class="form-control d-none editRowInput"
                    [(ngModel)]="drawerheight2ofcivilKit_globalVar_MK">
                </td>
              </tr>
              <tr
                [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                <td>5</td>
                <td>Drawer 3 Height in mm(D3)</td>
                <td>
                  <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                    {{ boqConfigMKVal.civil_kitchen_parameters.drawer_height_3}}
                  </span>
                  <input type="number" name="" class="form-control d-none editRowInput"
                    [(ngModel)]="drawerheight3ofcivilKit_globalVar_MK">
                </td>
              </tr>
              <tr>
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">6</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">2</td>
                <td>Core Material</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.core_material.name}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Core Material" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="core_material_globalVar_MK"
                      (change)="listofCoreMaterial(core_material_globalVar_MK)">
                      <ng-option value="" selected>
                        Select
                      </ng-option>
                      <ng-container *ngFor="let coremat of globalVarArr.core_material">
                        <ng-option *ngIf="!coremat.arrivae_select" value="{{coremat.name}}">
                          {{coremat.name}}
                        </ng-option>

                        <ng-option *ngIf="coremat.arrivae_select" value="{{coremat.name}}">
                          {{coremat.name}} {{arrivae_select}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">7</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">3</td>
                <td>Shutter Material</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.shutter_material.name}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Shutter Material" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="shutter_material_globalVar_MK"
                      (change)="listofShutterFinishes(shutter_material_globalVar_MK)">
                      <ng-option value="" selected>
                        Select
                      </ng-option>
                      <ng-container *ngFor="let shuttermat of globalVarArr.shutter_materials">
                        <ng-option *ngIf="!shuttermat.arrivae_select" value="{{shuttermat.name}}">
                          {{shuttermat.name}}
                        </ng-option>

                        <ng-option *ngIf="shuttermat.arrivae_select" value="{{shuttermat.name}}">
                          {{shuttermat.name}} {{arrivae_select}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">8</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">4</td>
                <td>Shutter Finish</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.shutter_finish.name}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Shutter Finish" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="shutter_finish_globalVar_MK"
                      (change)="listofShutterFinishShades(shutter_finish_globalVar_MK)">
                      <ng-option value="" selected>
                        Select
                      </ng-option>
                      <ng-container *ngFor="let shutter_fin of globalVarArr.shutter_finish">
                        <ng-option *ngIf="shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                          {{shutter_fin.name}} {{arrivae_select}}
                        </ng-option>

                        <ng-option *ngIf="!shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                          {{shutter_fin.name}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">9</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">5</td>
                <td> Shutter Shade Code</td>
                <td>
                  <span class="editRowSpan capitalize"
                    *ngIf="!boqConfigMKVal.custom_shutter_shade_code">{{boqConfigMKVal.shutter_shade_code.code}}</span>
                  <span class="editRowSpan capitalize"
                    *ngIf="boqConfigMKVal.custom_shutter_shade_code">{{boqConfigMKVal.shutter_shade_code}}</span>
                  <div class="d-none editRowInput">
                    <ng-select placeholder="Shutter Shade Code" class="form-control border-0 pl-0 pr-0"
                      [(ngModel)]="shutter_shade_code_globalVar_MK"
                      (change)="setImageModal($event.target.value,'shadeCode',globalVarArr.category)">
                      <ng-option value="" selected>
                        Custom shade code
                      </ng-option>
                      <ng-container *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code">
                        <ng-option *ngIf="!shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                          {{shuttershadecode.code}}
                        </ng-option>

                        <ng-option *ngIf="shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                          {{shuttershadecode.code}} {{arrivae_select}}
                        </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>

                  <input type="text" name="" class="form-control d-none editRowInput my-1"
                    [(ngModel)]="shutter_custshade_code_globalVar_MK" placeholder="Enter custom shade code"
                    [disabled]="shutter_shade_code_globalVar_MK!='customshadecode'">
                  <img src="{{boqConfigMKVal.shutter_shade_code.shade_image}}" class="my-1 editRowSpan addCursor"
                    alt=" No Image" height="60px" width="100px"
                    *ngIf="!boqConfigMKVal.custom_shutter_shade_code && boqConfigMKVal.shutter_shade_code.shade_image"
                    onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModalMK')" />
                  <img src="{{shadeImg}}" class="my-1 editRowInput d-none addCursor" alt=" No Image" height="60px"
                    width="100px" *ngIf="shadeImg" onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModalMK')" />
                </td>
              </tr>
              <tr>
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">10</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">6</td>
                <td> Handle Code</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.door_handle_code}}</span>
                  <a data-toggle="modal" data-target="#addhandleModal" class="addCursor d-none editRowInput"
                    style="color: blue;"
                    (click)="openHandleModal('kitchen','drawer','',shutter_finish_globalVar_MK,false)">Choose Handle
                    code</a><br>
                  <img src="{{doorhandleImg}}" class="my-1 d-none editRowInput addCursor" height="60px" width="100px"
                    *ngIf="doorhandleImg" onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#selectedGlobalVarModalMK')" /> <span
                    class="ml-2 d-none editRowInput">{{door_handle_code_globalVar_MK}}</span>
                </td>
              </tr>
              <!-- <tr>
                                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">11</td>
                               <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">7</td>
                               <td>Hardware Brand</td>
                               <td>
                                   <span *ngIf="boqConfigMKVal.brand" class="editRowSpan capitalize">{{boqConfigMKVal.brand.name}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="hardware_brand_globalVar_MK">
                                        <option value="">Select</option>
                                        <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                    </select>
                               </td>
                            </tr> -->
              <tr>
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">11</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">7</td>
                <td> Hinge Type</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.hinge_type}}</span>
                  <select class="form-control d-none editRowInput" [(ngModel)]="hinge_type_globalVar_MK">
                    <option value="">Select</option>
                    <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span
                        *ngIf="ht=='soft'"> - CLOSE</span></option>
                  </select>
                </td>
              </tr>
              <!-- <tr>
                                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">13</td>
                               <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">9</td>
                               <td> Channel Type</td>
                               <td>
                                   <span class="editRowSpan capitalize">{{boqConfigMKVal.channel_type}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="channel_type_globalVar_MK">
                                        <option value="">Select</option>
                                        <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                    </select>
                               </td>
                            </tr> -->
              <tr [ngClass]="{'d-none':(globalVarArr.modspace == true)}">
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">12</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">8</td>
                <td> Skirting Config Type</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.skirting_config_type}}</span>
                  <select class="form-control d-none editRowInput" [(ngModel)]="skirting_con_type_globalVar_MK"
                    (change)="listofSkirtingHeights(skirting_con_type_globalVar_MK)">
                    <option value="">Select</option>
                    <option *ngFor="let sct of globalVarArr.skirting_config_type" value="{{sct.skirting_type}}">
                      {{sct.skirting_type | uppercase}}</option>
                  </select>
                </td>
              </tr>
              <tr [ngClass]="{'d-none':(globalVarArr.modspace == true)}">
                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">13</td>
                <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">9</td>
                <td> Skirting Config Height</td>
                <td>
                  <span class="editRowSpan capitalize">{{boqConfigMKVal.skirting_config_height}}</span>
                  <select class="form-control d-none editRowInput" [(ngModel)]="skirting_con_height_globalVar_MK">
                    <option value="">Select</option>
                    <option *ngFor="let sch of globalVarArr.skirting_config_height" value="{{sch.skirting_height}}">
                      {{sch.skirting_height}}</option>
                  </select>
                </td>
              </tr>
              <!-- <tr>
                                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">16</td>
                               <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">12</td>
                               <td> Edge Banding Shade</td>
                               <td>
                                   <span class="editRowSpan capitalize" *ngIf="!boqConfigMKVal.custom_edge_banding_shade_code">{{boqConfigMKVal.edge_banding_shade_code.code}}</span>
                                   <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.custom_edge_banding_shade_code">{{boqConfigMKVal.edge_banding_shade_code}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="edgebanding_shade_code_globalVar_MK" (change)="setImageModal($event.target.value,'edgebandingShadeCode',globalVarArr.category)">
                                        <option value="">Select</option>
                                        <option value="customedgebanshadecode">Custom edge banding shade code</option>
                                        <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}" [selected]="edgebanding_shade_code_globalVar_MK==ebsc.code">{{ebsc.code}}</option>
                                    </select>
                                    <input type="text" name="" class="form-control d-none editRowInput my-1" [(ngModel)]="edgebanding_custshade_code_globalVar_MK" placeholder="Enter custom edge banding shade code" [disabled]="edgebanding_shade_code_globalVar_MK!='customedgebanshadecode'">
                                    <img src="{{boqConfigMKVal.edge_banding_shade_code.shade_image}}" class="my-1 editRowSpan addCursor" alt=" No Image" height="60px" width="100px" *ngIf="!boqConfigMKVal.custom_edge_banding_shade_code && boqConfigMKVal.edge_banding_shade_code.shade_image" onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target,'#selectedGlobalVarModalMK')"/>
                                    <img src="{{edgebandingImg}}" class="my-1 editRowInput d-none addCursor" alt=" No Image" height="60px" width="100px" *ngIf="edgebandingImg" onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target,'#selectedGlobalVarModalMK')" />
                               </td>
                            </tr> -->
              <!-- <tr>
                                <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">17</td>
                               <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">13</td>
                               <td> Countertop</td>
                               <td>
                                   <span class="editRowSpan capitalize">{{boqConfigMKVal.countertop | replaceChar}}</span>
                                   <select class="form-control d-none editRowInput" [(ngModel)]="countertop_globalVar_MK">
                                        <option value="">Select</option>
                                        <option *ngFor="let count_top of globalVarArr.countertop" value="{{count_top}}" [selected]="countertop_globalVar_MK==count_top">{{count_top | replaceChar}}</option>
                                    </select>
                               </td>
                            </tr> -->
            </tbody>
          </table>
          <div class="row editRowInput d-none"
            *ngIf="globalVarArr && boqConfigMKVal && boqConfigMKVal.category=='kitchen' ">
            <div class="col-sm-12 text-right">
              <button class=" rk-btnCancel my-2"
                (click)="cancelEditGlobalVarRow('',boqConfigMKVal.category)">Cancel</button>
              <button class="pull-right rk-interalBtnColor mr-2 my-2"
                (click)="updateGlobalVar('',boqConfigMKVal.id,boqConfigMKVal.category)">Save</button>
              <button class="pull-right rk-interalBtnColor mr-2 my-2"
                (click)="updateAndApplyBoqGlobalConfig('',boqConfigMKVal.id,boqConfigMKVal.category)">Save and
                Apply</button>
              <button class="pull-right rk-interalBtnColor mr-2 my-2"
                (click)="openPresetModal(null,'kitchen','update','#selectedGlobalVarModalMK')">Save As Preset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="customizationModal" tabindex="-1" role="dialog" aria-labelledby="customizationModalLable"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="exampleModalLabel">Customize Elements</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="globalVarArr && customizationModule_MW_details">
        <form [formGroup]="customizationModule_MW_Form">
          <div class="row">
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('core_material')}">
              <label>Core Material</label>
              <select class="form-control" formControlName="core_material"
                (change)="listofCoreMaterial($event.target.value,addGlobalVariableForm)">
                <option value="">Select</option>
                <!-- <option  *ngIf="!coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}</option>
                                <option *ngIf="coremat.arrivae_select" style="background-color:#8C031F;" value="{{coremat.name}}">{{coremat.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae Select)</span></option>
                                <option *ngFor="let coremat of globalVarArr.core_material" value="{{coremat.name}}">{{coremat.name}}</option> -->
                <ng-container *ngFor="let coremat of globalVarArr.core_material">
                  <option *ngIf="!coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}</option>
                  <option *ngIf="coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}&nbsp;&nbsp;<span
                      style="font-size:10px;float:right;">(Arrivae Select)</span></option>
                </ng-container>
              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_material')}">
              <label>Shutter Material</label>
              <select class="form-control" formControlName="shutter_material"
                (change)="listofShutterFinishes($event.target.value)">
                <option value="">Select</option>
                <!-- <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option> -->
                <ng-container *ngFor="let shuttermat of globalVarArr.shutter_materials">
                  <option *ngIf="!shuttermat.arrivae_select" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                  <option *ngIf="shuttermat.arrivae_select" value="{{shuttermat.name}}">
                    {{shuttermat.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae Select)</span>
                  </option>
                </ng-container>
              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_finish')}">
              <label>Shutter Finish</label>
              <select class="form-control" formControlName="shutter_finish"
                (change)="listofShutterFinishShades($event.target.value)">
                <option value="">Select</option>
                <ng-container *ngFor="let shutter_fin of globalVarArr.shutter_finish">
                  <option *ngIf="shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                    {{shutter_fin.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae Select)</span>
                  </option>
                  <option *ngIf="!shutter_fin.arrivae_select" value="{{shutter_fin.name}}">{{shutter_fin.name}}</option>
                </ng-container>

              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_shade_code')}">
              <label>Shutter Shade Code</label>
              <select class="form-control" formControlName="shutter_shade_code"
                (change)="onchangeOfCustomizationShade($event.target.value,'shade','wardrobe')">
                <option value="">Select</option>
                <option value="customshadecode">Custom shade code</option>
                <!-- <option *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code" value="{{shuttershadecode.code}}">{{shuttershadecode.code}}</option> -->
                <ng-container *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code">
                  <option *ngIf="!shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                    {{shuttershadecode.code}}</option>
                  <option *ngIf="shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                    {{shuttershadecode.code}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae
                      Select)</span></option>
                </ng-container>
              </select>
              <input type="text" name="" class="form-control my-1" formControlName="cust_shutter_shade_code"
                placeholder="Enter custom shade code">
            </div>
            <!-- <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('edge_banding_shade_code')}">
                            <label>Edge Banding Shade Code</label>
                            <select class="form-control" formControlName="edge_banding_shade_code" (change)="onchangeOfCustomizationShade($event.target.value,'edgeband','wardrobe')">
                                <option value="">Select</option>
                                <option value="customedgebanshadecode">Custom edge banding shade code</option>
                                <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}">{{ebsc.code}}</option>
                            </select>
                            <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code">
                        </div> -->
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_handle_code')}">
              <label>Shutter Handle Code</label>
              <input type="text" name="" class="form-control" readonly formControlName="shutter_handle_code">
              <a data-toggle="modal" data-target="#addhandleModal" class="addCursor" style="color: blue;"
                (click)="openHandleModal('wardrobe','shutter',customizationModule_MW_details.product_module_id,customizationModule_MW_Form.controls['shutter_finish'].value,true)">Choose
                Shutter Handle Code</a><br>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('door_handle_code')}">
              <label>Drawer Handle Code</label>

              <input type="text" name="" class="form-control" readonly formControlName="door_handle_code">
              <a data-toggle="modal" data-target="#addhandleModal" class="addCursor" style="color: blue;"
                (click)=" openHandleModal('wardrobe','drawer',customizationModule_MW_details.product_module_id,customizationModule_MW_Form.controls['shutter_finish'].value,true)">Choose
                Drawer Handle Code</a><br>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('hinge_type')||(globalVarArr.modspace == true)}">
              <label>Hinge Type</label>
              <select class="form-control" formControlName="hinge_type">
                <option value="">Select</option>
                <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span
                    *ngIf="ht=='soft'"> - CLOSE</span></option>
              </select>
            </div>
            <!-- <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('channel_type')}">
                            <label>Channel Type</label>
                            <select class="form-control" formControlName="channel_type">
                                <option value="">Select</option>
                                <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                            </select>
                        </div> -->
            <!-- <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('hardware_brand_id')}">
                            <label>Hardware Brand</label>
                            <select class="form-control" formControlName="hardware_brand">
                                <option value="">Select</option>
                                <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                            </select>
                        </div> -->
            <div class="col-md-6 mt-2" *ngIf="customizationModule_MW_details"
              [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('number_exposed_sites')}">
              <label>Number Exposed Sites</label>
              <select class="form-control" formControlName="number_exposed_sites">
                <option>Select</option>
                <option *ngFor="let item3 of customizationModule_MW_details.allowed_number_exposed_sites"
                  value="{{item3}}">{{item3}}</option>
              </select>
            </div>
            <div class="col-md-12 mt-2" *ngIf="customizationModule_MW_details">
              <fieldset formArrayName="addons">
                <div class="form-group row"
                  *ngFor="let item of customizationModule_MW_Form.get('addons')['controls']; let i_1=index "
                  [formGroup]="item">
                  <div class="col-sm-4">
                    <label [attr.for]="'addon'+i_1">Addon </label>
                    <select class="form-control" [attr.id]="'addon'+i_1" formControlName="id"
                      (change)="customization_addon_dropdownChange($event.target.value,i_1,'MW')">
                      <option>Select</option>
                      <option *ngFor="let item_1 of customizationModule_MW_details.allowed_addons"
                        value="{{item_1.id}}">{{item_1.name}} - {{item_1.code}}</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <label [attr.for]="'addon-quantity'+i_1">Quantity</label>
                    <input type="number" class="form-control" [attr.id]="'addon-quantity'+i_1"
                      formControlName="quantity">
                  </div>
                  <div class="col-sm-3">
                    <label [attr.for]="'addon-image'+i_1">Image</label>
                    <img
                      src="http://{{getformArray(customizationModule_MW_Form,'addons').controls[i_1]['controls'].image.value}}"
                      height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'"
                      style="display: block;"
                      *ngIf="getformArray(customizationModule_MW_Form,'addons').controls[i_1]['controls'].image.value!=''"
                      (click)="zoomImg($event.target,'#customizationModal')" class="addCursor">
                  </div>
                  <div class="col-sm-1 py-1">
                    <i class="fa fa-minus nestedRemoveBtn"
                      (click)="customizationModule_MW_Form.get('addons').removeAt(i_1)"></i>
                  </div>
                </div>
              </fieldset>
              <a (click)="getAddonTags(); getOptionalAddons('wardrobe');" class="mb-2 addCursor"
                style="color: blue;padding-left:2%" data-toggle="modal" data-target="#addoptionalAddonModal"><i
                  class="fa fa-plus"> </i> Add Addons</a>
            </div>
            <div class="col-md-12">
              <button (click)="updateCustomization(customizationModule_MW_Form.value,'wardrobe')"
                class="cartBtn pull-right">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="customizationModalMk" tabindex="-1" role="dialog"
  aria-labelledby="customizationModalMkLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static"
  style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="exampleModalLabel">Customize Elements</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="globalVarArr && customizationModule_MK_details">
        <form [formGroup]="customizationModule_MK_Form">
          <div class="row">
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('core_material')}">
              <label>Core Material</label>
              <select class="form-control" formControlName="core_material"
                (change)="listofCoreMaterial($event.target.value,addGlobalVariableForm)">
                <option value="">Select</option>
                <ng-container *ngFor="let coremat of globalVarArr.core_material">
                  <option *ngIf="!coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}</option>
                  <option *ngIf="coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}&nbsp;&nbsp;<span
                      style="font-size:10px;float:right;">(Arrivae Select)</span></option>
                </ng-container>
              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('shutter_material')}">
              <label>Shutter Material</label>

              <select class="form-control" formControlName="shutter_material"
                (change)="listofShutterFinishes($event.target.value)">
                <option value="">Select</option>
                <ng-container *ngFor="let shuttermat of globalVarArr.shutter_materials">
                  <option *ngIf="!shuttermat.arrivae_select" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                  <option *ngIf="shuttermat.arrivae_select" value="{{shuttermat.name}}">
                    {{shuttermat.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae Select)</span>
                  </option>
                </ng-container>


              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('shutter_finish')}">
              <label>Shutter Finish</label>

              <select class="form-control" formControlName="shutter_finish"
                (change)="listofShutterFinishShades($event.target.value);">
                <option value="">Select</option>
                <ng-container *ngFor="let shutter_fin of globalVarArr.shutter_finish">
                  <option *ngIf="shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                    {{shutter_fin.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae Select)</span>
                  </option>
                  <option *ngIf="!shutter_fin.arrivae_select" value="{{shutter_fin.name}}">{{shutter_fin.name}}</option>
                </ng-container>

              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('shutter_shade_code')}">
              <label>Shutter Shade Code</label>

              <select class="form-control" formControlName="shutter_shade_code"
                (change)="onchangeOfCustomizationShade($event.target.value,'shade','kitchen')">
                <option value="">Select</option>
                <option value="customshadecode">Custom shade code</option>
                <ng-container *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code">
                  <option *ngIf="!shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                    {{shuttershadecode.code}}</option>
                  <option *ngIf="shuttershadecode.arrivae_select" value="{{shuttershadecode.code}}">
                    {{shuttershadecode.code}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae
                      Select)</span></option>
                </ng-container>
                <!-- <option *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code" value="{{shuttershadecode.code}}">{{shuttershadecode.code}}</option> -->
              </select>
              <input type="text" name="" class="form-control my-1" formControlName="cust_shutter_shade_code"
                placeholder="Enter custom shade code">

            </div>
            <!-- <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('edge_banding_shade_code')}">
                                <label>Edge Banding Shade Code</label>
                                <input type="text" name="" class="form-control" formControlName="edge_banding_shade_code" readonly *ngIf="!editBtnFlag">
                                <select class="form-control" formControlName="edge_banding_shade_code" *ngIf="editBtnFlag" (change)="onchangeOfCustomizationShade($event.target.value,'edgeband','kitchen')">
                                    <option value="">Select</option>
                                    <option value="customedgebanshadecode">Custom edge banding shade code</option>
                                    <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}">{{ebsc.code}}</option>
                                </select>
                                <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code" readonly *ngIf="!editBtnFlag">
                                <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code" *ngIf="editBtnFlag">
                            </div> -->
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('door_handle_code')}">
              <label>Handle Code</label>
              <input type="text" name="" class="form-control" formControlName="door_handle_code" readonly>
              <a data-toggle="modal" data-target="#addhandleModal" class="addCursor" style="color: blue;"
                (click)="openHandleModal('kitchen','drawer',customizationModule_MK_details.product_module_id,customizationModule_MK_Form.controls['shutter_finish'].value,true)">Choose
                Handle Code</a><br>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('hinge_type') ||(globalVarArr.modspace == true)}">
              <label>Hinge Type</label>

              <select class="form-control" formControlName="hinge_type">
                <option value="">Select</option>
                <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span
                    *ngIf="ht=='soft'"> - CLOSE</span></option>
              </select>
            </div>
            <!-- <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('channel_type')}">
                                <label>Channel Type</label>
                                
                                <select class="form-control" formControlName="channel_type" >
                                    <option value="">Select</option>
                                    <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                </select>
                            </div> -->
            <!-- <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('hardware_brand_id')}">
                                <label>Hardware Brand</label>
                                <input type="text" name="" class="form-control" formControlName="hardware_brand" readonly *ngIf="!editBtnFlag">
                                <select class="form-control" formControlName="hardware_brand" *ngIf="editBtnFlag">
                                    <option value="">Select</option>
                                    <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                </select>
                            </div> -->
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('skirting_config_type') || (globalVarArr.modspace == true)}">
              <label>Skirting Config Type</label>

              <select class="form-control" formControlName="skirting_config_type"
                (change)="listofSkirtingHeights($event.target.value)">
                <option value="">Select</option>
                <option *ngFor="let sct of globalVarArr.skirting_config_type" value="{{sct.skirting_type}}">
                  {{sct.skirting_type | uppercase}}</option>
              </select>
            </div>
            <div class="col-md-6 mt-2"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('skirting_config_height')|| (globalVarArr.modspace == true)}">
              <label>Skirting Config Height</label>

              <select class="form-control" formControlName="skirting_config_height">
                <option value="">Select</option>
                <option *ngFor="let sch of globalVarArr.skirting_config_height" value="{{sch.skirting_height}}">
                  {{sch.skirting_height}}</option>
              </select>
            </div>
            <div class="col-md-6 mt-2" *ngIf="customizationModule_MK_details"
              [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('number_exposed_sites')}">
              <label>Number Exposed Sites</label>

              <select class="form-control" formControlName="number_exposed_sites">
                <option>Select</option>
                <option *ngFor="let item3 of customizationModule_MK_details.allowed_number_exposed_sites"
                  value="{{item3}}">{{item3}}</option>
              </select>
            </div>
            <div class="col-md-12 mt-2" *ngIf="customizationModule_MK_details">
              <fieldset formArrayName="compulsory_addons" class="mx-3">
                <div class="form-group row fieldsetBorder"
                  *ngFor="let item2 of customizationModule_MK_Form.get('compulsory_addons')['controls']; let i=index "
                  [formGroup]="item2">
                  <ng-container
                    *ngIf="!customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].combination.value">
                    <div class="col-sm-4">
                      <label [attr.for]="'compaddon-slot'+i">Slot *</label>
                      <input type="text" name="" formControlName="slot" class="form-control"
                        [attr.id]="'compaddon-slot'+i" readonly>
                    </div>
                    <div class="col-sm-4">
                      <label [attr.for]="'compaddon'+i">Addon *</label>
                      <textarea formControlName="name" class="form-control" [attr.id]="'compaddon'+i"
                        readonly=""></textarea>
                      <a data-toggle="modal" data-target="#addAddonModal"
                        (click)="getAddonTags(); getCompulsoryAddons(customizationModule_MK_details.product_module_id,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].slot.value,i); openAddAddonModal('compaddon')"
                        class="d-block addCursor link-color mt-2" *ngIf="editBtnFlag">Choose Addon</a>
                    </div>
                    <div class="col-sm-4">
                      <label [attr.for]="'compaddon-quantity'+i">Quantity*</label>
                      <input type="number" class="form-control" [attr.id]="'compaddon-quantity'+i"
                        formControlName="quantity" readonly>
                    </div>
                    <div class="col-sm-4">
                      <label [attr.for]="'compaddon-image'+i">Image</label>
                      <img
                        src="http://{{getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].image.value}}"
                        height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'"
                        style="display: block;"
                        *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].image.value!=''"
                        (click)="zoomImg($event.target,'#customizationModalMk')" class="addCursor">
                    </div>
                    <a data-toggle="modal" data-target="#addAddonModal"
                      (click)="getAddonTags(); getCompulsoryAddons(customizationModule_MK_details.product_module_id,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].slot.value,i); openAddAddonModal('compaddon')"
                      class="d-block addCursor link-color mt-2">Choose Addon </a>
                  </ng-container>

                  <ng-container
                    *ngIf="customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].combination.value">
                    <div style="width:100%;margin:0">
                      <h6 style="color:black"><span
                          style="color:lightGray">Slot:</span>{{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].slot.value}}
                      </h6><br>
                      <h6 style="color:black"><span style="color:lightGray">Add On:</span>
                        {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].name.value}}
                      </h6><br>
                      <h6 style="color:black ; display:inline"><span style="color:lightGray">Quantity:</span>
                        {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].quantity.value}}
                      </h6>
                      <h6 style="color:black;float:right"><span style="color:lightGray">Price:</span>
                        {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].included_mrp.value | currency:"₹ ":0 }}
                      </h6>
                      <ng-container
                        *ngFor="let combinationAddon of this.customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].addons.value">
                        <div class="comb-addon">
                          <div><img src="http://{{combinationAddon.addon_image}}" height="100px" width="100px"
                              onerror="this.src='./assets/img/no_image.svg'" style="display: block;"
                              *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].image.value!=''"
                              (click)="zoomImg($event.target,'#customizationModalMk')" class="addCursor"></div>
                          <div style="width:30%"><span style="font-size:18px">{{combinationAddon.code}}</span> <br>
                            <span style="color:lightgray">Description:&nbsp;</span>{{combinationAddon.name}}</div>
                          <div style="width:20%"><span style="color:lightgray">Vendor
                              SKU:&nbsp;</span>{{combinationAddon.vendor_sku}}<br> <span
                              style="color:lightgray">Brand:&nbsp;</span>{{combinationAddon.brand_name}} </div>
                          <div style="min-width:5%!important;font-weight:500">Qty:&nbsp;{{combinationAddon.quantity}}
                          </div>
                          <div style="font-weight:500">{{combinationAddon.mrp | currency:"₹ ":0}}</div>
                        </div>
                      </ng-container>
                    </div>
                    <a style="padding-left:84%" data-toggle="modal" data-target="#addAddonModal"
                      (click)="getAddonTags(); getCompulsoryAddons(customizationModule_MK_details.product_module_id,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].slot.value,i); openAddAddonModal('compaddon')"
                      class="d-block addCursor link-color mt-2">Choose Addon </a>
                  </ng-container>

                  <div class="col-sm-12 mt-3">
                    <ng-container
                      *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls.length>0">
                      <h5 style="font-size:1rem;color:gray"> Optional Addons for Addon: </h5>
                      <ng-container class="addon-for-addon-box">
                        <fieldset formArrayName="addons_for_addons">
                          <div class="form-group row"
                            *ngFor="let item_2 of getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls; let i9=index "
                            [formGroup]="item_2">
                            <!-- {{getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addon_image.value | Json}} -->
                            <ng-container
                              *ngIf="!getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].combination.value">
                              <div class="col-sm-4">
                                <label [attr.for]="'addonforaddon'+i9">Addon *</label>
                                <textarea formControlName="name" class="form-control" [attr.id]="'addonforaddon'+i9"
                                  disabled readonly></textarea>
                              </div>
                              <div class="col-sm-2">
                                <label [attr.for]="'addonforaddon-quantity'+i9">Quantity*</label>
                                <input type="number" class="form-control" [attr.id]="'addonforaddon-quantity'+i9"
                                  formControlName="quantity" *ngIf="editBtnFlag">
                                <input type="number" class="form-control" [attr.id]="'addonforaddon-quantity'+i9"
                                  formControlName="quantity" readonly *ngIf="!editBtnFlag">

                              </div>
                              <div class="col-sm-3">
                                <label [attr.for]="'addonforaddon-image'+i9">Image</label>
                                <img
                                  src="http://{{ getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addon_image.value}}"
                                  height="80px" width="80px" onerror="this.src='./assets/img/no_image.svg'"
                                  style="display: block;"
                                  *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addon_image.value!=''"
                                  (click)="zoomImg($event.target,'#customizationModalMk')" class="addCursor">
                              </div>
                            </ng-container>
                            <!-- {{getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].combination.value}} -->
                            <!-- {{getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addons.value}} -->
                            <ng-container class="addon-for-addon-div"
                              *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].combination.value">
                              <h6 style="color:black;width:100%;margin-top:3%;margin-bottom:3%"><span
                                  style="color:lightGray">Add On:</span>
                                {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].name.value}}
                              </h6>
                              <h6 style="color:black;width:20%"><span style="color:lightGray">Quantity:</span>
                                {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].quantity.value}}
                              </h6>
                              <h6 style="color:black;width:30%"><span style="color:lightGray">Price:</span>
                                {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].included_mrp.value | currency:"₹ ":0 }}
                              </h6>
                              <h6 style="color:black;width:50%"><span style="color:lightGray">Total Price:</span>
                                {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].included_mrp.value * customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].quantity.value | currency:"₹ ":0 }}
                              </h6>
                              <ng-container
                                *ngFor="let combinationAddon of getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addons.value">
                                <hr>

                                <div class="comb-addon">
                                  <div><img src="http://{{combinationAddon.addon_image}}" height="100px" width="100px"
                                      onerror="this.src='./assets/img/no_image.svg'" style="display: block;"
                                      *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].image.value!=''"
                                      (click)="zoomImg($event.target,'#customizationModalMk')" class="addCursor"></div>
                                  <div style="width:30%"><span style="font-size:18px">{{combinationAddon.code}}</span>
                                    <br> <span
                                      style="color:lightgray">Description:&nbsp;</span>{{combinationAddon.name}}</div>
                                  <div style="width:20%"><span style="color:lightgray;min-width:15%">Vendor
                                      SKU:&nbsp;</span>{{combinationAddon.vendor_sku}}<br> <span
                                      style="color:lightgray">Brand:&nbsp;</span>{{combinationAddon.brand_name}} </div>
                                  <div style="min-width:5%!important;font-weight:500">Qty:{{combinationAddon.quantity}}
                                  </div>
                                  <div style="font-weight:500">{{combinationAddon.mrp| currency:"₹ ":0}}</div>
                                </div>
                              </ng-container>


                            </ng-container>


                            <div style='margin-left:90%' class="col-sm-1 py-1">
                              <i class="fa fa-minus nestedRemoveBtn"
                                (click)="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.removeAt(i9)"></i>
                            </div>
                          </div>

                        </fieldset>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="col-sm-12">
                    <a *ngIf="customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].name && customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].name.value "
                      (click)="getAddonTags(); getListofAddonsForAddons(getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].id.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].combination.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].slot.value,i); openAddAddonModal('addonforaddon');"
                      class="mb-2 addCursor d-block" style="color: blue;" data-toggle="modal"
                      data-target="#addAddonModal"><i class="fa fa-plus"> </i> Add Optional Addons </a>
                  </div>
                  <!--Addon for addons-->
                </div>
              </fieldset>
            </div>
            <ng-container *ngIf="customizationModule_MK_details">
              <div class="col-md-12 mt-1" *ngIf="customizationModule_MK_Form.get('addons')['controls'].length>0"
                style="border:1px solid lightgray">
                <fieldset style="margin:2%" formArrayName="addons">
                  <h5 style="font-size:1rem;color:gray"> Optional Addons for Section: </h5>
                  <div class="form-group row"
                    *ngFor="let item of customizationModule_MK_Form.get('addons')['controls']; let i=index "
                    [formGroup]="item">
                    <ng-container *ngIf="!item.value.combination">
                      <div class="col-sm-4">
                        <label [attr.for]="'addon'+i">Addon </label>
                        <textarea class="form-control" [attr.id]="'addon'+i" formControlName="name" readonly></textarea>
                      </div>
                      <div class="col-sm-4">
                        <label [attr.for]="'addon-quantity'+i">Quantity</label>
                        <input type="number" class="form-control" [attr.id]="'addon-quantity'+i"
                          formControlName="quantity" *ngIf="!editBtnFlag" readonly>
                        <input type="number" class="form-control" [attr.id]="'addon-quantity'+i"
                          formControlName="quantity" *ngIf="editBtnFlag">
                      </div>
                      <div class="col-sm-3">
                        <label [attr.for]="'addon-image'+i">Image</label>
                        <img
                          src="http://{{getformArray(customizationModule_MK_Form,'addons').controls[i]['controls'].image.value}}"
                          height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'"
                          style="display: block;"
                          *ngIf="getformArray(customizationModule_MK_Form,'addons').controls[i]['controls'].image.value!=''"
                          (click)="zoomImg($event.target,'#customizationModalMk')" class="addCursor">
                      </div>
                      <div class="col-sm-1 py-1">
                        <i class="fa fa-minus nestedRemoveBtn"
                          (click)="customizationModule_MK_Form.get('addons').removeAt(i)"></i>
                        <i style="cursor:pointer" class="fa fa-minus nestedRemoveBtn"
                          (click)="customizationModule_MK_Form.get('addons').removeAt(i)"></i>
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group row"
                    *ngFor="let item of customizationModule_MK_Form.get('addons')['controls']; let i=index "
                    [formGroup]="item">
                    <ng-container>
                      <div *ngIf="customizationModule_MK_Form.get('addons').controls[i]['controls'].combination.value"
                        style="width:100%;margin:0;border:1px solid lightgray">

                        <!-- <h6 style="color:black"><span style="color:lightGray">Add On:</span> {{customizationModule_MK_Form.get('compulsory_addons').controls[i]['controls'].name.value}} </h6><br> -->

                        <ng-container
                          *ngIf="customizationModule_MK_Form.get('addons').controls[i]['controls'].combination.value">
                          <div style="margin-left:2%;">
                            <h6 style="color:black;width:100%;margin-top:3%;margin-bottom:3%"><span
                                style="color:lightGray">Add On:</span>
                              {{customizationModule_MK_Form.get('addons').controls[i]['controls'].name.value}}</h6>
                            <h6 style="color:black;width:20%;"><span style="color:lightGray">Quantity:</span>
                              {{customizationModule_MK_Form.get('addons').controls[i]['controls'].quantity.value}}</h6>
                            <h6 style="color:black;width:30%"><span style="color:lightGray">Price:</span>
                              {{customizationModule_MK_Form.get('addons').controls[i]['controls'].included_mrp.value | currency:"₹ ":0 }}
                            </h6>
                            <h6 style="color:black;width:50%"><span style="color:lightGray">Total Price:</span>
                              {{customizationModule_MK_Form.get('addons').controls[i]['controls'].included_mrp.value * customizationModule_MK_Form.get('addons').controls[i]['controls'].quantity.value | currency:"₹ ":0 }}
                            </h6>
                          </div>
                          <ng-container
                            *ngFor="let combinationAddon of this.customizationModule_MK_Form.get('addons').controls[i]['controls'].addons.value">
                            <!-- <ng-container *ngIf="!combinationAddon.slot.value"> -->
                            <!-- <ng-container *ngIf="!combinationAddon.compulsory_addon_id.value"> -->

                            <div class="comb-addon">
                              <div><img src="http://{{combinationAddon.addon_image}}" height="100px" width="100px"
                                  onerror="this.src='./assets/img/no_image.svg'" style="display: block;"
                                  *ngIf="combinationAddon.addon_image"
                                  (click)="zoomImg($event.target,'#customizationModalMk')" class="addCursor"></div>
                              <div style="width:30%"><span style="font-size:18px">{{combinationAddon.code}}</span> <br>
                                <span style="color:lightgray">Description:&nbsp;</span>{{combinationAddon.name}}</div>
                              <div style="width:20%"><span style="color:lightgray">Vendor
                                  SKU:&nbsp;</span>{{combinationAddon.vendor_sku}}<br> <span
                                  style="color:lightgray">Brand:&nbsp;</span>{{combinationAddon.brand_name}} </div>
                              <div style="min-width:5%!important;font-weight:500">Qty:{{combinationAddon.quantity}}
                              </div>
                              <div style="font-weight:500">{{combinationAddon.mrp | currency:"₹ ":0}}</div>
                            </div>
                            <!-- </ng-container> -->
                            <!-- </ng-container> -->
                          </ng-container>
                        </ng-container>
                        <div style="min-width:100%;text-align:right" class="col-sm-1 py-1">
                          <i class="fa fa-minus nestedRemoveBtn"
                            (click)="customizationModule_MK_Form.get('addons').removeAt(i)"></i>
                          <span style="color:#8c031f;cursor:pointer"
                            (click)="customizationModule_MK_Form.get('addons').removeAt(i)">Remove</span>
                        </div>
                      </div>
                    </ng-container>


                  </div>
                </fieldset>
              </div>
              <a (click)="getAddonTags(); getOptionalAddons('kitchen');" class="mb-2 addCursor"
                style="color: blue;padding-left:2%" data-toggle="modal" data-target="#addoptionalAddonModal"><i
                  class="fa fa-plus"> </i> Add Addons</a>

            </ng-container>
            <!-- <pre>{{customizationModule_MK_Form.value | json}}</pre> -->
            <div class="col-md-12">
              <button (click)="updateCustomization(customizationModule_MK_Form.value,'kitchen')"
                class="cartBtn pull-right">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>






<!--Combined Modules modal-->
<div class="modal fade" id="combinedmodulesModal" tabindex="-1" role="dialog"
  aria-labelledby="combinedmodulesModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Combined Modules</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="combinemodalData=undefined">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="combinedModulesForm">
          <div class="row">
            <div class="col-sm-6">
              <label>Description<span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="description">
            </div>
            <div class="col-sm-6">
              <label>Space<span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="space" readonly>
            </div>
            <div class="col-sm-12 mt-4">
              <label>Modules<span class="text-danger">*</span></label><br />
              <ng-container *ngFor="let sw of combinemodalData">
                <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngIf="sw.combined==false">
                  <input type="checkbox" class="form-check-input" value="{{sw.id}}" (change)="onCheckChange($event)">
                  {{sw.code}}
                </label>
              </ng-container><br />
              <span class="text-danger">Note*- Atleaset two modules need to be selected.</span>
            </div>
            <div class="col-sm-12 mt-4">
              <label>Combined Door<span class="text-danger">*</span></label>
              <select class="form-control" formControlName="combined_door_id">
                <option value="">Select Combined Door</option>
                <option *ngFor="let cd of combined_doors" value="{{cd.id}}">{{cd.name}} - {{cd.code}}</option>
              </select>
            </div>
            <div class="col-sm-12 mt-2">
              <button class="rk-interalBtnColor pull-right" (click)="combineModules(combinedModulesForm.value)"
                [disabled]="!combinedModulesForm.valid || !(getformArray(combinedModulesForm,'modular_job_ids').length>=2)">Combine</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editCombineModuleModal" tabindex="-1" role="dialog"
  aria-labelledby="editCombineModuleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Combined Modules</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="combinemodalData=undefined">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="combinedModulesForm">
          <div class="row">
            <div class="col-sm-6">
              <label>Description<span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="description">
            </div>
            <div class="col-sm-6">
              <label>Space<span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="space" readonly>
            </div>
            <div class="col-sm-12 mt-4">
              <label>Modules<span class="text-danger">*</span></label><br />
              <ng-container *ngFor="let sw of combinemodalData">
                <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngIf="sw.combined==false">
                  <input type="checkbox" class="form-check-input" value="{{sw.id}}" (change)="onCheckChange($event)">
                  {{sw.code}}
                </label>
                <ng-container *ngIf="sw.combined==true">
                  <ng-container *ngFor="let data2 of sw.included_modules">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4"
                      *ngIf="data2.combined_module_id==sw.id">
                      <input type="checkbox" class="form-check-input" value="{{data2.id}}"
                        (change)="onCheckChange($event)"
                        [checked]="checkValInFormArray(data2.id,combinedModulesForm,'modular_job_ids')">
                      {{data2.code}}
                    </label>
                  </ng-container>
                </ng-container>
              </ng-container><br />

              <span class="text-danger">Note*- Atleaset two modules need to be selected.</span>
            </div>
            <div class="col-sm-12 mt-4">
              <label>Combined Door<span class="text-danger">*</span></label>
              <select class="form-control" formControlName="combined_door_id">
                <option value="">Select Combined Door</option>
                <option *ngFor="let cd of combined_doors" value="{{cd.id}}">{{cd.name}} - {{cd.code}}</option>
              </select>
            </div>
            <div class="col-sm-12 mt-2">
              <button class="rk-interalBtnColor pull-right"
                (click)="editcombineModules(combinedModulesForm.value,editCombineModuleId)"
                [disabled]="!combinedModulesForm.valid || !(getformArray(combinedModulesForm,'modular_job_ids').length>=2)">Combine</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="ui-notification" *ngIf="notificationAlert">
  <span id="notificationMessageText">{{product_notify_message}}</span>
  <a class="close linknotification" (click)="notificationAlert=false">×</a>
</div>

<!-- add product Modal -->
<div class="modal fade" id="addProductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="ui-notification" *ngIf="notificationAlert">
    <span id="notificationMessageText">{{product_notify_message}}</span>
    <a class="close linknotification" (click)="notificationAlert=false">×</a>
  </div>
  <div class="modal-dialog my-2 mx-2" role="document">

    <div class="modal-content" *ngIf="all_product_activated">

      <div class="modal-body pt-0" style="min-height: 100vh;background: #f5f5f5;">
        <!-- Product code start -->

        <div class="row container-set container-set-change">
          <div class="col-6">
            <div class="ss-searchbox">
              <i class="fa fa-search float-right"></i>
              <input class="form-control" type="text" placeholder="Search by SKU"
                (keydown.enter)="searchTextFilter($event)">

            </div>
          </div>
          <div class="col-3 mt-3">
            <label class="switche" (change)="updatePolka($event)" for="togBtn"><input type="checkbox" id="togBtn">
              <div class="slidere round"></div>
            </label>
          </div>
          <div class="col-md-3">
            <button aria-label="Close" class="close-change cursor-pointer pull-right" data-dismiss="modal" type="button"
              (click)="closeModal()" style="outline: none;">
              <img src="../../../assets/img/cross-out.svg" style="width:13px;">
            </button>
          </div>
        </div>
        <nav class="row navbar navbar-expand-lg navbar-light bg-white">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto ul-ff" *ngIf="catalog_segments.length > 0" style="padding-left:1.2rem;">
              <li class="nav-item dropdown" (click)="curtainActiveHandler()">
                <a class="nav-link dropdown-toggle cursor-pointer" role="button" >Curtains</a>
              </li>
              <li class="nav-item dropdown" *ngFor="let segment of catalog_segments"
                (click)="activateSegment('segment', segment.id)">
                <a class="nav-link dropdown-toggle cursor-pointer" id="navbarDropdown-{{segment.id}}" role="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{segment.segment_name}}
                </a>
                <div class="subnavlist lt dropdown-menu" *ngIf="segment"dropdown-menu dropdown-menu-right lt marketProductMenuDropDown subnavlist>
                  <div class="subnavlist_wrapper clearfix">
                    <ul class="inline-list left" *ngFor="let category of segment.categories">
                      <li class="sublist_item">
                        <div class="taxontype cursor-pointer"
                          style="font-size: 14px;font-family: 'Source Sans Pro', sans-serif;font-weight: 600;color: #231f20;margin-bottom: 10px;"
                          (click)="activateSegment('category', category.id)">
                          {{category.category_name}}
                        </div>
                        <ul class="taxonslist">
                          <li class="subnav_item" *ngFor="let subcategory of category.subcategories"
                            (click)="activateSubCategory('product', subcategory.id, $event)"><span
                              class="pl-2 cursor-pointer">{{subcategory.subcategory_name}}</span></li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle cursor-pointer" id="marketplacenavbarDropdown" role="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Marketplace
                </a>
                <div class="subnavlist lt dropdown-menu dropdown-menu-right">
                  <div class="subnavlist_wrapper clearfix d-flex" style="flex-direction: row-reverse;">
                    <div class="float-right">
                      <ul>
                        <li *ngFor="let market of marketplace" (mouseover)="getMarketplacecategories(market)"
                          class="sublist_item">
                          <div class="taxontype cursor-pointer"
                            style="font-size: 14px;font-family: 'Source Sans Pro', sans-serif;font-weight: 600;color: #231f20;margin-bottom: 10px;">
                            {{market.segment_name}}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="float-left width80">
                      <ul class="inline-list" style="margin-right: 1rem;"
                        *ngFor="let category of marketplace_submenu_categories">
                        <li class="sublist_item">
                          <div class="taxontype cursor-pointer"
                            style="font-size: 14px;font-family: 'Source Sans Pro', sans-serif;font-weight: 600;color: #231f20;margin-bottom: 10px;margin: 0 10px 10px 7px;"
                            (click)="activateSegment('category', category.id)">
                            {{category.category_name}}
                          </div>
                          <ul class="taxonslist">
                            <li *ngFor="let subcategory of category.subcategories" class="subnav_item cursor-pointer"
                              style="font-size: 14px;font-family: 'Source Sans Pro', sans-serif;color: #707070;"
                              (click)="activateSubCategory('product', subcategory.id, $event)">
                              {{subcategory.subcategory_name}}</li>
                          </ul>
                        </li>
                        <!-- <li  class="subnav_item">
                                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" *ngIf="segment">
                                      {{segment.segment_name}}
                                    </a>
                                  </li> -->
                      </ul>
                    </div>

                  </div>

                </div>
              </li>
            </ul>
          </div>

        </nav>

        <app-show-curtain-list [spacevalue]="selectedSpaceForModal" [searchvalue]="search_string" *ngIf="curtainActive" (notifycatalogue)="getNotification($event)"></app-show-curtain-list>
        <ng-container *ngIf="!curtainActive">
        <div class="black-borderSeparator"></div>
        <div class="row bg-white" style="padding: 1% 0% 1% 4%;">
          <div class="col-12">
            <div class="row">
              <div class="col-7">
                <label class="labels" style="padding-left:3.5%;">FILTERS</label>
              </div>
              <div class="col-3">
                <label class="labels" style="padding-left:1.5%;">SORT BY</label>
              </div>
              <div class="col-2 text-right">
                <div class="float-right cursor-pointer" (click)="fetchSavedProducts()">
                  <i class="fa fa-heart saved-products-heart;"
                    style="color: #8c051e;float: left;margin-right: 7px;margin-top: 4px;" aria-hidden="true"></i>
                  <label class="saved-products-heart-label cursor-pointer">Saved Products</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-7 d-flex">
                <div class="px-2 py-2">
                  <div class="dropdown wrapper-dropdown-1">
                    <div class="dropdown-toggle" id="pricedropdownMenu" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      Price
                      <!-- <i class="far fa-angle-down" style="font: normal normal normal 14px/1 FontAwesome;"></i> -->
                    </div>
                    <div class="dropdown-menu" aria-labelledby="pricedropdownMenu" style="padding: 10px;">
                      <h6 _ngcontent-c6="" style="font-size: 12px;color: #231f20;">Price(INR)</h6>
                      <ion-range-slider class="dropdown-item" #priceSliderElement type="double"
                        [min]="master_minimum_price" [max]="master_maximum_price" [from]="master_minimum_price"
                        [from_min]="master_minimum_price" [from_max]="(master_maximum_price)-1" from_shadow="true"
                        [to]="master_maximum_price" [to_min]="master_minimum_price+1" [to_max]="master_maximum_price"
                        to_shadow="true" grid="false" prefix=" " postfix=" " decorate_both="false"
                        (onFinish)="updateNewSlider('price',advancedSlider, $event)">
                      </ion-range-slider>
                      <!-- <button class="dropdown-item" type="button">Action</button> -->
                    </div>
                  </div>

                </div>
                <div class="px-2 py-2">
                  <div class="dropdown wrapper-dropdown-1">
                    <div class="dropdown-toggle" data-toggle="dropdown">Class
                      <!-- <i class="far fa-angle-down" style="font: normal normal normal 14px/1 FontAwesome;"></i> -->
                    </div>
                    <ul class="dropdown-menu dd-dropdown px-2 py-2" style="margin-top: -0.2rem;">
                      <h6 _ngcontent-c6="" style="font-size: 12px;color: #231f20;">Class</h6>

                      <li class="my-2" *ngFor="let clas of filter_classes">
                        <input name="opt" type="checkbox" value="" id="opt1" class="mr-2 cursor-pointer"
                          (change)="updateFilterClass(clas.id,$event)">
                        <label class="checkbox-container ffssansp ffclr" style="font-size: 16px;">{{clas.name}}</label>
                      </li>

                    </ul>
                  </div>
                </div>
                <div class="px-2 py-2">
                  <div class="dropdown wrapper-dropdown-1">
                    <div class="dropdown-toggle" id="leadtimedropdownMenu" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      Lead Time
                      <!-- <i class="far fa-angle-down" style="font: normal normal normal 14px/1 FontAwesome;"></i> -->
                    </div>
                    <div class="dropdown-menu" aria-labelledby="leadtimedropdownMenu" style="padding: 10px;">
                      <h6 _ngcontent-c6="" style="font-size: 12px;color: #231f20;">Lead Time(Day)</h6>
                      <ion-range-slider #leadtimeSliderElement type="double" [min]="master_minimum_lead_time"
                        [max]="master_maximum_lead_time" [from]="master_minimum_lead_time" from_shadow="true"
                        [to]="master_maximum_lead_time" to_shadow="true" grid="false" prefix=" " postfix=" "
                        decorate_both="false" (onFinish)="updateNewSlider('lead_time',advancedSlider, $event)">
                      </ion-range-slider>
                    </div>
                  </div>
                </div>
                <div class="px-2 py-2">
                  <div class="dropdown wrapper-dropdown-1">
                    <div class="dropdown-toggle" id="dimensiondropdownMenu" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      Dimensions
                      <!-- <i class="far fa-angle-down" style="font: normal normal normal 14px/1 FontAwesome;"></i> -->
                    </div>
                    <div class="dropdown-menu" aria-labelledby="dimensiondropdownMenu" style="padding: 10px;">
                      <h6 _ngcontent-c6="" style="font-size: 12px;color: #231f20;">Dimensions(mm)</h6>
                      <h6 style="font-size: 11px;color: #6d6567;">Width:</h6>
                      <ion-range-slider #widthSliderElement type="double" [min]="master_minimum_width"
                        [max]="master_maximum_width" [from]="master_minimum_width" [from_min]="master_minimum_width"
                        [from_max]="(master_maximum_width)-1" from_shadow="true" [to]="master_maximum_width"
                        [to_min]="master_minimum_width+1" [to_max]="master_maximum_width" to_shadow="true" grid="false"
                        prefix=" " postfix=" " decorate_both="false"
                        (onFinish)="updateNewSlider('width',advancedSlider, $event)">
                      </ion-range-slider>
                      <h6 style="font-size: 11px;color: #6d6567;">Length:</h6>
                      <ion-range-slider #depthSliderElement type="double" [min]="master_minimum_length"
                        [max]="master_maximum_length" [from]="master_minimum_length" [from_min]="master_minimum_length"
                        [from_max]="(master_maximum_length)-1" from_shadow="true" [to]="master_maximum_length"
                        [to_min]="master_minimum_length+1" [to_max]="master_maximum_length" to_shadow="true"
                        grid="false" prefix=" " postfix=" " decorate_both="false"
                        (onFinish)="updateNewSlider('length',advancedSlider, $event)">
                      </ion-range-slider>
                      <h6 style="font-size: 11px;color: #6d6567;">Height:</h6>
                      <ion-range-slider #heightSliderElement type="double" [min]="master_minimum_height"
                        [max]="master_maximum_height" [from]="master_minimum_height" [from_min]="master_minimum_height"
                        [from_max]="(master_maximum_height)-1" from_shadow="true" [to]="master_maximum_height"
                        [to_min]="master_minimum_height+1" [to_max]="master_maximum_height" to_shadow="true"
                        grid="false" prefix=" " postfix=" " decorate_both="false"
                        (onFinish)="updateNewSlider('height',advancedSlider, $event)">
                      </ion-range-slider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="px-2 py-2">
                  <div class="dropdown wrapper-dropdown-1">
                    <div class="dropdown-toggle sort-toggle" data-toggle="dropdown">Popularity
                      <span class="caret"></span></div>
                    <ul class="dropdown-menu dd-dropdown-sort-price px-2 py-2" style="margin-top: -0.2rem;">
                      <p>Sorting</p>
                      <li class="my-2">
                        <div class="checkbox-container" (click)="sortFilter('popularity')">Popularity</div>
                      </li>
                      <li class="my-2">
                        <div class="checkbox-container" (click)="sortFilter('price_low_to_high')">Price: Low to High
                        </div>
                      </li>
                      <li class="my-2">
                        <div class="checkbox-container" (click)="sortFilter('price_high_to_low')">Price: High to Low
                        </div>
                      </li>
                      <li class="my-2">
                        <div class="checkbox-container" (click)="sortFilter('newest_first')">Newest First</div>
                      </li>
                      <li class="my-2">
                        <div class="checkbox-container" (click)="sortFilter('none')">None</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-2 text-right">
                <p class="cursor-pointer" (click)="clearAll()"
                  style="color:#8f0020;text-align: right;font-size: .8rem;">Clear All</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 ml-5 mr-5" *ngIf="products_array.length > 0">
          <div class="col-md-3 px-2 py-2"
            *ngFor="let product of products_array | paginate: {id:'productsarrayPagination', itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  };let i = index">
            <div class="card addCursor {{product.new_product ? 'new' : ''}}">
              <div class="su-img-container">
                <img class="su-product-card-img" src="{{product.image_url}}"
                  onerror="this.src='./assets/img/noimage.jpg'" (click)="activateProduct_details(product.id, $event)"
                  id="prod-img-{{i}}">
              </div>
              <div class="row px-2 pt-2">
                <div class="col-sm-7 catlogue-product-name" title="{{product.name}}">
                  {{product.name}}
                </div>
                <div class="col-sm-5">
                  <span style="font-size: 11px;color: #6d6567;">
                    Units Sold:
                  </span>
                  <span style="font-family: Roboto;font-size: 11px;font-weight: 500;color: #231f20;">
                    {{product.units_sold}}
                  </span>
                </div>
              </div>
              <div class="row p-2">
                <div class="col-sm-7 catlogue-product-price">
                  Rs.{{product.sale_price}}
                </div>
                <div class="col-sm-5">
                  <img src="./assets/img/view.jpg" alt="" style="margin-top: -10px;" (click)="zoomImg('prod-img-',i)">
                  <i class="fa {{product.liked ? 'fa-heart' : 'fa-heart-o'}} pull-right mx-2"
                    style="color:#8c051e;font-size: 18px;" (click)="likeProduct(product.id)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center" *ngIf="products_array && products_array.length >0">
            <pagination-controls id="productsarrayPagination" autoHide="true"
              (pageChange)="current_page = filterNewProducts($event)">
            </pagination-controls>
          </div>
        </div>
        <div class="row mt-3 ml-5 mr-5" *ngIf="products_array && products_array.length == 0">
          <div class="col-md-12 not-found text-center">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
        </div>
</ng-container>
        <!-- Modal For preview Image -->
        <div class="modal fade zoom-img-modal-lg" tabindex="-1" role="dialog" aria-labelledby="zoomImageModalLabel"
          aria-hidden="true" data-keyboard="false" data-backdrop="static" style="top:4%">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header text-right row">
                <button type="button" class="btn close col-12 text-right px-3 py-0" data-dismiss="modal"
                  aria-label="Close" (click)="normalImg()">
                  &times;
                </button>
              </div>
              <div class="modal-body text-center" id="imagecontainer">
                <img src="" class="large-img" id="img-lg-zoom1">
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="zoomer-container">
                    <img src="{{this.activatedZoomerImg}}">
                  </div> -->


        <!-- product code end -->
      </div>
    </div>

    <div class="modal-content" *ngIf="all_segment_activated">
      <div class="modal-header">
        <!--start 1-->
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <button aria-label="Close" class="close mb-2" data-dismiss="modal" type="button" (click)="closeModal()"
                style="outline: none;">
                <img src="../../../assets/img/cross-out.svg" style="width:15px;">
              </button>
            </div>
          </div>
          <!--end 1-->
        </div>
      </div>
      <div class="modal-body pt-0" style="min-height: 100vh;">


        <div class="Product-bg">
          <div class="container-set container-set-change">
            <div class="row">
              <div class="col-6">
                <div class="ss-searchbox">
                  <i class="fa fa-search float-right"></i>
                  <input class="form-control" type="text" placeholder="Search by SKU"
                    (keydown.enter)="searchTextFilter($event)">
                </div>
              </div>
            </div>
          </div>

          <span class="cursor-pointer" (click)="goBack()"><i
              class="fa fa-chevron-left left_chevron-copy-4 mt-4 mb-4"></i> Back</span>

          <div class="container cardPoss">
            <div class="mb-1">

              <!-- Catalogue breadcrumb -->
              <small class="Living-room-seating cursor-pointer" (click)="goBack()"
                (mouseover)="$event.target.style.color='#922230'">Catalogue</small>

              <!-- segment breadcrumb -->
              <i class="fa fa-angle-right  cosTogg1" *ngIf="breadcrumb.segment"></i><small
                class="Sofa-Sets cursor-pointer" (click)="activateSegment('segment', breadcrumb.segment.id)"
                (mouseover)="$event.target.style.color='#922230'"
                *ngIf="breadcrumb.segment">{{breadcrumb.segment.name}}</small>

              <!-- category breadcrumb -->
              <i class="fa fa-angle-right cosTogg1" *ngIf="breadcrumb.category"></i><small
                class="Hopefull-Sofa cursor-pointer" *ngIf="breadcrumb.category"
                (click)="activateSegment('category', breadcrumb.category.id)"
                (mouseover)="$event.target.style.color='#922230'">{{breadcrumb.category.name}}</small>

              <!-- subcategory breadcrumb -->
              <i class="fa fa-angle-right cosTogg1" *ngIf="breadcrumb.subcategory"></i><small
                class="Hopefull-Sofa cursor-pointer" *ngIf="breadcrumb.subcategory"
                (click)="activateSubCategory('product', breadcrumb.subcategory.id, $event)"
                (mouseover)="$event.target.style.color='#922230'">{{breadcrumb.subcategory.name}}</small>

              <!-- product breadcrumb -->
              <i class="fa fa-angle-right cosTogg1" *ngIf="breadcrumb.product"></i><small
                class="Hopefull-Sofa cursor-pointer" *ngIf="breadcrumb.product">{{breadcrumb.product.name}}</small>


            </div>
            <div class="row">
              <div class="col-6 mb-4"
                *ngFor="let product of segments_array | paginate: {id:'segments_arrayPagination', itemsPerPage: segment_per_page, currentPage: segment_current_page, totalItems: segment_total_page  }">
                <ng-container *ngIf="catalogue_type == 'segment'">
                  <div class="card xzoom text-center" style="display: block;"
                    (click)="activateSegment('category', product.id)">

                    <img class="card-img-top" src="{{product.highlight_image}}"
                      onerror="this.src='./assets/img/no_image.svg'"
                      style="max-height: 235px;width: auto;min-height: 235px;">
                    <div class="card-footer">
                      <p class="text-center contPoss">{{product.category_name}}</p>
                      <p class="text-center contPossi">{{product.number_products}} Product | From: ₹
                        {{product.starting_price}}</p>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="catalogue_type == 'category'">
                  <div class="card xzoom text-center" style="display: block;"
                    (click)="activateSubCategory('product', product.id, $event)">

                    <img class="card-img-top" src="{{product.highlight_image}}"
                      onerror="this.src='./assets/img/no_image.svg'"
                      style="max-height: 235px;width: auto;min-height: 235px;">
                    <div class="card-footer">
                      <p class="text-center contPoss">{{product.subcategory_name}}</p>
                      <p class="text-center contPossi">{{product.number_products}} Product | From: ₹
                        {{product.starting_price}}</p>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="col-md-12 text-center" *ngIf="segments_array && segments_array.length >0">
                <pagination-controls id="segments_arrayPagination" autoHide="true"
                  (pageChange)="segment_current_page = filterNewSegments($event)">
                </pagination-controls>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div class="modal-content" *ngIf="product_detail_activated">
      <div class="modal-header">
        <!--start 1-->
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <button aria-label="Close" class="close mb-2" data-dismiss="modal" type="button" (click)="closeModal()"
                style="outline: none;">
                <img src="../../../assets/img/cross-out.svg" style="width:15px;">
              </button>
            </div>
          </div>
          <!--end 1-->
        </div>
      </div>
      <div class="modal-body pt-0" style="min-height: 100vh;">
        <div class="View-Product">
          <div class="container-set container-set-change">
            <div class="row">
              <div class="col-6">
                <div class="ss-searchbox">
                  <i class="fa fa-search float-right"></i>
                  <input class="form-control" type="text" placeholder="Search by SKU"
                    (keydown.enter)="searchTextFilter($event)">
                </div>
              </div>
            </div>
          </div>
          <span class="cursor-pointer" (click)="goBack()"><i
              class="fa fa-chevron-left left_chevron-copy-4 mt-4 mb-4"></i> Back</span>

          <div class="container">
            <section id="default" class="padding-top0">
              <div class="row">
                <div class="col-md-6">
                  <div class="xzoom-container">
                    <div class="zoomer img-zoom-container" (mouseenter)="imageZoom('img-lg-zoom','myresult')"
                      (mouseleave)="removeHover('myresult')">

                      <img class="xzoom" id="img-lg-zoom" src="{{ medium_image }}"
                        onError="this.src = 'assets/v3/img/noImg.png' " />
                    </div>
                    <div id="myresult" class="img-zoom-result" style="display: none"></div>

                    <div id="carouselExample" class="xzoom-thumbs carousel slide" data-ride="carousel"
                      data-interval="9000">
                      <div class="carousel-inner row w-100 mx-auto xzoom-thumbs " role="listbox">
                        <div class="carousel-item col-md-3 mt-3"
                          *ngFor="let item of product_detail.all_image_urls;let i= index"
                          [class.active]="selectedIndex === i">
                          <img class="img-fluid mx-auto d-block xzoom-gallery" src="{{ item.thumbnail }}" alt="slide 2"
                            onerror="this.src='./assets/img/no_image.svg'" (click)="sendMidImge(item.medium,i)"
                            style="width:100px" [class.active]="selectedIndexChange === i">
                        </div>

                      </div>
                      <a class="carousel-control-prev" href="#carouselExample" role="button" data-slide="prev"
                        *ngIf="product_detail.all_image_urls.length > 4">
                        <span><i class="fa fa-angle-left" style="margin-left: -37px"></i></span>
                        <span class="sr-only" (click)="callCarousel()">Previous</span>
                      </a>
                      <a class="carousel-control-next text-faded" href="#carouselExample" role="button"
                        data-slide="next" (click)="callCarousel()" *ngIf="product_detail.all_image_urls.length > 4">
                        <span><i class="fa fa-angle-right"></i></span>
                        <span class="sr-only" (click)="callCarousel()">Previous</span>
                      </a>
                    </div>

                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-pos">
                    <div class="mb-1">

                      <!-- Catalogue breadcrumb -->
                      <small class="Living-room-seating cursor-pointer" (click)="goBack()"
                        (mouseover)="$event.target.style.color='#922230'">Catalogue</small>

                      <!-- segment breadcrumb -->
                      <i class="fa fa-angle-right  cosTogg1" *ngIf="product_detail.breadcrumb.segment"></i><small
                        class="Sofa-Sets cursor-pointer"
                        (click)="activateSegment('segment', product_detail.breadcrumb.segment.id)"
                        (mouseover)="$event.target.style.color='#922230'"
                        *ngIf="product_detail.breadcrumb.segment">{{product_detail.breadcrumb.segment.name}}</small>

                      <!-- category breadcrumb -->
                      <i class="fa fa-angle-right cosTogg1" *ngIf="product_detail.breadcrumb.category"></i><small
                        class="Hopefull-Sofa cursor-pointer" *ngIf="product_detail.breadcrumb.category"
                        (click)="activateSegment('category', product_detail.breadcrumb.category.id)"
                        (mouseover)="$event.target.style.color='#922230'">{{product_detail.breadcrumb.category.name}}</small>

                      <!-- subcategory breadcrumb -->
                      <i class="fa fa-angle-right cosTogg1" *ngIf="product_detail.breadcrumb.subcategory"></i><small
                        class="Hopefull-Sofa cursor-pointer" *ngIf="product_detail.breadcrumb.subcategory"
                        (click)="activateSubCategory('product', product_detail.breadcrumb.subcategory.id, $event)"
                        (mouseover)="$event.target.style.color='#922230'">{{product_detail.breadcrumb.subcategory.name}}</small>

                      <!-- product breadcrumb -->
                      <i class="fa fa-angle-right cosTogg1" *ngIf="product_detail.breadcrumb.product"></i><small
                        class="Hopefull-Sofa cursor-pointer"
                        *ngIf="product_detail.breadcrumb.product">{{product_detail.breadcrumb.product.name}}</small>

                    </div>

                    <div class="sku-chng ">
                      <small class=" SKU-Code-Arr-2Seat"> SKU Code :{{product_detail.unique_sku}}</small>
                    </div>
                    <div class="coc">
                      <h4 class="Coco---Two-Seater-So">
                        {{product_detail.name}}
                        <i class="fa {{product_detail.liked ? 'fa-heart' : 'fa-heart-o'}} pull-right mx-2"
                          style="color:#8c051e;font-size: 26px;" (click)="likeProduct(product_detail.id)"></i>
                        <!-- <i class="fa fa-heart Path_110"></i> -->
                      </h4>
                    </div>

                    <div class="prices" price-chng="">
                      <p> ₹ {{product_detail.sale_price | number : '1.2-2'}}</p>
                    </div>
                  </div>
                  <div class="form form-pos">
                    <div class="form-group" *ngIf="master_option.length > 0">
                      <label for="sel3" class="MASTER-OPTION">MASTER OPTION</label>
                      <div class="form-control Rectangle" *ngFor="let master of master_option">
                        {{master.name}}
                      </div>
                    </div>
                    <div class="form-group" *ngIf="sub_option.length > 0">
                      <label for="exampleFormControlSelect1" class="MASTER-SUBOPTION">MASTER SUBOPTION</label>
                      <span><i class="fa fa-angle-right left_chevron-copy-2" style="margin-top: 85px"></i></span>
                      <select class="form-control Rectangle1" id="exampleFormControlSelect1" style="height:53px"
                        (change)="fetchCatalogueOptions($event.target.value)">
                        <option value="{{sub.id}}" *ngFor="let sub of sub_option">{{sub.name}}</option>
                      </select>
                    </div>
                    <div class="form-group" *ngIf="cat_option.length > 0">
                      <label for="exampleFormControlSelect1" class="CATALOG-OPTIONS">CATALOGUE OPTION </label>
                      <span><i class="fa fa-angle-right left_chevron-copy-3" style="margin-top: 80px"></i></span>
                      <select class="form-control Rectangle1" id="exampleFormControlSelect1" style="height:53px"
                        (change)="fetchVariation($event.target.value)">
                        <option value="{{cat.id}}" *ngFor="let cat of cat_option">{{cat.name}} </option>
                      </select>

                    </div>
                  </div>
                  <div class="form-possi" *ngIf="variation.length > 0">
                    <div
                      class="variation-img-container rounded-circle variation-img-container-{{varia.id}} {{i==0 ? 'active' : ''}}"
                      *ngFor="let varia of variation; let i =index"
                      (mouseenter)="activateZoomer(varia.attributes.medium_image, $event)"
                      (mouseleave)="deActivateZoomer()">
                      <img class="variation-img" src="{{varia.attributes.thumbnail}}" title="{{varia.attributes.name}}"
                        (click)="selectVariation(varia.attributes.id)">
                    </div>
                  </div>
                  <small class="View-More float-right cursor-pointer" *ngIf="variation.length > 14"
                    (click)="viewMoreVariation($event)">View More</small>
                  <div class="form-group" style="clear: both;">
                    <label>Quantity : </label>
                    <input class="form-control ml-3" type="number" style="width: 30%; display: inline-block;" value="1"
                      min="1"
                      (change)="this.modalQuantityandProductSelectionForm.patchValue({productQty: $event.target.value});">
                  </div>
                  <div class="form-group">
                    <button class="interalBtnColor cartBtn addCursor mt-2 mb-2"
                      (click)="addProductToBoqs(product_detail,modalQuantityandProductSelectionForm.value)">Select
                      Product</button>
                  </div>

                  <!-- {{modalQuantityandProductSelectionForm.value | json}} -->

                </div>
              </div>
            </section>
          </div>
          <div class="container mt-4">
            <div class="row">
              <div class="col-md-12">
                <h6 class="PRODUCT-INFORMATION">PRODUCT INFORMATION</h6>
                <table>
                  <tr class="trmarg " *ngIf="product_detail.color">
                    <td class="text-deco w-60">Color:</td>
                    <td class="text-deco1">{{product_detail.color}}</td>
                  </tr>
                  <tr class="trmarg" *ngIf="product_detail.product_config">
                    <td class="text-deco w-50">Configuration:</td>
                    <td class="text-deco1">{{product_detail.product_config}}</td>
                  </tr>
                  <tr class="trmarg" *ngIf="product_detail.measurement_unit">
                    <td class="text-deco w-50">Measurment Unit:</td>
                    <td class="text-deco1">{{product_detail.measurement_unit}}</td>
                  </tr>
                  <tr class="trmarg" *ngIf="product_detail.lead_time">
                    <td class="text-deco w-50">Lead time:</td>
                    <td class="text-deco1">{{product_detail.lead_time}}</td>
                  </tr>
                  <tr class="trmarg" *ngIf="product_detail.finish">
                    <td class="text-deco w-50">Finish</td>
                    <td class="text-deco1">{{product_detail.finish}}</td>
                  </tr>
                  <tr class="trmarg" *ngIf="product_detail.product_config">
                    <td class="text-deco w-50">Dimension(mm):</td>
                    <td class="text-deco1">
                      {{product_detail.length}}<span>&#215;</span>{{product_detail.width}}<span>&#215;</span>{{product_detail.height}}
                    </td>
                  </tr>
                </table>
              </div>
              <br>
              <div class="col-md-12 mt-4" *ngIf="product_detail.material">
                <p class="lorem-head">Material:</p>
                <p class="Lorem-ipsum"> {{product_detail.material}}</p>
              </div>
              <div class="col-md-12 mt-1" *ngIf="product_detail.dimension_remark">
                <p class="lorem-head">Dimension Remark:</p>
                <p class="Lorem-ipsum"> {{product_detail.dimension_remark}}</p>
              </div>
              <div class="col-md-12 mt-1" *ngIf="product_detail.remark">
                <p class="lorem-head">Remark:</p>
                <p class="Lorem-ipsum"> {{product_detail.remark}}</p>
              </div>
              <div class="col-md-12 mt-1" *ngIf="product_detail.warranty">
                <p class="WARRANTY"> WARRANTY:</p>
                <p class="Lorem-ipsum"> {{product_detail.warranty}}</p>
              </div>
              <div class="col-md-12 mt-1" *ngIf="product_detail.similar_products.length > 0">
                <h6 class="VIEW-SIMILAR-PRODUCT mt-4">VIEW SIMILAR PRODUCT</h6>
              </div>

              <div class="col-md-3 px-2 py-2 mt-3"
                *ngFor="let product of product_detail.similar_products;let i = index">
                <div class="card addCursor {{product.new_product ? 'new' : ''}}">
                  <div class="su-img-container">
                    <img class="su-product-card-img" src="{{product.image_url}}"
                      onerror="this.src='./assets/img/noimage.jpg'" [routerLink]="['/catalogue','product',product.id]"
                      id="prod-img-{{i}}">
                  </div>
                  <div class="row px-2 pt-2">
                    <div class="col-sm-7 catlogue-product-name" title="{{product.name}}">
                      {{product.name}}
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-sm-7 catlogue-product-price">
                      Rs.{{product.sale_price}}
                    </div>
                    <div class="col-sm-5">
                      <img src="./assets/img/view.jpg" alt="" style="margin-top: -10px;"
                        (click)="zoomImg('prod-img-',i)">
                      <i class="fa {{product.liked ? 'fa-heart' : 'fa-heart-o'}} pull-right mx-2"
                        style="color:#8c051e;font-size: 18px;" (click)="likeProduct(product.id)"></i>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!--Add extras modal-->
<div class="modal fade" id="addExtrasModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" style="overflow-y: scroll;">
  <div class="modal-dialog my-2 mx-2" role="document">
    <div class="modal-content" id="allextrasRow">
      <div class="modal-header">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-2"></div>
            <div class="col-10 pl-5">
              <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                <i class="fa fa-search"></i>
                <input class="form-control" type="text"
                  placeholder="Type vendor SKU/ description/ specifications  to search..." #search (keyup)="0"
                  [(ngModel)]="search_string_extra_filter">
              </div>
              <button class="rk-interalBtnColor addCursor" (click)="getKitchenExtras(extraCategory)">Search</button>
            </div>
          </div>
        </div>
        <button type="button" class="close addExtrastModalClose" data-dismiss="modal" aria-label="Close"
          (click)="closeAddExtraModal()">
          <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-2">
            <div class="mx-2">
              <div class="mb-3">
                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make<span
                    class="pull-right">_</span></h6>
                {{brand_name_extra_filter }}
                <div class="aa-text" *ngFor="let data of makeforextras_filter">
                  <input type="checkbox" name="brand_name_extra_filter" class="mr-1" value="{{data.name}}"
                    (change)="onCheckChangeFilter($event,'make','extra')"
                    [checked]="brand_name_extra_filter.includes(data.name)"> <span class="sideOption">{{data.name}}
                  </span>
                </div>
              </div>
              <!-- <div class="mb-3">
                                        <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Addon Tag<span class="pull-right">-</span></h6>
                                        <div class="aa-text" *ngFor="let tag of addontagsArr">
                                            <input type="checkbox" name="tagvals" class="mr-1" value="{{tag.humanized_name}}" (change)="onCheckChangeFilter($event,'addontag','extra')" [checked]="tags_extras_filter.includes(tag.name)"> <span class="sideOption" >{{tag.humanized_name}}</span>
                                            <br>
                                        </div>
                                    </div> -->
              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Price<span
                  class="pull-right">-</span></h6>
              <ion-range-slider #advancedSliderElement type="double" min="0" max="500000" [from]="fromval_slider"
                from_min="0" from_max="499999" from_shadow="true" [to]="toval_slider" to_min="1" to_max="500000"
                to_shadow="true" grid="false" prefix="Price: " postfix=" Rs." decorate_both="false"
                (onUpdate)="update(advancedSlider, $event)" (onChange)="update(advancedSlider, $event)"
                (onFinish)="finish(advancedSlider, $event)">
              </ion-range-slider>
              <input type="number" name="" (input)="changeSliderValue('from', $event.target.value)"
                class="form-control d-inline" style="width: 47%" [(ngModel)]="fromval_slider">
              <input type="number" name="" (input)="changeSliderValue('to',$event.target.value)"
                class="form-control d-inline" style="width: 49%" [(ngModel)]="toval_slider">

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Type/Grouping<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" name='single' (change)="onCheckChangeFilter($event,'grouping','single')"
                  class="mr-1" value="single" /><span class="sideOption">Single</span>
              </div>
              <div class="aa-text">
                <input type="checkbox" name='combo' (change)="onCheckChangeFilter($event,'grouping','combination')"
                  class="mr-1" value="combo" /><span class="sideOption">Combo/Bundled</span>
              </div>
              <div class="aa-text">
                <input type="checkbox" name='both' (change)="onCheckChangeFilter($event,'grouping','both')" class="mr-1"
                  value="both" /><span class="sideOption">Both</span>
              </div>

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Arrivae Select<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" (change)="onCheckChangeFilter($event,'arrivaeSelect','')" class="mr-1"
                  [checked]="type_arrivae_select" /><span class="sideOption">Arrivae Select</span>
              </div>

              <button class="rk-interalBtnColor mt-3" (click)="getKitchenExtras(extraCategory);">Apply Filters</button>
            </div>
          </div>
          <div class="col-sm-10 bgColor">
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row">
                  <div class="col-sm-3" *ngFor="let kitchenextra of kitchenExtras; let ki=index;">
                    <div *ngIf="kitchenExtras && !kitchenextra.included_addons">
                      <div class="card card-chng mb-5 py-2" style="padding-top:0%!important">
                        <div class="card-header"
                          style="background-color:#FAFAFA;height:0rem;border:none;background-color:white;padding:0;width:97%">
                          <div *ngIf="kitchenextra.arrivae_select"
                            style="background-color: #8C031F;z-index:2;position:relative;top:+0rem;display: block; color: white;width: 30%;border-radius:13%;text-align:center">
                            <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                        </div>
                        <img class="card-img-top addCursor" src="{{kitchenextra.addon_image}}"
                          *ngIf="kitchenextra.addon_image" onerror="this.src='./assets/img/no_image.svg';"
                          alt="Missing Image" (click)="zoomImg($event.target,'#addExtrasModal')">
                        <div class="card-body" style="min-height: 14rem;">
                          <h6 class="card-title textColor1 rk-textColor capitalize">{{kitchenextra.code}}</h6>
                          <p class="card-text textColor2 capitalize">Description : {{kitchenextra.name}}</p>
                          <p class="card-text textColor2 capitalize">Vendor SKU : {{kitchenextra.vendor_sku}}</p>
                          <p class="card-text textColor2 capitalize">Brand : {{kitchenextra.brand_name}}</p>
                          <p class="card-text textColor2 capitalize">Specification : {{kitchenextra.specifications}}</p>
                          <p class="textColor2 capitalize">Price : &#8377; {{kitchenextra.mrp}}</p>
                        </div>
                        <div class="card-footer">
                          <form [formGroup]="addExtraFormMk">
                            <input type="number" class="d-inline form-control" style="
                                                                  width: 70%;" placeholder="Enter Quantity"
                              formControlName="qty" name="qty" id="extraqtyinput_{{ki}}" min="1">
                            <button class="rk-interalBtnColor addCursor d-inline"
                              (click)="addExtra_new(kitchenextra.id,addExtraFormMk.value,ki,false)">Add</button>
                          </form>
                        </div>
                      </div>
                    </div>

                    <!-- Extra Addon Combinations -->
                    <div *ngIf="kitchenextra.included_addons;" class="card card-chng mb-5 py-2"
                      style="border-radius: 3%;background-color:#FAFAFA;padding-top:0%!important">
                      <div class="card-header"
                        style="background-color:#FAFAFA;height:0rem;border:none;background-color:white;padding:0;width:97%">
                        <div *ngIf="kitchenextra.arrivae_select"
                          style="background-color: #8C031F;z-index:2;position:relative;top:+0rem;display: block; color: white;width: 30%;border-radius:13%;text-align:center">
                          <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                      </div>
                      <div class="card-header" style="background-color:#FAFAFA;text-align:left;padding: .55rem 1rem;">
                        <span style='font-weight:600;font-size: .9rem'>Combination Price:</span>
                        <span
                          style="float:right;font-weight:600;">{{kitchenextra.included_mrp | currency:"₹ ":0}}</span>
                      </div>
                      <img class="card-img-top addCursor" style='width:100%!important'
                        src="{{kitchenextra.included_addons[addOnIndex[ki]].addon_image}}"
                        *ngIf="kitchenextra.included_addons[addOnIndex[ki]].addon_image"
                        onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                        (click)="zoomImg($event.target,'#addAddonModal')">
                      <div class="card-body" style="min-height: 14rem; max-height:14.45rem">
                        <div style="margin-bottom:14%">
                          <i style="display:inline-block;vertical-align:text-top;color:#8C031F"
                            (click)="setCombinationElement($event,optionalRadio,addOnIndex[ki]-1,kitchenextra.included_addons.length,ki)"
                            class="fas fa-chevron-left"></i>
                          <h6 class="card-title textColor1 rk-textColor capitalize text-font-align"
                            style="display:inline-block;color:black;margin-bottom:0!important;width:89%!important">
                            {{kitchenextra.included_addons[addOnIndex[ki]].code}}</h6><i
                            style="display:inline-block;vertical-align:text-top;color:#8C031F"
                            (click)="setCombinationElement($event,optionalRadio,addOnIndex[ki]+1,kitchenextra.included_addons.length,ki)"
                            class="fas fa-chevron-right"></i>
                          <h5 class="card-title textColor1 rk-textColor capitalize" style="margin-top:5%"><span>Qty:
                              1</span><span
                              style="float:right;">{{kitchenextra.included_addons[addOnIndex[ki]].mrp | currency:"₹ ":0}}</span>
                          </h5>
                        </div>
                        <p class="card-text textColor2 capitalize"><span class="card-text-heading"
                            style="margin-top:8%">Description :</span> <span data-toggle="tooltip"
                            [title]="kitchenextra.included_addons[addOnIndex[ki]].name"
                            class="card-text-value">{{(kitchenextra.included_addons[addOnIndex[ki]].name.length>38)? (kitchenextra.included_addons[addOnIndex[ki]].name | slice:0:38)+'..':(kitchenextra.included_addons[addOnIndex[ki]].name)}}</span>
                        </p>
                        <ng-container *ngIf="kitchenextra.included_addons[addOnIndex[ki]].vendor_sku">
                          <p class="card-text textColor2 capitalize"><span class="card-text-heading">Vendor SKU :</span>
                            <span data-toggle="tooltip"
                              [title]="kitchenextra.included_addons[addOnIndex[ki]].vendor_sku"
                              class="card-text-value">{{(kitchenextra.included_addons[addOnIndex[ki]].vendor_sku.length>11)?(kitchenextra.included_addons[addOnIndex[ki]].vendor_sku | slice: 0:11)+'..':(kitchenextra.included_addons[addOnIndex[ki]].vendor_sku)}}</span>
                          </p>
                        </ng-container>
                        <p class="card-text textColor2 capitalize"><span class="card-text-heading">Brand :</span> <span
                            class="card-text-value">{{kitchenextra.included_addons[addOnIndex[ki]].brand_name}}</span>
                        </p>
                        <!-- <p class="card-text textColor2 capitalize"><span style="color:grey">Specification :</span> <span style="font-weight:600;color:black">{{addon.specifications}}</span></p> -->
                        <!-- <p class="card-text textColor2 capitalize">MRP : &#8377; {{addon.mrp}}</p> -->

                      </div>
                      <ng-container>
                        <div class="radio-inline" style="width:100%;text-align:center;">
                          <ng-container
                            *ngFor="let comboElement of kitchenextra.included_addons;let comboElementIndex = index">
                            <label><input type="checkbox" class="mr-1 carosel-nav" [checked]='comboElementIndex==0'
                                id="optradiocombination-{{ki}}-{{comboElementIndex}}"
                                (change)="setCombinationElement($event,optionalRadio,comboElementIndex,kitchenextra.included_addons.length,ki)"></label>
                          </ng-container>
                        </div>
                      </ng-container>
                      <!-- <div class="card-switch text-center" style="border:none !important;background-color:#FAFAFA" *ngIf="addonModalType=='compaddon'">
                                                      <button class="rk-interalBtnColor addCursor d-inline" (click)="addCompAddon(addon,ki,slotindex)">Add</button>
                                                  </div> -->
                      <div class="card-footer">
                        <form [formGroup]="addExtraFormMk">
                          <input type="number" class="d-inline form-control" style="
                                                              width: 70%;" placeholder="Enter Quantity"
                            formControlName="qty" name="qty" id="extraqtyinput_{{ki}}" min="1">
                          <button class="rk-interalBtnColor addCursor d-inline"
                            (click)="addExtra_new(kitchenextra.id,addExtraFormMk.value,ki,true)">Add</button>
                        </form>
                      </div>
                    </div>

                  </div>
                  <div *ngIf="kitchenExtras && kitchenExtras.length==0">No Extra available</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <button class="rk-interalBtnColor mr-2" (click)="prevPage('extra')" *ngIf="pageno_extra>1"><i
                    class="fa fa-angle-double-left mr-2" style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                <button *ngIf="kitchenExtras && kitchenExtras.length==15 && showNext" class="rk-interalBtnColor"
                  (click)="nextPage('extra')">Next<i class="fa fa-angle-double-right ml-2"
                    style="font-size: 19px;font-weight: bold;"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Add addon modal-->
<div class="modal fade" id="addAddonModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
    <div class="modal-content" id="alladdonsRow">
      <div class="modal-header">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-2"></div>
            <div class="col-10 pl-5">
              <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                <i class="fa fa-search"></i>
                <input class="form-control" style="color:gray" type="text"
                  placeholder="Type vendor SKU/ description/ specifications  to search..." #search (keyup)="0"
                  [(ngModel)]="search_string_addon_filter">
              </div>
              <button class="rk-interalBtnColor addCursor"
                (click)="getCompulsoryAddons(customizationModule_MK_details.product_module_id,slotnameForAddon,slotindex)"
                *ngIf="addonModalType=='compaddon'">Search</button>
              <button class="rk-interalBtnColor addCursor"
                (click)="getListofAddonsForAddons(getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].id.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].combination.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].slot.value,slotindex);"
                *ngIf="addonModalType=='addonforaddon'">Search</button>

            </div>
          </div>
        </div>
        <button type="button" class="close addExtrastModalClose" (click)="closeAddAddonModal()">
          <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-2">
            <div class="mx-2">
              <div class="mb-3">
                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make<span
                    class="pull-right">_</span></h6>
                <div class="aa-text" *ngFor="let data of makeforextras_filter">
                  <input type="checkbox" name="brand_name_extra_filter" class="mr-1" value="{{data.name}}"
                    (change)="onCheckChangeFilter($event,'make','compaddon')"
                    [checked]="brand_name_addon_filter.includes(data.name)"> <span class="sideOption">{{data.name}}
                  </span>
                </div>
              </div>
              <!-- <div class="mb-3">
                                        <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Addon Tag<span class="pull-right">-</span></h6>
                                        <div class="aa-text" *ngFor="let tag of addontagsArr">
                                            <input type="checkbox" name="tagvals" class="mr-1" value="{{tag.humanized_name}}" (change)="onCheckChangeFilter($event,'addontag','compaddon')" [checked]="tags_addon_filter.includes(tag.name)"> <span class="sideOption" >{{tag.humanized_name}}</span>
                                            <br>
                                        </div>
                                        <span>Check this: {{addontagsArr | json}}</span>
                                    </div> -->

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Price<span
                  class="pull-right">-</span></h6>
              <ion-range-slider #advancedSliderElement type="double" min="0" max="500000" [from]="fromval_slider"
                from_min="0" from_max="499999" from_shadow="true" [to]="toval_slider" to_min="1" to_max="500000"
                to_shadow="true" grid="false" prefix="Price: " postfix=" Rs." decorate_both="false"
                (onUpdate)="update(advancedSlider, $event)" (onChange)="update(advancedSlider, $event)"
                (onFinish)="finish(advancedSlider, $event)">
              </ion-range-slider>
              <input type="number" name="" (input)="changeSliderValue('from', $event.target.value)"
                class="form-control d-inline" style="width: 47%" [(ngModel)]="fromval_slider">
              <input type="number" name="" (input)="changeSliderValue('to',$event.target.value)"
                class="form-control d-inline" style="width: 49%" [(ngModel)]="toval_slider">

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Type/Grouping<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" name='single' (change)="onCheckChangeFilter($event,'grouping','single')"
                  class="mr-1" value="single" /><span class="sideOption">Single</span>
              </div>
              <div class="aa-text">
                <input type="checkbox" name='combo' (change)="onCheckChangeFilter($event,'grouping','combination')"
                  class="mr-1" value="combo" /><span class="sideOption">Combo/Bundled</span>
              </div>
              <div class="aa-text">
                <input type="checkbox" name='both' (change)="onCheckChangeFilter($event,'grouping','both')" class="mr-1"
                  value="both" /><span class="sideOption">Both</span>
              </div>

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Arrivae Select<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" (change)="onCheckChangeFilter($event,'arrivaeSelect','')" class="mr-1"
                  [checked]="type_arrivae_select" /><span class="sideOption">Arrivae Select</span>
              </div>

              <button class="rk-interalBtnColor mt-3"
                (click)="getCompulsoryAddons(customizationModule_MK_details.product_module_id,slotnameForAddon,slotindex);"
                *ngIf="addonModalType=='compaddon'">Apply Filters</button>
              <button class="rk-interalBtnColor mt-3"
                (click)="getListofAddonsForAddons(getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].id.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].combination.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].slot.value,slotindex);"
                *ngIf="addonModalType=='addonforaddon'">Apply Filters</button>
            </div>
          </div>

          <div class="col-sm-10 bgColor">
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row" *ngIf="compulsoryaddonsArr && compulsoryaddonsArr.length>0; else no_addon">
                  <div class="col-sm-3" *ngFor="let addon of compulsoryaddonsArr; let ki=index;">
                    <div *ngIf="!addon.included_addons" class="card card-chng mb-5 py-2"
                      style="border-radius: 3%;min-height:30.7rem;padding-top:0!important;padding:0;">

                      <div class="card-header"
                        style="background-color:#FAFAFA;height:0rem;border:none;background-color:white;padding:0;width:97%">
                        <div *ngIf="addon.arrivae_select"
                          style="background-color: #8C031F;z-index:2;position:relative;top:+0rem;display: block; color: white;width: 30%;border-radius:13%;text-align:center">
                          <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                      </div>
                      <img style="position:relative;border-radius:4%;width:100%" class="card-img-top addCursor "
                        src="{{addon.addon_image}}" *ngIf="addon.addon_image"
                        onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                        (click)="zoomImg($event.target,'#addAddonModal')">
                      <div class="card-body" style="min-height: 18rem; ">
                        <h6 class="card-title textColor1 rk-textColor capitalize text-font-align" style="color:black">
                          {{addon.code}}</h6>
                        <h5 class="card-title textColor1 rk-textColor capitalize text-center">
                          {{addon.mrp | currency:"₹ ":0}}</h5>
                        <p style="margin-top:16%" class="card-text textColor2 capitalize "><span
                            class="card-text-heading">Description :</span> <span data-toggle="tooltip"
                            [title]="addon.name"
                            class="card-text-value">{{(addon.name.length>38)? (addon.name | slice:0:38)+'..':(addon.name)}}</span>
                        </p>
                        <ng-container *ngIf="addon.vendor_sku">
                          <p class="card-text textColor2 capitalize"><span class="card-text-heading">Vendor SKU :</span>
                            <span data-toggle="tooltip" [title]="addon.vendor_sku"
                              class="card-text-value">{{(addon.vendor_sku.length>11)? (addon.vendor_sku | slice: 0:11)+'..':(addon.vendor_sku)}}</span>
                          </p>
                        </ng-container>
                        <p class="card-text textColor2 capitalize"><span class="card-text-heading">Brand :</span> <span
                            class="card-text-value">{{addon.brand_name}}</span></p>
                        <!-- <p class="card-text textColor2 capitalize"><span style="color:grey">Specification :</span> <span style="font-weight:600;color:black">{{addon.specifications}}</span></p> -->
                        <!-- <p class="card-text textColor2 capitalize">MRP : &#8377; {{addon.mrp}}</p> -->
                      </div>
                      <div style="border:none !important;text-align:center!important" class="card-footer text-right"
                        *ngIf="addonModalType=='compaddon'">
                        <button style="margin-top:10%;" class="rk-interalBtnColor addCursor d-inline"
                          (click)="addCompAddon(addon,ki,slotindex)">Add</button>
                      </div>
                      <div class="card-footer" style="border:none !important" *ngIf="addonModalType=='addonforaddon'">
                        <form [formGroup]="addAddon_for_addon_FormMk">
                          <input type="number" class="d-inline form-control" style="
                                                                width: 70%;" placeholder="Enter Quantity"
                            formControlName="qty" name="qty" id="addonforaddonqtyinput_{{ki}}" min="1">
                          <button class="rk-interalBtnColor addCursor d-inline"
                            (click)="addAddonforaddon_new(addon,addAddon_for_addon_FormMk.value,slotindex,ki)">Add</button>
                        </form>
                      </div>
                    </div>

                    <!-- <hr> -->
                    <!-- for combinations -->
                    <div *ngIf="addon.included_addons;" class="card card-chng mb-5 py-2"
                      style="border-radius: 3%;background-color:#FAFAFA;padding-top:0%!important">
                      <div class="card-header"
                        style="background-color:#FAFAFA;height:0rem;border:none;background-color:white;padding:0;width:97%">
                        <div *ngIf="addon.arrivae_select"
                          style="background-color: #8C031F;z-index:2;position:relative;top:+0rem;display: block; color: white;width: 30%;border-radius:13%;text-align:center">
                          <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                      </div>
                      <div class="card-header" style="background-color:#FAFAFA;text-align:left;padding: .55rem 1rem;">
                        <span style='font-weight:600;font-size: .9rem'>Combination Price:</span>
                        <span style="float:right;font-weight:600;">{{addon.included_mrp | currency:"₹ ":0}}</span>
                      </div>
                      <img class="card-img-top addCursor" style='width:100%!important'
                        src="{{addon.included_addons[addOnIndex[ki]].addon_image}}"
                        *ngIf="addon.included_addons[addOnIndex[ki]].addon_image"
                        onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                        (click)="zoomImg($event.target,'#addAddonModal')">
                      <div class="card-body" style="min-height: 14rem; max-height:14.45rem">
                        <div style="margin-bottom:14%">
                          <i style="display:inline-block;vertical-align:text-top;color:#8C031F"
                            (click)="setCombinationElement($event,optionalRadio,addOnIndex[ki]-1,addon.included_addons.length,ki)"
                            class="fas fa-chevron-left"></i>
                          <h6 class="card-title textColor1 rk-textColor capitalize text-font-align"
                            style="display:inline-block;color:black;margin-bottom:0!important;width:89%!important">
                            {{addon.included_addons[addOnIndex[ki]].code}}</h6><i
                            style="display:inline-block;vertical-align:text-top;color:#8C031F"
                            (click)="setCombinationElement($event,optionalRadio,addOnIndex[ki]+1,addon.included_addons.length,ki)"
                            class="fas fa-chevron-right"></i>
                          <h5 class="card-title textColor1 rk-textColor capitalize" style="margin-top:5%"><span>Qty:
                              1</span><span
                              style="float:right;">{{addon.included_addons[addOnIndex[ki]].mrp | currency:"₹ ":0}}</span>
                          </h5>
                        </div>
                        <p class="card-text textColor2 capitalize"><span class="card-text-heading"
                            style="margin-top:8%">Description :</span> <span data-toggle="tooltip"
                            [title]="addon.included_addons[addOnIndex[ki]].name"
                            class="card-text-value">{{(addon.included_addons[addOnIndex[ki]].name.length>38)? (addon.included_addons[addOnIndex[ki]].name | slice:0:38)+'..':(addon.included_addons[addOnIndex[ki]].name)}}</span>
                        </p>
                        <ng-container *ngIf="addon.included_addons[addOnIndex[ki]].vendor_sku">
                          <p class="card-text textColor2 capitalize"><span class="card-text-heading">Vendor SKU :</span>
                            <span data-toggle="tooltip" [title]="addon.included_addons[addOnIndex[ki]].vendor_sku"
                              class="card-text-value">{{(addon.included_addons[addOnIndex[ki]].vendor_sku.length>11)?(addon.included_addons[addOnIndex[ki]].vendor_sku | slice: 0:11)+'..':(addon.included_addons[addOnIndex[ki]].vendor_sku)}}</span>
                          </p>
                        </ng-container>
                        <p class="card-text textColor2 capitalize"><span class="card-text-heading">Brand :</span> <span
                            class="card-text-value">{{addon.included_addons[addOnIndex[ki]].brand_name}}</span></p>
                        <!-- <p class="card-text textColor2 capitalize"><span style="color:grey">Specification :</span> <span style="font-weight:600;color:black">{{addon.specifications}}</span></p> -->
                        <!-- <p class="card-text textColor2 capitalize">MRP : &#8377; {{addon.mrp}}</p> -->

                      </div>
                      <ng-container>
                        <div class="radio-inline" style="width:100%;text-align:center;">
                          <ng-container
                            *ngFor="let comboElement of addon.included_addons;let comboElementIndex = index">
                            <label><input type="checkbox" class="mr-1 carosel-nav" [checked]='comboElementIndex==0'
                                id="optradiocombination-{{ki}}-{{comboElementIndex}}"
                                (change)="setCombinationElement($event,optionalRadio,comboElementIndex,addon.included_addons.length,ki)"></label>
                          </ng-container>
                        </div>
                      </ng-container>
                      <div class="card-switch text-center" style="border:none !important;background-color:#FAFAFA"
                        *ngIf="addonModalType=='compaddon'">
                        <button class="rk-interalBtnColor addCursor d-inline"
                          (click)="addCompAddon(addon,ki,slotindex)">Add</button>
                      </div>
                      <div class="card-footer" style="border:none !important" *ngIf="addonModalType=='addonforaddon'">
                        <form [formGroup]="addAddon_for_addon_FormMk">
                          <input type="number" class="d-inline form-control" style="
                                                                width: 70%;" placeholder="Enter Quantity"
                            formControlName="qty" name="qty" id="addonforaddonqtyinput_{{ki}}" min="1">
                          <button class="rk-interalBtnColor addCursor d-inline"
                            (click)="addAddonforaddon_new(addon,addAddon_for_addon_FormMk.value,slotindex,ki)">Add</button>
                        </form>
                      </div>
                    </div>



                  </div>
                </div>

                <ng-template #no_addon>No Addon available</ng-template>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right" *ngIf="addonModalType=='compaddon'">
                <button class="rk-interalBtnColor mr-2" (click)="prevPage('addon','compaddon')"
                  *ngIf="pageno_addon>1"><i class="fa fa-angle-double-left mr-2"
                    style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                <button *ngIf="compulsoryaddonsArr && showNext && compulsoryaddonsArr.length==15"
                  class="rk-interalBtnColor" (click)="nextPage('addon','compaddon');">Next<i
                    class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
              </div>
              <div class="col-12 text-right" *ngIf="addonModalType=='addonforaddon'">
                <button class="rk-interalBtnColor mr-2" (click)="prevPage('addon','addonforaddon')"
                  *ngIf="pageno_addon>1"><i class="fa fa-angle-double-left mr-2"
                    style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                <button *ngIf="compulsoryaddonsArr && showNext && compulsoryaddonsArr.length==15"
                  class="rk-interalBtnColor" (click)="nextPage('addon','addonforaddon');">Next<i
                    class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--optional addon modal-->
<div class="modal fade" id="addoptionalAddonModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
    <div class="modal-content" id="alloptionaladdonsRow">
      <div class="modal-header">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-2"></div>
            <div class="col-10 pl-5">
              <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                <i class="fa fa-search"></i>
                <input style="color:gray" class="form-control" type="text"
                  placeholder="Type vendor SKU/ description/ specifications  to search..." #search (keyup)="0"
                  [(ngModel)]="search_string_addon_filter">
              </div>
              <button class="rk-interalBtnColor addCursor" (click)="getOptionalAddons(optaddoncategory)">Search</button>

            </div>
          </div>
        </div>
        <button type="button" class="close addExtrastModalClose" (click)="closeoptionalAddonModal(optaddoncategory)">
          <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-2">
            <div class="mx-2">
              <div class="mb-3">
                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make<span
                    class="pull-right">_</span></h6>
                <div class="aa-text" *ngFor="let data of makeforextras_filter">
                  <input type="checkbox" name="brand_name_extra_filter" class="mr-1" value="{{data.name}}"
                    (change)="onCheckChangeFilter($event,'make','compaddon')"
                    [checked]="brand_name_addon_filter.includes(data.name)"> <span class="sideOption">{{data.name}}
                  </span>
                </div>
              </div>
              <!-- <div class="mb-3">
                                      <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Addon Tag<span class="pull-right">-</span></h6>
                                      <div class="aa-text" *ngFor="let tag of addontagsArr">
                                          <input type="checkbox" name="tagvals" class="mr-1" value="{{tag.humanized_name}}" (change)="onCheckChangeFilter($event,'addontag','compaddon')" [checked]="tags_addon_filter.includes(tag.name)"> <span class="sideOption" >{{tag.humanized_name}}</span>
                                          <br>
                                      </div>
                                  </div> -->
              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By MRP<span
                  class="pull-right">-</span></h6>
              <ion-range-slider #advancedSliderElement type="double" min="0" max="500000" [from]="fromval_slider"
                from_min="0" from_max="499999" from_shadow="true" [to]="toval_slider" to_min="1" to_max="500000"
                to_shadow="true" grid="false" prefix="MRP: " postfix=" Rs." decorate_both="false"
                (onUpdate)="update(advancedSlider, $event)" (onChange)="update(advancedSlider, $event)"
                (onFinish)="finish(advancedSlider, $event)">
              </ion-range-slider>
              <input type="number" name="" (input)="changeSliderValue('from', $event.target.value)"
                class="form-control d-inline" style="width: 47%" [(ngModel)]="fromval_slider">
              <input type="number" name="" (input)="changeSliderValue('to',$event.target.value)"
                class="form-control d-inline" style="width: 49%" [(ngModel)]="toval_slider">

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Type/Grouping<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" name='single' (change)="onCheckChangeFilter($event,'grouping','single')"
                  class="mr-1" value="single" /><span class="sideOption">Single</span>
              </div>
              <div class="aa-text">
                <input type="checkbox" name='combo' (change)="onCheckChangeFilter($event,'grouping','combination')"
                  class="mr-1" value="combo" /><span class="sideOption">Combo/Bundled</span>
              </div>
              <div class="aa-text">
                <input type="checkbox" name='both' (change)="onCheckChangeFilter($event,'grouping','both')" class="mr-1"
                  value="both" /><span class="sideOption">Both</span>
              </div>

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Arrivae Select<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" (change)="onCheckChangeFilter($event,'arrivaeSelect','')" class="mr-1"
                  [checked]="type_arrivae_select" /><span class="sideOption">Arrivae Select</span>
              </div>

              <button class="rk-interalBtnColor mt-3" (click)="getOptionalAddons(optaddoncategory)">Apply
                Filters</button>
            </div>
          </div>
          <div class="col-sm-10 bgColor">
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row" *ngIf="compulsoryaddonsArr && compulsoryaddonsArr.length>0; else no_addon">
                  <div class="col-sm-3" *ngFor="let addon of compulsoryaddonsArr; let ki=index;">
                    <ng-container *ngIf="!addon.combo_name">
                      <div class="card card-chng mb-5 py-2" style="padding-top:0%!important">
                        <div class="card-header"
                          style="background-color:#FAFAFA;height:0rem;border:none;background-color:white;padding:0;width:97%">
                          <div *ngIf="addon.arrivae_select"
                            style="background-color: #8C031F;z-index:2;position:relative;top:+0rem;display: block; color: white;width: 30%;border-radius:13%;text-align:center">
                            <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                        </div>
                        <img style="width:100%" class="card-img-top addCursor" src="{{addon.addon_image}}"
                          *ngIf="addon.addon_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                          (click)="zoomImg($event.target,'#addoptionalAddonModal')">
                        <div class="card-body" style="min-height: 19.5rem;">
                          <h6 class="card-title textColor1 rk-textColor capitalize">{{addon.code}}</h6>
                          <p class="card-text textColor2 capitalize">Description : {{addon.name}}</p>
                          <p class="card-text textColor2 capitalize">Vendor SKU : {{addon.vendor_sku}}</p>
                          <p class="card-text textColor2 capitalize">Brand : {{addon.brand_name}}</p>
                          <p class="card-text textColor2 capitalize">Specification : {{addon.specifications}}</p>
                          <p class="card-text textColor2 capitalize">MRP : &#8377; {{addon.mrp}}</p>
                        </div>
                        <div class="card-footer">
                          <form [formGroup]="addAddon_for_addon_FormMk">
                            <input type="number" class="d-inline form-control" style="
                                                            width: 70%;" placeholder="Enter Quantity"
                              formControlName="qty" name="qty" id="optionaladdonqtyinput_{{ki}}" min="1">
                            <button class="rk-interalBtnColor addCursor d-inline"
                              (click)="addoptionaladdon_new(addon,addAddon_for_addon_FormMk.value,ki,optaddoncategory)">Add</button>
                          </form>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="addon.combo_name">
                      <div *ngIf="addon.included_addons;" class="card card-chng mb-5 py-2"
                        style="border-radius: 3%;background-color:#FAFAFA">
                        <div class="card-header" style="background-color:#FAFAFA;text-align:left;padding: .55rem 1rem;">
                          <span style='font-weight:600;font-size: .9rem'>Combination Price: </span>
                          <span style="float:right;font-weight:600;">{{addon.included_mrp | currency:"₹ ":0}}</span>
                        </div>
                        <img style="width:100%" class="card-img-top addCursor"
                          src="{{addon.included_addons[addOnIndex[ki]].addon_image}}"
                          *ngIf="addon.included_addons[addOnIndex[ki]].addon_image"
                          onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image"
                          (click)="zoomImg($event.target,'#addAddonModal')">
                        <div class="card-body" style="min-height: 14rem; max-height:14.45rem">
                          <div style="margin-bottom:14%">
                            <i style="display:inline-block;vertical-align:text-top;color:#8C031F"
                              (click)="setCombinationElement($event,addonOptionalRadio,addOnIndex[ki]-1,addon.included_addons.length,ki)"
                              class="fas fa-chevron-left"></i>
                            <h6 class="card-title textColor1 rk-textColor capitalize text-font-align"
                              style="display:inline-block;color:black;margin-bottom:0!important;width:89%!important">
                              {{addon.included_addons[addOnIndex[ki]].code}}</h6><i
                              style="display:inline-block;vertical-align:text-top;color:#8C031F"
                              (click)="setCombinationElement($event,addonOptionalRadio,addOnIndex[ki]+1,addon.included_addons.length,ki)"
                              class="fas fa-chevron-right"></i>
                            <h5 class="card-title textColor1 rk-textColor capitalize" style="margin-top:5%"><span>Qty:
                                1</span><span
                                style="float:right;">{{addon.included_addons[addOnIndex[ki]].mrp | currency:"₹ ":0}}</span>
                            </h5>
                          </div>
                          <p class="card-text textColor2 capitalize"><span class="card-text-heading"
                              style="margin-top:8%">Description :</span> <span data-toggle="tooltip"
                              [title]="addon.included_addons[addOnIndex[ki]].name"
                              class="card-text-value">{{(addon.included_addons[addOnIndex[ki]].name.length>38)? (addon.included_addons[addOnIndex[ki]].name | slice:0:38)+'..':(addon.included_addons[addOnIndex[ki]].name)}}</span>
                          </p>
                          <ng-container *ngIf="addon.included_addons[addOnIndex[ki]].vendor_sku">
                            <p class="card-text textColor2 capitalize"><span class="card-text-heading">Vendor SKU
                                :</span> <span data-toggle="tooltip"
                                [title]="addon.included_addons[addOnIndex[ki]].vendor_sku"
                                class="card-text-value">{{(addon.included_addons[addOnIndex[ki]].vendor_sku.length>11)?(addon.included_addons[addOnIndex[ki]].vendor_sku | slice: 0:11)+'..':(addon.included_addons[addOnIndex[ki]].vendor_sku)}}</span>
                            </p>
                          </ng-container>
                          <p class="card-text textColor2 capitalize"><span class="card-text-heading">Brand :</span>
                            <span class="card-text-value">{{addon.included_addons[addOnIndex[ki]].brand_name}}</span>
                          </p>
                          <!-- <p class="card-text textColor2 capitalize"><span style="color:grey">Specification :</span> <span style="font-weight:600;color:black">{{addon.specifications}}</span></p> -->
                          <!-- <p class="card-text textColor2 capitalize">MRP : &#8377; {{addon.mrp}}</p> -->

                        </div>
                        <ng-container>
                          <div class="radio-inline" style="width:100%;text-align:center;">
                            <ng-container
                              *ngFor="let comboElement of addon.included_addons;let comboElementIndex = index">
                              <label><input type="checkbox" class="mr-1 carosel-nav" [checked]='comboElementIndex==0'
                                  id="addonoptradiocombination-{{ki}}-{{comboElementIndex}}"
                                  (change)="setCombinationElement($event,this.addonOptionalRadio,comboElementIndex,addon.included_addons.length,ki)"></label>
                            </ng-container>
                          </div>
                        </ng-container>
                        <div class="card-footer">
                          <form [formGroup]="addAddon_for_addon_FormMk">
                            <input type="number" class="d-inline form-control" style="
                                                          width: 71%;padding-top:3%;padding-bottom:3%"
                              placeholder="Enter Quantity" formControlName="qty" name="qty"
                              id="optionaladdonqtyinput_{{ki}}" min="1">
                            <button class="rk-interalBtnColor addCursor d-inline"
                              (click)="addoptionaladdon_new(addon,addAddon_for_addon_FormMk.value,ki,optaddoncategory)">Add</button>
                          </form>
                        </div>


                      </div>

                    </ng-container>
                  </div>
                </div>
                <ng-template #no_addon>No Addon available</ng-template>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <button class="rk-interalBtnColor mr-2" (click)="prevPage('addon','optionaladdon',optaddoncategory)"
                  *ngIf="pageno_addon>1"><i class="fa fa-angle-double-left mr-2"
                    style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                <button *ngIf="compulsoryaddonsArr && showNext && compulsoryaddonsArr.length==15"
                  class="rk-interalBtnColor" (click)="nextPage('addon','optionaladdon',optaddoncategory);">Next<i
                    class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="moduleCodeModal" tabindex="-1" role="dialog" aria-labelledby="moduleCodeModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog" role="document" style="max-width: 100%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="moduleCodeModalLabel">Select Module</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModuleModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-3" *ngFor=" let module of arr_list_modal; let q =index">
            <div class="card card-chng mb-2 pt-2 addCursor" id="modulecard{{q}}">
              <img alt="Missing Image" class="card-img-top addCursor" onerror="this.src='./assets/img/no_image.svg';"
                src="{{module.module_image}}" (click)="setModulecode(module)" id="mod-img-{{q}}">
              <div class="card-body">
                <h6 class="card-title textColor1 rk-textColor capitalize" (click)="setModulecode(module)">
                  {{module.code}}</h6>
                <p class="card-text textColor2 capitalize" (click)="setModulecode(module)">Dimensions -
                  {{module.dimensions}}</p>
              </div>
              <div class="card-footer border text-right">
                <button class="rk-interalBtnColor addCursor rk-form-fontsize "
                  (click)="preview_Img('mod-img-',q,'#moduleCodeModal')">Preview Image</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--preset Modal starts-->
<div class="modal fade" id="listPresetModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="listPresetModalLabel">List of Presets</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-12" *ngIf="preset_list &&  preset_list.length==0 ">No Presets</div>
          <div class="col-md-12" *ngIf="preset_list &&  preset_list.length>0">
            <collapsible-table [type]="'accordion'" bordered class="table" style="outline: none;">
              <thead class="thead-dark">
                <collapsible-table-row>
                  <th scope="col" class="firstTh">#</th>
                  <th scope="col"> Name</th>
                  <th scope="col">Created By</th>
                  <th class="minWidthForTd">Date</th>
                  <th scope="col">Remarks</th>
                  <th scope="lastTh" class="lastTh"></th>
                </collapsible-table-row>
              </thead>
              <tbody style="background: white">
                <ng-container
                  *ngFor="let data of preset_list | paginate: {id:'preset_listPagination', itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index;"
                  [attr.data-index]="i">
                  <collapsible-table-row [detail]="detail1">
                    <td style="min-width: 1rem;">{{((current_page-1) * per_page) + (i+1)}}</td>
                    <td class="capitalize"> {{data.preset_name}}</td>
                    <td>{{data.preset_created_by.name}} - {{data.preset_created_by.email}}</td>
                    <td class="capitalize">{{data.created_at | date:'dd MMM, y , h:mm a'}}</td>
                    <td class="capitalize">{{data.preset_remark}}</td>
                    <td class="capitalize"><button class="rk-interalBtnColor addCursor"
                        (click)="savePresetAsGlobal(data.category,data.id)">Select</button></td>
                  </collapsible-table-row>
                  <collapsible-table-row-detail style="box-shadow: none;" #detail1>
                    <div class="px-2 py-3 mx-0">
                      <div class="row px-3" style="border-bottom: 1px solid #dcd7d7;">
                        <div class="col-md-12">
                          <h5 class="heading-change">Preset Details:</h5>
                        </div>
                      </div>
                      <div class="row style-chng px-3 pt-3">
                        <div class="col-md-3">
                          <label class="">Category :</label>
                          <p class="preset_details_para capitalize">{{data.category}}</p>
                        </div>
                        <div *ngIf="data.core_material" class="col-md-3">
                          <label class="">Core Material :</label>
                          <p class="preset_details_para capitalize">{{data.core_material.name}}</p>
                        </div>
                        <div *ngIf="data.shutter_material" class="col-md-3">
                          <label class="">Shutter Material :</label>
                          <p class="preset_details_para capitalize">{{data.shutter_material.name}}</p>
                        </div>
                        <div *ngIf="data.shutter_finish" class="col-md-3">
                          <label class="">Shutter Finish :</label>
                          <p class="preset_details_para capitalize">{{data.shutter_finish.name}}</p>
                        </div>
                        <div class="col-md-3">
                          <label class=""><span *ngIf="data.category=='wardrobe'">Drawer</span> Handle Code :</label>
                          <p class="preset_details_para capitalize">{{data.door_handle_code}}</p>
                          <img src="{{data.door_handle_image}}" alt=" No Image" height="60px" width="100px"
                            *ngIf="data.door_handle_image " onerror="this.src='./assets/img/no_image.svg'">
                        </div>
                        <div class="col-md-3" *ngIf="data.category=='wardrobe'">
                          <label class="">Shutter Handle Code :</label>
                          <p class="preset_details_para capitalize">{{data.shutter_handle_code}}</p>
                          <img src="{{data.shutter_handle_image}}" alt=" No Image" height="60px" width="100px"
                            *ngIf="data.shutter_handle_image " onerror="this.src='./assets/img/no_image.svg'">
                        </div>
                        <div class="col-md-3">
                          <label class="">Hinge Type :</label>
                          <p class="preset_details_para capitalize">{{data.hinge_type}}</p>
                        </div>
                        <!-- <div class="col-md-3">
                                                            <label class="">Channel Type :</label>
                                                            <p class="preset_details_para capitalize">{{data.channel_type}}</p>
                                                        </div> -->
                        <!-- <div class="col-md-3">
                                                            <label class="">Hardware Brand :</label>
                                                            <p class="preset_details_para capitalize">{{data.brand.name}}</p>
                                                        </div> -->
                        <div class="col-md-3" *ngIf="data.category=='kitchen'">
                          <label class="">Skirting Config Type :</label>
                          <p class="preset_details_para capitalize">{{data.skirting_config_type}}</p>
                        </div>
                        <div class="col-md-3" *ngIf="data.category=='kitchen'">
                          <label class="">Skirting Config Height :</label>
                          <p class="preset_details_para capitalize">{{data.skirting_config_height}}</p>
                        </div>
                        <!-- <div class="col-md-3" *ngIf="data.category=='kitchen'">
                                                            <label class="">Countertop :</label>
                                                            <p class="preset_details_para capitalize">{{data.countertop | replaceChar}}</p>
                                                        </div> -->
                        <div class="col-md-3" *ngIf="data.category=='kitchen'">
                          <label class="">Type of Kitchen :</label>
                          <p class="preset_details_para capitalize">
                            <ng-container *ngIf="data.civil_kitchen">Civil Kitchen</ng-container>
                            <ng-container *ngIf="!data.civil_kitchen">Modular Kitchen</ng-container>
                          </p>
                        </div>
                        <div class="col-md-3"
                          *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                          <label class="">Depth (in mm) :</label>
                          <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.depth}}</p>
                        </div>
                        <div class="col-md-3"
                          *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                          <label class="">Drawer Height 1 (in mm) :</label>
                          <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.drawer_height_1}}
                          </p>
                        </div>
                        <div class="col-md-3"
                          *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                          <label class="">Drawer Height 2 (in mm) :</label>
                          <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.drawer_height_2}}
                          </p>
                        </div>
                        <div class="col-md-3"
                          *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                          <label class="">Drawer Height 3 (in mm) :</label>
                          <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.drawer_height_3}}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="">Shutter Shade Code :</label>
                          <p class="preset_details_para capitalize">
                            <ng-container *ngIf="data.custom_shutter_shade_code">{{data.shutter_shade_code}}
                            </ng-container>
                            <ng-container *ngIf="!data.custom_shutter_shade_code">{{data.shutter_shade_code.code}}
                            </ng-container>
                          </p>
                          <img src="{{data.shutter_shade_code.shade_image}}" alt=" No Image" height="60px" width="100px"
                            *ngIf="!data.custom_shutter_shade_code && data.shutter_shade_code.shade_image "
                            onerror="this.src='./assets/img/no_image.svg'">
                        </div>
                        <!-- <div class="col-md-3" *ngIf = "data.edge_banding_shade_code">
                                                            <label class="">Edge Banding Shade Code :</label>
                                                            <p class="preset_details_para capitalize"><ng-container *ngIf="data.custom_edge_banding_shade_code">{{data.edge_banding_shade_code}}</ng-container><ng-container *ngIf="!data.custom_edge_banding_shade_code">{{data.edge_banding_shade_code.code}}</ng-container></p>
                                                            <ng-container *ngIf="!data.custom_edge_banding_shade_code && data.edge_banding_shade_code.shade_image">
                                                              <img src="{{data.edge_banding_shade_code.shade_image}}" alt=" No Image" height="60px" width="100px" onerror="this.src='./assets/img/no_image.svg'">
                                                            </ng-container>
                                                        </div> -->
                      </div>
                    </div>
                  </collapsible-table-row-detail>
                </ng-container>
              </tbody>
            </collapsible-table>
            <div class="text-center" *ngIf="preset_list && preset_list.length >0">
              <pagination-controls id="preset_listPagination" autoHide="true"
                (pageChange)="current_page = getGlobalPresets(preset_list_category,$event)"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--preset modal ends-->

<div class="modal fade" id="saveMkwLayoutModal" tabindex="-1" role="dialog" aria-labelledby="saveMkwLayoutModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="saveMkwLayoutModalLabel">Save As Layout</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="saveMkwLayoutForm.reset();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <form [formGroup]="saveMkwLayoutForm">
          <div class="row">
            <div class="col-md-6">
              <label>Category <span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" readonly formControlName="category">
            </div>
            <div class="col-md-6">
              <label>Name <span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="name">
            </div>
            <div class="col-md-12 mt-3">
              <label>Remarks</label>
              <textarea class="form-control" rows="2" formControlName="remark"></textarea>
            </div>
            <div class="col-md-12 text-right">
              <button class="rk-interalBtnColor addCursor my-2" [disabled]="!saveMkwLayoutForm.valid"
                (click)="saveAsMkwLayout(saveMkwLayoutForm.value)">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="setGlobalConfigModal" tabindex="-1" role="dialog"
  aria-labelledby="setGlobalConfigModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static"
  style="overflow-y: scroll;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="setGlobalConfigModalLabel">Select Global Variables</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="closeGlobalVarFormModal();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0" *ngIf="globalVarArr">
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-2" style="margin-top:1rem;margin-bottom:1rem">
            <div class="form-group">
              <span>Arrivae Select Only</span>
              <label class="switch">
                <input [(ngModel)]="arrivaeSelectValues" (change)="fetchArrivaeSelectValues();" type="checkbox">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <form [formGroup]="addGlobalVariableForm">
          <div class="row">
            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='kitchen')}">
              <div class="form-group">
                <label class="text-left">Type Of Kitchen <span class="text-danger">*</span></label>
                <select formControlName="civil_kitchen" class="form-control"
                  (change)="onChangeOfTOK($event.target.value,addGlobalVariableForm)">
                  <option value="">Select</option>
                  <option value='true'>Civil Kitchen</option>
                  <option value='false'>Modular Kitchen</option>
                </select>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"
              [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
              <div class="form-group">
                <label class="text-left">Depth in mm <span class="text-danger">*</span></label>
                <input type="number" name="" class="form-control" formControlName="depth" min="0">
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"
              [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
              <div class="form-group">
                <label class="text-left">Drawer 1 Height in mm(D1) <span class="text-danger">*</span></label>
                <input type="number" name="" class="form-control" formControlName="drawer_height_1" min="130">
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"
              [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
              <div class="form-group">
                <label class="text-left">Drawer 2 Height in mm(D2) <span class="text-danger">*</span></label>
                <input type="number" name="" class="form-control" formControlName="drawer_height_2" min="150">
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"
              [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
              <div class="form-group">
                <label class="text-left">Drawer 3 Height in mm(D3) <span class="text-danger">*</span></label>
                <input type="number" name="" class="form-control" formControlName="drawer_height_3" min="360">
              </div>
            </div>

            <!-- Set Global Variables -->

            <ng-container *ngIf="globalVarArr">
              <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                  <label class="text-left">Core Material<span class="text-danger">*</span></label>
                  <select formControlName="core_material" class="form-control"
                    (change)="listofCoreMaterial($event.target.value,addGlobalVariableForm)">
                    <option value="">Select</option>
                    <ng-container *ngFor="let coremat of globalVarArr.core_material">
                      <option *ngIf="!coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}</option>
                      <option *ngIf="coremat.arrivae_select" value="{{coremat.name}}">{{coremat.name}}&nbsp;&nbsp;<span
                          style="font-size:10px;float:right;">(Arrivae Select)</span></option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                  <label class="text-left">Shutter Material <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="shutter_material"
                    (change)="listofShutterFinishes($event.target.value,addGlobalVariableForm)">
                    <option value="">Select</option>
                    <ng-container *ngFor="let shuttermat of globalVarArr.shutter_materials">
                      <option *ngIf="!shuttermat.arrivae_select" value="{{shuttermat.name}}">{{shuttermat.name}}
                      </option>
                      <option *ngIf="shuttermat.arrivae_select" value="{{shuttermat.name}}">
                        {{shuttermat.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae Select)</span>
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                  <label class="text-left">Shutter Finish <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="shutter_finish"
                    (change)="listofShutterFinishShades($event.target.value,addGlobalVariableForm);">
                    <option value="">Select</option>
                    <ng-container *ngFor="let shutter_fin of globalVarArr.shutter_finish">
                      <option *ngIf="shutter_fin.arrivae_select" value="{{shutter_fin.name}}">
                        {{shutter_fin.name}}&nbsp;&nbsp;<span style="font-size:10px;float:right;">(Arrivae
                          Select)</span></option>
                      <option *ngIf="!shutter_fin.arrivae_select" value="{{shutter_fin.name}}">{{shutter_fin.name}}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6 mb-2">
                                            <div class="form-group">
                                                <label class="text-left">Shutter Type <span class="text-danger">*</span></label>
                                                <select class="form-control" formControlName="shutter_material" (change)="listofShutterFinishes($event.target.value,addGlobalVariableForm)">
                                                    <option value="">Select</option>
                                                    <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                                                </select>
                                            </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mb-2">
                                            <div class="form-group">
                                                <label class="text-left">Internal Color <span class="text-danger">*</span></label>
                                                <select class="form-control" formControlName="shutter_material" (change)="listofShutterFinishes($event.target.value,addGlobalVariableForm)">
                                                    <option value="">Select</option>
                                                    <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                                                </select>
                                            </div>
                                    </div> -->
              <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                  <label class="text-left">Shutter Shade Code <span class="text-danger">*</span></label>
                  <a class="addCursor d-block link-color"
                    (click)="openglobalvarSubModal('#shadeCodeModal','#setGlobalConfigModal');checkConsistencyOfValues()">Choose
                    Shade Code</a>
                  <span>{{addGlobalVariableForm.controls['shutter_shade_code'].value}}</span>
                  <img src="{{addGlobalVariableForm.controls['shutter_shade_code_img'].value}}" alt=" No Image"
                    height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['shutter_shade_code_img'].value "
                    onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#setGlobalConfigModal')" class="addCursor">
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="text-left">Edge Banding Shade <span class="text-danger">*</span></label>
                                            <a  class="addCursor d-block link-color" (click)="openglobalvarSubModal('#edgebandingShadeModal','#setGlobalConfigModal')">Choose Edge Banding Shade Code</a>
                                            <span>{{addGlobalVariableForm.controls['edge_banding_shade_code'].value}}</span>
                                            <img src="{{addGlobalVariableForm.controls['edge_banding_shade_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['edge_banding_shade_code_img'].value " onerror="this.src='./assets/img/no_image.svg'" (click)="zoomImg($event.target,'#setGlobalConfigModal')" class="addCursor">
                                        </div>
                                    </div> -->
              <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='wardrobe')}">
                <div class="form-group">
                  <label class="text-left">Shutter Handle Code <span class="text-danger">*</span></label>
                  <a class="addCursor d-block link-color"
                    (click)="openglobalvarSubModal('#addhandleModal','#setGlobalConfigModal');  openHandleModal(globalVarArr.category,'shutter','',addGlobalVariableForm.controls['shutter_finish'].value,false);">Choose
                    Shutter Handle Code</a>
                  <span>{{addGlobalVariableForm.controls['shutter_handle_code'].value}}</span>
                  <img src="{{addGlobalVariableForm.controls['shutter_handle_code_img'].value}}" alt=" No Image"
                    height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['shutter_handle_code_img'].value "
                    onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#setGlobalConfigModal')" class="addCursor">
                </div>
              </div>
              <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                  <label class="text-left"
                    [ngClass]="{'d-block': (globalVarArr.category!='wardrobe'),'d-none':(globalVarArr.category=='wardrobe')}">Handle
                    Code <span class="text-danger">*</span></label>
                  <label class="text-left"
                    [ngClass]="{'d-block': (globalVarArr.category=='wardrobe'),'d-none':(globalVarArr.category!='wardrobe')}">Drawer
                    Handle Code <span class="text-danger">*</span></label>
                  <a class="addCursor d-block link-color"
                    (click)="openglobalvarSubModal('#addhandleModal','#setGlobalConfigModal'); openHandleModal(globalVarArr.category,'drawer','',addGlobalVariableForm.controls['shutter_finish'].value,false);">Choose
                    <span *ngIf="globalVarArr.category=='wardrobe'">Drawer</span> Handle Code</a>
                  <span>{{addGlobalVariableForm.controls['door_handle_code'].value}}</span>
                  <img src="{{addGlobalVariableForm.controls['door_handle_code_img'].value}}" alt=" No Image"
                    height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['door_handle_code_img'].value "
                    onerror="this.src='./assets/img/no_image.svg'"
                    (click)="zoomImg($event.target,'#setGlobalConfigModal')" class="addCursor">
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="text-left">Hardware Brand <span class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="brand_id">
                                                <option value="">Select</option>
                                                <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                            </select>
                                        </div>
                                    </div> -->
              <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none':(globalVarArr.modspace == true)}">
                <div class="form-group">
                  <label class="text-left">Hinge Type <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="hinge_type">
                    <option value="">Select</option>
                    <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span
                        *ngIf="ht=='soft'"> - CLOSE</span></option>
                  </select>
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="text-left">Channel Type <span class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="channel_type">
                                                <option value="">Select</option>
                                                <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                            </select>
                                        </div>
                                    </div> -->
              <div class="col-sm-12 col-md-6 mb-2"
                [ngClass]="{'d-none': (globalVarArr.category!='kitchen') || (globalVarArr.modspace == true)}">
                <div class="form-group">
                  <label class="text-left">Skirting Config Type<span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="skirting_config_type"
                    (change)="listofSkirtingHeights($event.target.value,addGlobalVariableForm)">
                    <option value="">Select</option>
                    <option *ngFor="let sct of globalVarArr.skirting_config_type" value="{{sct.skirting_type}}">
                      {{sct.skirting_type | uppercase}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 mb-2"
                [ngClass]="{'d-none': (globalVarArr.category!='kitchen') || (globalVarArr.modspace == true)}">
                <div class="form-group">
                  <label class="text-left"> Skirting Config Height <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="skirting_config_height">
                    <option value="">Select</option>
                    <option *ngFor="let sch of globalVarArr.skirting_config_height" value="{{sch.skirting_height}}">
                      {{sch.skirting_height}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='kitchen')}">
                                        <div class="form-group">
                                            <label class="text-left">Countertop <span class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="countertop">
                                                <option value="">Select</option>
                                                <option *ngFor="let count_top of globalVarArr.countertop" value="{{count_top}}">{{count_top | replaceChar}}</option>
                                            </select>
                                        </div>
                                    </div> -->
            </ng-container>
          </div>
          <div>
            <button class="pull-right rk-interalBtnColor mr-2 my-2 addCursor"
              (click)="postBoqGlobalConfig(addGlobalVariableForm.value,globalVarArr.category)">Save</button>
            <button class="pull-right rk-interalBtnColor mr-2 my-2 addCursor"
              (click)="openPresetModal(addGlobalVariableForm.value,globalVarArr.category,'add','#setGlobalConfigModal')">Save
              As Preset</button>
            <button class="pull-right rk-btnCancel my-2 mr-2 addCursor" data-dismiss="modal"
              (click)="closeGlobalVarFormModal()">Cancel</button>
          </div>
          <!-- <pre>{{addPresetForm.value | json}}</pre> -->
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="savePresetModal" tabindex="-1" role="dialog" aria-labelledby="savePresetModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="saveMkwLayoutModalLabel">Save As Preset</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closePresetModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <form [formGroup]="savePresetForm">
          <div class="row">
            <div class="col-md-6">
              <label>Category <span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" readonly formControlName="category">
            </div>
            <div class="col-md-6">
              <label>Name <span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="name">
            </div>
            <div class="col-md-12 mt-3">
              <label>Remarks</label>
              <textarea class="form-control" rows="2" formControlName="remark"></textarea>
            </div>
            <div class="col-md-12 text-right">
              <button class="rk-interalBtnColor addCursor my-2" [disabled]="!savePresetForm.valid"
                (click)="saveAsPreset(savePresetForm.value)">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="layoutlistmodal" tabindex="-1" role="dialog" aria-labelledby="layoutlistmodalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="layoutlistmodalLabel">List of Layouts</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeImportLayoutModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row mx-0">
          <div class="col-md-12" *ngIf="layouts_list &&  layouts_list.length==0">No Layout</div>
          <div class="col-md-12" *ngIf="layouts_list &&  layouts_list.length>0">
            <collapsible-table [type]="'accordion'" bordered class="table mt-3" style="outline: none;">
              <thead class="thead-dark">
                <collapsible-table-row>
                  <th scope="col" class="firstTh">#</th>
                  <th scope="col"> Name</th>
                  <th scope="col">Created By</th>
                  <th class="minWidthForTd">Date</th>
                  <th scope="col" class="">Remarks</th>
                  <th scope="lastTh" class="lastTh"></th>
                </collapsible-table-row>
              </thead>
              <tbody style="background: white">
                <ng-container
                  *ngFor="let data of layouts_list | paginate: {id:'layouts_listPagination', itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index;"
                  [attr.data-index]="i">
                  <collapsible-table-row [detail]="detail1" (click)="getMkwLayoutDetail(data.id)">
                    <td style="min-width: 1rem;">{{((current_page-1) * per_page) + (i+1)}}</td>
                    <td class="capitalize"> {{data.name}}</td>
                    <td>{{data.created_by.name}} - {{data.created_by.email}}</td>
                    <td class="capitalize">{{data.created_at | date:'dd MMM, y , h:mm a'}}</td>
                    <td class="capitalize">{{data.remark}}</td>
                    <td><button class="rk-interalBtnColor addCursor"
                        (click)="importLayoutToSpace(data.id)">Select</button></td>
                  </collapsible-table-row>
                  <collapsible-table-row-detail style="box-shadow: none;" #detail1>
                    <div class="px-2 py-3 mx-0">
                      <div class="row px-3" *ngIf="layoutDetail">
                        <!--Modular jobs-->
                        <div class="col-md-12 tableDiv" *ngIf="layoutDetail.modular_jobs.length>0">
                          <h6 class="mt-3 px-3">Modules</h6>
                          <table class="table px-3">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th [ngClass]="{'d-none':(selectedsectionName=='modular_wardrobe')}">Kitchen Category
                                </th>
                                <th>Type</th>
                                <th>Module</th>
                                <th class="text-center">Image</th>
                                <th>Quantity</th>
                                <th [ngClass]="{'d-none':(selectedsectionName=='modular_wardrobe')}">Width</th>
                                <th class="lastTh"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let mod of layoutDetail.modular_jobs; let k=index; ">
                                <tr
                                  *ngIf="(selectedsectionName=='modular_kitchen') || (selectedsectionName=='modular_wardrobe' && !mod.combined)">
                                  <td>{{k+1}}</td>
                                  <td [ngClass]="{'d-none':(selectedsectionName=='modular_wardrobe')}">
                                    {{mod.kitchen_category_name}}</td>
                                  <td>{{mod.module_type}}</td>
                                  <td>{{mod.code}}</td>
                                  <td>
                                    <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url"
                                      style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';"
                                      alt="Missing Image">
                                  </td>
                                  <td class="text-center">
                                    <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                                  </td>
                                  <td [ngClass]="{'d-none':(selectedsectionName == 'modular_wardrobe')}">
                                    <span>
                                      <ng-container *ngIf="mod.custom_shelf_unit_width">{{mod.custom_shelf_unit_width}}
                                        mm</ng-container>
                                      <ng-container *ngIf="!mod.custom_shelf_unit_width">NA</ng-container>
                                    </span>
                                  </td>
                                  <td>
                                    <img src="assets/v3/img/gear.svg"
                                      (click)="getCustomizationOfMKWlayout(mod.id,data.id)" class="addCursor">
                                  </td>
                                </tr>
                                <tr *ngIf="(selectedsectionName == 'modular_wardrobe' && mod.combined)"
                                  class="accordion-toggle addCursor" data-toggle="collapse" data-parent="#OrderPackages"
                                  [attr.data-target]="'.packageDetails'+k" (click)="showAccordion(k)">
                                  <td>{{k+1}}</td>
                                  <td>Combined</td>
                                  <td class="capitalize">{{mod.name}}</td>
                                  <td style="text-align:center">
                                    <ng-container *ngFor="let label of mod.labels.slice(0,3)">
                                      {{label.label_name}}<br /></ng-container><span data-toggle="modal"
                                      data-target="#labelList"
                                      (click)="this.transferLabelList(k,mod.labels,k,mod.id,'ModularJob',false,0,'')"><i
                                        data-toggle="tooltip" title="Click to view complete list."
                                        class="fa fa-binoculars" style="font-size:1rem;color:#8c0420"></i></span>
                                  </td>
                                  <td>
                                    <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url"
                                      style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';"
                                      alt="Missing Image">
                                  </td>
                                  <td class="text-center">
                                    <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                                  </td>
                                  <td></td>
                                </tr>
                                <tr class="d-none combmoduleAccordionRow{{k}}" id="combmoduleAccordionRow{{k}}"
                                  *ngIf="mod.combined">
                                  <td colspan="6" class="hiddenRow">
                                    <div class="accordion-body collapse packageDetails{{k}}" id="accordion_{{k}}">
                                      <table class="table">
                                        <tr *ngFor="let cmod of mod.included_modules; let m=index; ">
                                          <td>{{m+1}}</td>
                                          <td>{{cmod.module_type}}</td>
                                          <td>{{cmod.code}}</td>
                                          <td>
                                            <img src="{{cmod.module_image_url}}" *ngIf="cmod.module_image_url"
                                              style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';"
                                              alt="Missing Image">
                                          </td>
                                          <td>
                                            <span class="moduleLineItemSpan{{k}}{{m}}">{{cmod.quantity}}</span>
                                          </td>
                                          <td>
                                            <img src="assets/v3/img/gear.svg"
                                              (click)="getCustomizationOfMKWlayout(cmod.id,data.id)" class="addCursor">
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                        <!--Appliance job-->
                        <div class="col-md-12 tableDiv" *ngIf="layoutDetail.appliance_jobs.length>0">
                          <h6 class="mt-3 px-3">Appliances</h6>
                          <table class="table px-3">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th>Appliance Type</th>
                                <th>Appliance</th>
                                <th>Make</th>
                                <th>Vendor Sku</th>
                                <th>Quantity</th>
                                <th></th>
                                <th>Delivery Timeline</th>
                                <th class="text-center lastTh">Image</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let appjob of layoutDetail.appliance_jobs; let k1=index; ">
                                <td>{{k1+1}}</td>
                                <td>{{appjob.subcategory}}</td>
                                <td>{{appjob.name}}</td>
                                <td>{{appjob.make}}</td>
                                <td>{{appjob.vendor_sku}}</td>
                                <td>{{appjob.quantity}}</td>
                                <td>{{appjob.lead_time}}</td>
                                <td>
                                  <img src="{{appjob.image_url}}" *ngIf="appjob.image_url" style="width: 100px;"
                                    onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!--Extras job-->
                        <div class="col-md-12 tableDiv" *ngIf="layoutDetail.extra_jobs.length>0">
                          <h6 class="mt-3 px-3">Extras</h6>
                          <table class="table px-3">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th>Name</th>
                                <th>Vendor Sku</th>
                                <th>Make</th>
                                <th>Specification </th>
                                <th>Quantity</th>
                                <th class="text-center lastTh">Image</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let extrajob of layoutDetail.extra_jobs; let k2=index; ">
                                <td>{{k2+1}}</td>
                                <td>{{extrajob.name}}</td>
                                <td>{{extrajob.vendor_sku}}</td>
                                <td>{{extrajob.make}}</td>
                                <td>{{extrajob.specifications}}</td>
                                <td>{{extrajob.quantity}}</td>
                                <td>
                                  <img src="{{extrajob.image_url}}" *ngIf="extrajob.image_url" style="width: 100px;"
                                    onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </collapsible-table-row-detail>
                </ng-container>
              </tbody>
            </collapsible-table>
            <div class="text-center" *ngIf="layouts_list && layouts_list.length >0">
              <pagination-controls id="layouts_listPagination" autoHide="true"
                (pageChange)="current_page = getLayoutsList(importlayout_category,$event)"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="layoutCustomizationModal" tabindex="-1" role="dialog"
  aria-labelledby="layoutCustomizationModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="layoutCustomizationModalLabel">Customize Elements</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="closeLayoutCustomizationModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="customizationDetails">
        <div class="row">
          <div class="col-md-12">
            <label>Number Exposed Sites - </label>
            <span>{{customizationDetails.number_exposed_sites}}</span>
          </div>
          <div class="col-md-12">
            <fieldset *ngFor="let item of customizationDetails.addons; let i=index ">
              <div class="row mx-0 py-2 mb-2 addonrow" *ngIf="item.compulsory">
                <div class="col-md-3">
                  <label>Slot</label>
                  <p class="rk-form-fontsize">{{item.slot}}</p>
                </div>
                <div class="col-md-3">
                  <label>Addon</label>
                  <p class="rk-form-fontsize">{{item.name}} - {{item.code}}</p>
                </div>
                <div class="col-md-2">
                  <label>Quantity</label>
                  <p class="rk-form-fontsize px-3">{{item.quantity}}</p>
                </div>
                <div class="col-md-4">
                  <label>Image</label>
                  <img src="{{item.addon_image}}" height="100px" width="100px"
                    onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="item.addon_image">
                </div>

                <div class="col-md-12 mt-3" *ngFor="let item1 of customizationDetails.addons_for_addons">
                  <ng-container *ngIf="item1.compulsory_addon_id==item.id">
                    <div class="row mb-3 optaddonrow">
                      <div class="col-5">
                        <label>Optional Addon</label>
                        <p class="rk-form-fontsize">{{item1.name}} - {{item1.code}}</p>
                      </div>
                      <div class="col-3">
                        <label>Quantity</label>
                        <p class="rk-form-fontsize px-3">{{item1.quantity}}</p>
                      </div>
                      <div class="col-md-4">
                        <label>Image</label>
                        <img src="{{item1.addon_image}}" height="100px" width="100px"
                          onerror="this.src='./assets/img/no_image.svg'" style="display: block;"
                          *ngIf="item1.addon_image">
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="row mx-0 py-2 mb-2 addonrow" *ngIf="item.compulsory">
                <div class="col-md-6">
                  <label>Addon</label>
                  <p class="rk-form-fontsize">{{item.name}} - {{item.code}}</p>
                </div>
                <div class="col-md-2">
                  <label>Quantity</label>
                  <p class="rk-form-fontsize px-3">{{item.quantity}}</p>
                </div>
                <div class="col-md-4">
                  <label>Image</label>
                  <img src="{{item.addon_image}}" height="100px" width="100px"
                    onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="item.addon_image">
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="smartBoqModal" tabindex="-1" role="dialog" aria-labelledby="smartBoqModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modalboxHeader">
        <h5 class="modal-title modalTitle" id="smartBoqModalLabel">Generate Smart BOQ</h5>
        <button type="button" class="close addCursor" data-dismiss="modal" aria-label="Close"
          (click)="closeSmartBoqModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="smart_boq_Form">
          <div class="row">
            <div class="col-md-12">
              <label class="col-3">Enter Target Price <span class="text-danger">*</span></label>
              <input type="number" name="" class="form-control d-inline col-3 rk-form-fontsize"
                formControlName="target_price" min="1">
            </div>
            <div class="col-md-12">
              <fieldset formArrayName="category_data" class="mb-2">
                <div *ngFor="let item of smart_boq_Form.get('category_data')['controls']; let i=index "
                  [formGroup]="item" class="row my-2">
                  <div class="col-4">
                    <label [attr.for]="'category_data_elem'+i">Select Category <span
                        class="text-danger">*</span></label>
                    <ng-select [attr.id]="'category_data_elem'+i" formControlName="section_id">
                      <ng-option value="">Select Category</ng-option>
                      <ng-option *ngFor="let sc of categories_list_loosefur" value="{{sc.id}}"
                        [disabled]="checkForRepetedCategory(sc.id)">{{sc.name}} </ng-option>
                    </ng-select>
                  </div>
                  <div class="col-4">
                    <label [attr.for]="'category_data-quantity'+i">Quantity <span class="text-danger">*</span></label>
                    <input type="number" class="form-control rk-form-fontsize" [attr.id]="'category_data-quantity'+i"
                      formControlName="quantity">
                  </div>
                  <div class="col-4 text-center">
                    <i class="fa fa-minus nestedRemoveBtn addCursor"
                      (click)="smart_boq_Form.get('category_data').removeAt(i)"></i>
                  </div>
                </div>
              </fieldset>
              <a (click)="addNestedElem_SmartBOQ()" class="mb-2 px-3 addCursor" style="color: blue;"><i
                  class="fa fa-plus"> </i> Add Category</a>
            </div>
            <div class="col-md-12 text-right">
              <button class="rk-interalBtnColor addCursor" (click)="generateSmartQuotation(smart_boq_Form.value)"
                [disabled]="!smart_boq_Form.valid"
                [ngClass]="{'cursor-notallowed':!smart_boq_Form.valid, 'addCursor':smart_boq_Form.valid}">Generate
                BOQ</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Add Appliances Modal -->
<div class="modal fade" id="addApplianceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" style="overflow-y: scroll;" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog my-2 mx-2 modal-lg" role="document" id="applianceModalDialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-2"></div>
            <div class="col-10 pl-5">
              <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                <i class="fa fa-search"></i>
                <input class="form-control" type="text" placeholder="Type vendor SKU/ code/ specifications to search..."
                  #search (keyup)="0" [(ngModel)]="searchstr_appliance">
              </div>
              <button class="rk-interalBtnColor addCursor" (click)="getFilteredAppliances(current_page)">Search</button>
            </div>
          </div>
        </div>
        <button type="button" class="close addExtrastModalClose" data-dismiss="modal" aria-label="Close"
          (click)="closeApplianceModal()">
          <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-2">
            <div class="mx-2">
              <div class="mb-3">
                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make <span
                    class="pull-right">_</span></h6>
                <div class="aa-text" *ngFor="let data of makeforappliance_filter">
                  <input type="checkbox" name="make_appliance_filter" class="mr-1" value="{{data}}"
                    (change)="onCheckChangeFilter($event,'make','appliance')"
                    [checked]="make_appliance_filter.includes(data)">
                  <span class="sideOption" style="vertical-align:middle;">{{data}} </span>
                </div>
              </div>
              <!-- <div class="mb-3">
                                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Type <span class="pull-right">_</span></h6>
                                                <div class="aa-text" *ngFor="let data of makeforappliance_filter_types">
                                                    <input type="checkbox" name="make_appliance_filter_types" class="mr-1" value="{{data.id}}" 
                                                    (change)="onCheckChangeFilter($event,'types','appliance')" [checked]="make_appliance_filter_types.includes(data.id)">
                                                     <span class="sideOption">{{data.name}} </span>
                                                </div>
                                            </div> -->
              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By MRP<span
                  class="pull-right">-</span></h6>
              <ion-range-slider #priceSliderElement type="double" [min]="all_minimum_price" [max]="all_maximum_price"
                [from]="all_minimum_price" [from_min]="all_minimum_price" [from_max]="(all_maximum_price)-1"
                from_shadow="true" [to]="all_maximum_price" [to_min]="all_minimum_price+1" [to_max]="all_maximum_price"
                to_shadow="true" grid="false" prefix="MRP: " postfix=" INR" decorate_both="false"
                (onUpdate)="updateSlider('price',advancedSlider, $event)"
                (onChange)="updateSlider('price', advancedSlider, $event)">
              </ion-range-slider>
              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Arrivae Select<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" (change)="onCheckChangeFilter($event,'arrivaeSelect','')" class="mr-1"
                  [checked]="type_arrivae_select" /><span class="sideOption">Arrivae Select</span>
              </div>
              <button class="rk-interalBtnColor mt-3 addCursor" (click)="getFilteredAppliances(current_page);">Apply
                Filters</button>
            </div>
          </div>
          <div class="col-sm-10 bgColor">
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row" *ngIf="appliancelist_arr && appliancelist_arr.length>0; else no_product3">
                  <div class="col-sm-3"
                    *ngFor="let appliance of appliancelist_arr | paginate: {id:'appliancelist_arrPagination', itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  }">
                    <!-- This is appliance -->
                    <div class="card card-chng mb-5 py-2" style="padding-top:0 !important">
                      <div *ngIf="appliance.arrivae_select"
                        style="background-color: #8C031F;z-index:2;position:absolute;display: block; color: white;width: 30%;border-radius:10%;text-align:center">
                        <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                      <img class="card-img-top aspect-ratio-appliance-img addCursor" src="{{appliance.appliance_image}}"
                        *ngIf="appliance.appliance_image" onerror="this.src='./assets/img/no_image.svg';"
                        alt="Missing Image" height="143px" (click)="zoomImg($event.target,'#addApplianceModal')">
                      <div class="card-body" style="min-height: 14rem;">
                        <h6 class="card-title textColor1 rk-textColor capitalize">{{appliance.code}}</h6>
                        <p class="card-text textColor2 capitalize">Description : {{appliance.name}}</p>
                        <p class="card-text textColor2 capitalize">Vendor SKU : {{appliance.vendor_sku}}</p>
                        <p class="card-text textColor2 capitalize">Make : {{appliance.make}}</p>
                        <p class="card-text textColor2 capitalize">Specification : {{appliance.spec}}</p>
                        <p class="textColor2 capitalize">MRP : &#8377; {{appliance.mrp}}</p>
                      </div>
                      <div class="card-footer text-center">
                        <button class="rk-interalBtnColor addCursor d-inline" (click)="setAppliance(appliance); 
                                                            closeApplianceModal();">Select</button>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #no_product3>No Appliance available</ng-template>
              </div>
            </div>
            <div class="row" *ngIf="appliancelist_arr && appliancelist_arr.length >0">
              <div class="col-12 text-center">
                <pagination-controls id="appliancelist_arrPagination" autoHide="true"
                  (pageChange)="current_page = getFilteredAppliances($event)">
                </pagination-controls>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Add handle modal-->
<div class="modal fade" id="addhandleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" style="overflow-y: scroll;" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog my-2 mx-2" role="document">
    <div class="modal-content" id="allhandleRow">
      <div class="modal-header">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-2"></div>
            <div class="col-10 pl-5">
              <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                <i class="fa fa-search"></i>
                <input class="form-control" type="text"
                  placeholder="Type vendor SKU/ code/ specifications  to search..." #search (keyup)="0"
                  [(ngModel)]="searchstr_handle">
              </div>
              <button class="rk-interalBtnColor addCursor" (click)="getFilteredHandles(1)">Search</button>
            </div>
          </div>
        </div>
        <button type="button" class="close addExtrastModalClose" data-dismiss="modal" aria-label="Close"
          (click)="closeHandleModal(handleModal_param_obj.category)">
          <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-2">
            <div class="mx-2">
              <div class="mb-3">
                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make <span
                    class="pull-right">_</span></h6>
                <div class="aa-text mb-1" *ngFor="let data of makeforhandles_filter">
                  <input type="checkbox" name="make_handle_filter" class="mr-2" value="{{data}}"
                    (change)="onCheckChangeFilter($event,'make','handle')"> <span class="sideOption">{{data}} </span>
                </div>
              </div>
              <div class="mb-3">
                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Type <span
                    class="pull-right">_</span></h6>
                <!-- <div class="aa-text mb-1" *ngFor="let data of makeforhandles_filter">
                    <input type="checkbox" name="make_handle_filter" class="mr-2" value="{{data}}" (change)="onCheckChangeFilter($event,'make','handle')" > <span class="sideOption">{{data}} </span>
                </div> -->
                <div class="aa-text mb-1">
                  <input type="checkbox" id="type_handle_filter_normal_view" class="mr-2" value="normal"
                    (change)="onCheckChangeFilter($event,'type','handle')"> <span class="sideOption">Normal </span>
                </div>
                <div class="aa-text mb-1">
                  <input type="checkbox" id="type_handle_filter_profile_view" class="mr-2" value="profile"
                    (change)="onCheckChangeFilter($event,'type','handle')"> <span class="sideOption">Profile </span>
                </div>
                <div class="aa-text mb-1">
                  <input type="checkbox" id="type_handle_filter_insert_view" class="mr-2" value="insert"
                    (change)="onCheckChangeFilter($event,'type','handle')"> <span class="sideOption">Insert </span>
                </div>
                <div class="aa-text mb-1">
                  <input type="checkbox" id="type_handle_filter_concealed_view" class="mr-2" value="concealed"
                    (change)="onCheckChangeFilter($event,'type','handle')"> <span class="sideOption">Concealed </span>
                </div>

              </div>
              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By MRP<span
                  class="pull-right">-</span></h6>
              <ion-range-slider #priceSliderElement type="double" [min]="all_minimum_price" [max]="all_maximum_price"
                [from]="all_minimum_price" [from_min]="all_minimum_price" [from_max]="(all_maximum_price)-1"
                from_shadow="true" [to]="all_maximum_price" [to_min]="all_minimum_price+1" [to_max]="all_maximum_price"
                to_shadow="true" grid="false" prefix="MRP: " postfix=" INR" decorate_both="false"
                (onUpdate)="updateSlider('price',advancedSlider, $event)"
                (onChange)="updateSlider('price', advancedSlider, $event)">
              </ion-range-slider>

              <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Arrivae Select<span
                  class="pull-right">-</span></h6>
              <div class="aa-text">
                <input type="checkbox" (change)="onCheckChangeFilter($event,'arrivaeSelect','')" class="mr-1"
                  [value]="type_arrivae_select" [checked]="type_arrivae_select" /><span class="sideOption">Arrivae
                  Select</span>
              </div>
              <button class="rk-interalBtnColor mt-3 addCursor" (click)="getFilteredHandles(current_page);">Apply
                Filters</button>
            </div>
          </div>
          <div class="col-sm-10 bgColor">
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row" *ngIf="handlelist_arr && handlelist_arr.length>0; else no_product2">
                  <div class="col-sm-3"
                    *ngFor="let handle of handlelist_arr | paginate: {id:'handlelist_arrPagination', itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  }">
                    <div class="card card-chng mb-5 py-2" style="padding-top:0%!important">
                      <div *ngIf="handle.arrivae_select"
                        style="background-color: #8C031F;z-index:2;position:absolute;display: block; color: white;width: 30%;border-radius:10%;text-align:center">
                        <img style='width:20px;height:20px;' src="/assets/img/Select_logo.png">Select</div>
                      <img class="card-img-top addCursor" src="{{handle.handle_image}}" *ngIf="handle.handle_image"
                        onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" height="143px"
                        (click)="zoomImg($event.target,'#addhandleModal')">
                      <div class="card-body" style="min-height: 14rem;">
                        <h6 class="card-title textColor1 rk-textColor capitalize">{{handle.code}}</h6>
                        <p class="card-text textColor2 capitalize">Description : {{handle.name}}</p>
                        <p class="card-text textColor2 capitalize">Vendor SKU : {{handle.vendor_sku}}</p>
                        <p class="card-text textColor2 capitalize">Make : {{handle.make}}</p>
                        <p class="card-text textColor2 capitalize">Specification : {{handle.spec}}</p>
                        <p class="textColor2 capitalize">MRP : &#8377; {{handle.mrp}}</p>
                      </div>
                      <div class="card-footer text-center">
                        <button class="rk-interalBtnColor addCursor d-inline"
                          (click)="setImage(handle,handleModal_param_obj.handletype,handleModal_param_obj.category); closeHandleModal(handleModal_param_obj.category);">Select</button>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #no_product2>No Handle available</ng-template>
              </div>
            </div>
            <div class="row" *ngIf="handlelist_arr && handlelist_arr.length > 0">
              <div class="col-12 text-center">
                <pagination-controls id="handlelist_arrPagination" autoHide="true"
                  (pageChange)="current_page = getFilteredHandles($event)">
                </pagination-controls>
              </div>
            </div>
            <div class="row" *ngIf="handlelist_arr && handlelist_arr.length == 0">
              <div class="col-md-12 not-found text-center">
                <div class="boq-img">
                  <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
                </div>
                <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="fabricModalLabel" aria-hidden="true"
  data-keyboard="false" data-backdrop="static" id="fabricModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header text-right row">
        <button type="button" class="btn close col-12 text-right px-3 py-0" data-dismiss="modal" aria-label="Close"
          (click)="normalImg();resetVariations()">
          &times;
        </button>
      </div>
      <div class="modal-body text-center" id="imagecontainer">
        <div class="row" *ngIf="this.master_options.length > 0">
          <div class="col-sm-4">
            <label>Master option : </label>
            <select class="form-control" (change)="fetchSubOption($event)">
              <option>Select Master Option</option>
              <option *ngFor="let mo of this.master_options" value="{{mo.id}}">{{mo.name}}</option>
            </select>
          </div>
          <div class="col-sm-4">
            <label>Master suboption : </label>
            <select class="form-control" (change)="fetchModalCatalogueOption($event)">
              <option>Select Master Suboption</option>
              <option *ngFor="let mso of this.sub_options" value="{{mso.id}}">{{mso.name}}</option>
            </select>
          </div>
          <div class="col-sm-4">
            <label>Catalogue option : </label>
            <select class="form-control" (change)="fetchModalVariation($event)">
              <option>Select Master Option</option>
              <option *ngFor="let co of this.catalogue_options" value="{{co.id}}">{{co.name}}</option>
            </select>
          </div>
          <div class="col-sm-12 mt-4">
            <div class="variation-img-container variation-img-container-{{variation.id}}"
              *ngFor="let variation of variations" style="overflow: hidden;">
              <img src="{{variation.attributes.thumbnail}}" title="{{variation.attributes.name}}" class="variation-img"
                (click)="selectVariation(variation.attributes.id)">
            </div>
          </div>
        </div>

        <div class="row" *ngIf="this.master_options.length == undefined">
          <p class="lead" style="margin: auto;"> No Fabrics Available</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="zoomer-container">
  <img src="{{this.activatedZoomerImg}}">
</div>








<!--Custom Furniture Layout Modal-->
<div class="modal fade" id="CFlayoutlistmodal" tabindex="-1" role="dialog" aria-labelledby="layoutlistmodalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="layoutlistmodalLabel">List of Layouts</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeImportLayoutModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="row mx-0">
          <div class="col-md-12" *ngIf="custom_furniture_list &&  custom_furniture_list.length==0">No Layout</div>
          <div class="col-md-12" *ngIf="custom_furniture_list &&  custom_furniture_list.length>0">
            <collapsible-table [type]="'accordion'" bordered class="table mt-3" style="outline: none;">
              <thead class="thead-dark">
                <collapsible-table-row>
                  <th scope="col" class="firstTh">#</th>
                  <th scope="col"> Name</th>
                  <th scope="col">Created By</th>
                  <th class="minWidthForTd">Date</th>
                  <th scope="col" class="">Remarks</th>
                  <th scope="lastTh" class="lastTh"></th>
                </collapsible-table-row>
              </thead>
              <tbody style="background: white">
                <ng-container
                  *ngFor="let data of custom_furniture_list | paginate: {id:'layoutPagination', itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index;"
                  [attr.data-index]="i">
                  <collapsible-table-row [detail]="detail1" (click)="getCFLayoutDetail(data.id)">
                    <td style="min-width: 1rem;">{{i+1}}</td>
                    <td class="capitalize"> {{data.name}}</td>
                    <td>{{data.created_by.name}} - {{data.created_by.email}}</td>
                    <td class="capitalize">{{data.created_at | date:'dd MMM, y , h:mm a'}}</td>
                    <td class="capitalize">{{data.remark}}</td>
                    <td><button class="rk-interalBtnColor addCursor"
                        (click)="importCFLayoutToSpace(data.id)">Select</button></td>
                  </collapsible-table-row>
                  <collapsible-table-row-detail style="box-shadow: none;" #detail1>
                    <div class="ml-3 mt-3" *ngIf="cflayoutDetail">
                      <!--Cabinet List-->
                      <div *ngIf="cflayoutDetail.shangpin_jobs_cabinet.length>0">
                        <p class="font-weight-bold">Cabinet List:</p>
                        <div class="tableDiv mt-3">
                          <table class="table">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th>ITEM</th>
                                <th>MODEL NUMBER</th>
                                <th>ACTUAL SIZE<br>(WxDxH)</th>
                                <th>COLOR</th>
                                <th>UNIT PRICE</th>
                                <th>QUANTITY</th>
                                <th>AMOUNT</th>
                                <th class="lastTh"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="let addedproduct of cflayoutDetail.shangpin_jobs_cabinet; let k7=index; ">
                                <tr>
                                  <td>{{k7+1}}</td>
                                  <td>{{addedproduct.cabinet_item}}</td>
                                  <td>{{addedproduct.cabinet_model_no}}</td>
                                  <td>{{addedproduct.cabinet_overall_size}}</td>

                                  <td>{{addedproduct.cabinet_color}}</td>

                                  <td>{{addedproduct.cabinet_price_factored | number: '.1-2'}}</td>
                                  <td>{{addedproduct.cabinet_quantity}}</td>
                                  <td>{{addedproduct.cabinet_amount_factored | number: '.1-2'}}</td>
                                  <td>
                                    <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}"
                                      data-toggle="dropdown" role="button" aria-haspopup="true"
                                      aria-expanded="false"></i>
                                    <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                      <a class="dropdown-item addCursor"
                                        (click)="removeCfProductToBoqs(addedproduct.id)">Delete</a>
                                    </div>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!--Door List-->
                      <div *ngIf="cflayoutDetail.shangpin_jobs_door.length>0">
                        <p class="font-weight-bold">Door List:</p>
                        <div class="tableDiv mt-3">
                          <table class="table">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th>STYLE CODE</th>
                                <th>OVERALL SIZE<br>(WxDxH)</th>
                                <th>QUANTITY</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="let addedproduct of cflayoutDetail.shangpin_jobs_door; let k7=index;">
                                <tr>
                                  <td>{{k7+1}}</td>
                                  <td>{{addedproduct.door_style_code}}</td>
                                  <td>{{addedproduct.door_overall_size}}</td>
                                  <td>{{addedproduct.door_quantity}}</td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!--Accessory List-->
                      <div *ngIf="cflayoutDetail.shangpin_jobs_accessory.length>0">
                        <p class="font-weight-bold">Accessory List:</p>
                        <div class="tableDiv mt-3">
                          <table class="table">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th>STYLE CODE</th>
                                <th>OVERALL SIZE<br>(WxDxH)</th>
                                <th>UNIT PRICE</th>
                                <th>QUANTITY</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="let addedproduct of cflayoutDetail.shangpin_jobs_accessory; let k7=index; ">
                                <tr>
                                  <td>{{k7+1}}</td>
                                  <td>
                                    <div *ngIf="addedproduct.accessory_code && !addedproduct.accessory_model_no">
                                      {{addedproduct.accessory_code}}</div>

                                    <div *ngIf="addedproduct.accessory_model_no">{{addedproduct.accessory_model_no}}
                                    </div>
                                  </td>
                                  <td>{{addedproduct.accessory_overall_size}}</td>
                                  <td>{{addedproduct.accessory_amount_factored | number: '.1-2'}}</td>
                                  <td>{{addedproduct.accessory_quantity}}</td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!--Sliding Door-->
                      <div class="" *ngIf="cflayoutDetail.shangpin_jobs_sliding_door.length>0">
                        <p class="font-weight-bold">Sliding Door:</p>
                        <div class="tableDiv mt-3 mb-2">
                          <table class="table">
                            <thead class="thead-dark">
                              <tr>
                                <th class="firstTh">#</th>
                                <th>ITEM</th>
                                <th>MODEL NUMBER</th>
                                <th>ACTUAL SIZE<br>(WxDxH)</th>
                                <th>COLOR</th>
                                <th>UNIT PRICE</th>
                                <th>QUANTITY</th>
                                <th>AMOUNT</th>
                                <th class="lastTh"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="let addedproduct of cflayoutDetail.shangpin_jobs_sliding_door; let k7=index;">
                                <tr>
                                  <td>{{k7+1}}</td>
                                  <td>{{addedproduct.door_item}}</td>
                                  <td>{{addedproduct.door_model_no}}</td>
                                  <td>{{addedproduct.door_overall_size}}</td>
                                  <td>{{addedproduct.Door_color}}</td>
                                  <td>{{addedproduct.door_price_factored | number: '.1-2'}}</td>
                                  <td>{{addedproduct.door_quantity}}</td>
                                  <td>{{addedproduct.door_amount_factored | number: '.1-2'}}</td>
                                  <td></td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!--Wardrobe List-->
                      <div class="" *ngIf="cflayoutDetail.shangpin_jobs_wardrobe.length>0">
                        <p class="font-weight-bold">Wardrobe List:</p>
                        <!-- <div class="tableDiv mt-3 mb-2">
                                  <ng-container *ngFor="let addedproduct of cflayoutDetail.shangpin_jobs_wardrobe; let k7=index;">
                                    <div class="d-flex mb-2 pl-2 slidingamountCard">
                                      <span>{{k7+1}}</span><span class="ml-2">Total Amount:{{addedproduct.amount_factored  | number: '.1-2'}}</span>
                                    </div>
                                  </ng-container>
                                </div> -->
                        <table class="table">
                          <thead class="thead-dark">
                            <tr>
                              <th class="firstTh">#</th>
                              <th>ITEM</th>
                              <th>MODEL NUMBER</th>
                              <th>ACTUAL SIZE<br>(WxDxH)</th>
                              <th>COLOR</th>
                              <th>UNIT PRICE</th>
                              <th>QUANTITY</th>
                              <th>AMOUNT</th>
                              <th class="lastTh"></th>
                            </tr>
                          </thead>
                          <ng-container
                            *ngFor="let addedproduct of cflayoutDetail.shangpin_jobs_wardrobe; let k7=index;">
                            <tr>
                              <td>{{k7+1}}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>{{addedproduct.wardrobe_amount_factored | number: '.1-2'}}</td>
                              <td></td>
                            </tr>
                          </ng-container>
                        </table>
                      </div>
                    </div>
                  </collapsible-table-row-detail>
                </ng-container>
              </tbody>
            </collapsible-table>
            <div class="text-center" *ngIf="layouts_list && layouts_list.length >0">
              <pagination-controls id="layoutPagination" autoHide="true"
                (pageChange)="current_page = getLayoutsList(importlayout_category,$event)"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!--To save layout of custom furniture-->
<div class="modal fade" id="saveCfLayoutModal" tabindex="-1" role="dialog" aria-labelledby="saveCfLayoutModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modalboxHeader mb-3">
        <h5 class="modal-title modalTitle" id="saveMkwLayoutModalLabel">Save As Layout</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="saveMkwLayoutForm.reset();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <form [formGroup]="saveMkwLayoutForm">
          <div class="row">
            <div class="col-md-6">
              <label>Name <span class="text-danger">*</span></label>
              <input type="text" name="" class="form-control" formControlName="name">
            </div>
            <div class="col-md-12 mt-3">
              <label>Remarks</label>
              <textarea class="form-control" rows="2" formControlName="remark"></textarea>
            </div>
            <div class="col-md-12 text-right">
              <button class="rk-interalBtnColor addCursor my-2" [disabled]="!saveMkwLayoutForm.valid"
                (click)="saveCustomFurniture(saveMkwLayoutForm.value)">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div id="labelList" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div style="padding-bottom:0;padding-top:0;justify-content:flex-end" class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div style="padding-top:0" class="modal-body">
        <table class="table">
          <thead>
            <tr>
              <th>Label Name <i class="fa fa-plus" (click)="openAddLabelForm()"
                  style="padding-left:2%;font-size:1rem;color:#8c0420"></i></th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="openAddLabel">
              <td><input [(ngModel)]="addLabelValue" placeholder="Name of the label to be added."
                  style="width:93%;display:inline" type="text" class="form-control"><i class="fa fa-check"
                  (click)="addLabel(addLabelValue,ownerableType,ownerableId)"
                  style="padding-left:1%;font-size:1rem;color:#8c0420"></i></td>
              <td></td>
              <td></td>
            </tr>
            <tr *ngFor="let label of this.labelList;let labelIndex=index">
              <td *ngIf="!editLabelShow[labelIndex]">{{label.label_name}}</td>
              <td *ngIf="editLabelShow[labelIndex]">
                <input [(ngModel)]="editLabelValue" placeholder={{label.label_name}} style="width:90%;display:inline"
                  type="text" class="form-control" id="usr">
                <i class="fa fa-check" (click)="editLabel(labelIndex,editLabelValue,label.id)"
                  style="padding-left:2%;font-size:1rem;color:#8c0420"></i>
              </td>
              <td><i class="fa fa-edit" (click)="editLabelSignal(labelIndex,label.label_name)"
                  style="font-size:1rem;color:#8c0420"></i></td>
              <td><i class="fa fa-trash-o" (click)="deleteLabel(labelIndex,label.id)"
                  style="font-size:1rem;color:#8c0420"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              </div> -->
    </div>

  </div>
</div>





<!-- The Services Packages Modal -->
<div class="modal" id="servicesPackages">
  <div class="modal-dialog modal-lg" style="max-width: 74%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title w-100 text-center">Service Package</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 text-center">
            <input class="ss-searchbox w-50" type="text" id="serachPackage" placeholder="Search Packages" />
            <button class="rk-interalBtnColor cursor-pointer" (click)="searchPackage()">Search</button>
          </div>

          <!-- Tab section -->
          <div class="col-sm-12 col-md-12 col-lg-12 d-flex mt-2">
            <div class="tabDataDiv mr-2" (click)="selectServicePackageTab('','All')"
              [ngClass]="{activeServiceTab: activeTab == 'All', unActiveServiceTab: activeTab != 'All'}">All</div>
            <ng-container *ngFor="let tab of categories">
              <div class="tabDataDiv mr-2" (click)="selectServicePackageTab(tab.id,tab.name)"
                [ngClass]="{activeServiceTab: activeTab == tab.name, unActiveServiceTab: activeTab != tab.name}">
                {{tab.name}}
              </div>
            </ng-container>
          </div>

          <!-- Card Section -->
          <div class="col-sm-12 col-md-12 col-lg-12" style="height: 31rem;overflow: scroll;">
            <div class="row pl-4 pr-4" *ngIf="servicePackages_cards.length > 0">
              <ng-container
                *ngFor="let card of servicePackages_cards | paginate: {id:'servicePackagesPagination', itemsPerPage: services_package_per_page, currentPage: services_package_current_page, totalItems: services_package_total_page}; let i = index">
                <div class="col-sm-12 col-md-6 col-lg-6 box-shadow servicecardSEction mt-3 pb-3 pt-3">
                  <p class="text-right" *ngIf="services_array_image_file[i] === 0 && card.image_urls.length > 0">
                    <a data-toggle="modal" class="text-dark cursor-pointer" data-target="#servicesPackagesImage"
                      href="#" (click)="getImages(card.image_urls)">
                      <i class="fa fa-arrows-alt"></i>
                    </a>
                  </p>

                  <p class="text-right" *ngIf="services_array_image_file[i] === 1 && card.image_urls.length > 0">
                    <a class="text-dark cursor-pointer" (click)="getServicesFiles(card.image_urls)">
                      <i class="fa fa-download"></i>
                    </a>
                  </p>
                  <div class="text-center">
                    <img class="" src={{card.image_urls[0].image}} alt="Forest"
                      *ngIf="services_array_image_file[i] === 0 && card.image_urls.length > 0" style="height: 9rem;" />
                  </div>
                  <img class="w-100" src="./assets/img/no_image.svg" alt="Forest"
                    *ngIf="services_array_image_file[i] === 1 && card.image_urls.length > 0" style="height: 9rem;" />
                  <img class="w-100" src="./assets/img/no_image.svg" alt="Forest" *ngIf="card.image_urls.length == 0"
                    style="height: 9rem;" />
                  <p class="mt-2"><span><strong>Category:</strong></span>{{card.service_package_category.name}}</p>
                  <p><span><strong>Name:</strong></span>{{card.name}}</p>
                  <p><span><strong>Cost:</strong></span>₹ {{card.rate | number:'1.0-0'}}</p>
                  <div class="d-flex"><span><strong>Description:</strong></span>
                    <p class="popService" (mouseenter)="openpopup($event)" title={{card.description}}>
                      {{card.description}}</p>
                  </div>
                  <div class="row">
                    <div class="col-7 col-md-7 col-lg-7 pt-2">
                      <span><strong>Qty ({{card.unit}})</strong></span>
                      <input type="number" id="servicePackageQtyIF-{{card.id}}"
                        class="w-50 ml-2 pl-2 servicePackagesInput" />
                    </div>

                    <div class="col-5 col-md-5 col-lg-5 text-right">
                      <button class="rk-interalBtnColor cursor-pointer"
                        (click)="addPackagetoBoq(card.id, card.name)">Add to
                        BOQ</button>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="col-md-12 text-center mt-3" *ngIf="servicePackages_cards && servicePackages_cards.length > 0">
                <pagination-controls id="servicePackagesPagination" autoHide="true"
                  (pageChange)="services_package_current_page = getServicePackages($event,'','','')">
                </pagination-controls>
              </div>
            </div>
            <div class="row pl-4 pr-4 mt-5" *ngIf="servicePackages_cards.length == 0">
              <p class="text-center w-100 font-weight-bold">No Packages Found</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



<div class="modal" id="servicesPackagesImage">
  <div class="modal-dialog" style="max-width: 74%;">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header justify-content-end">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="d-flex h-100 justify-content-center">
          <i class="fa fa-angle-left cursor-pointer mr-4" (click)="changeImage('minus')"
            style="font-size: 41px;margin-top: 16rem;" *ngIf="!show_arrow"></i>
          <img class="" [src]="image_firt" style="height: 39rem;" />
          <i class="fa fa-angle-right cursor-pointer ml-4" (click)="changeImage('plus')"
            style="font-size: 41px;margin-top: 16rem;" *ngIf="!show_arrow"></i>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/quotation/create-modular-quote/create-modular-quote.component.html